export default {
  // Quick-mode 5-question card texts (Epixora quick research)
  materialAnswer: {
    badge: 'Material answer',
    analyzedFiles: 'Analyzed: {files}',
    noRelevantContent: 'No relevant content found in the material for your question',
    partialCoverage: 'The material only partially answers your question; available data is limited',
    noneHint: 'Your question is not supported by the selected material. Try rephrasing, adding more files, or use "Generate topic briefing" / "Deep research" below to search external sources.',
    partialHint: 'The answer below is based only on uploaded material. Use the actions below for broader coverage.',
    fullHint: 'The answer below is based on uploaded material. You can still expand via topic briefing or deep research.',
    disclaimer: 'Answer is based only on selected materials; no external literature was searched.',
    saveToMap: 'Save to knowledge map',
    export: 'Export',
    exportMarkdown: 'Markdown',
    exportWord: 'Word',
    exportPdf: 'PDF',
    exportHtml: 'HTML',
    noExportContent: 'Nothing to export',
    exportSuccess: '{format} exported',
    exportFailed: 'Export failed. Please retry.',
    startBrief: 'Generate topic briefing',
    deepResearch: 'Deep research',
    deepResearchConfirmTitle: 'Confirm research topic',
    deepResearchConfirmTip: 'Please review and edit the topic below. After confirmation, deep research will start in Expert mode.',
    deepResearchOriginalQuestion: 'Your question:',
    deepResearchTopicLabel: 'Research topic',
    deepResearchTopicPlaceholder: 'Please enter a research topic',
    deepResearchConfirmContinue: 'Confirm and continue',
    deepResearchTopicRequired: 'Please confirm the research topic first',
    preparingContent: 'Uploaded files are still being parsed and prepared',
    preparingHint: 'Please ask again after parsing completes; answers will be based on file content.',
    filesParsing: 'Uploaded files are being parsed and prepared, please wait…',
    filesParseTimeout: 'Files are still being parsed. Please try again shortly.',
    parseFailedFiles: 'These files failed to parse: {files}. Please re-upload before asking.',
    parseFailedStatus: 'File parsing failed. Please re-upload or use an OCR-enabled PDF.',
    parseReadyStatus: 'Parsing completed. The material is ready; you can ask again.',
    uploadedMaterialFallback: 'Uploaded material',
    materialSnippetTitle: 'Uploaded material snippet #{id}',
    snippetInlineTag: 'Snippet {id}',
  },
  quickCard: {
    planCardTitle: 'Structured research questions (editable, keep at least 3)',
    questionPlanIntro: 'To focus on "{topic}", I prepared the following directions to answer your question.',
    planCardLocked: 'Research started',
    title: 'Prepared {count} research questions around "{topic}"',
    defaultTopic: 'this topic',
    summary: '{count} questions now (min {min}, max {max})',
    addQuestion: 'Add question',
    changePerspective: 'Try another angle',
    startResearch: 'Start research',
    editTitle: 'Edit',
    deleteTitle: 'Delete',
    questionPlaceholder: 'Enter a research question',
    emptyQuestion: 'Question cannot be empty',
    tooLong: 'A single question cannot exceed 200 characters',
    minQuestions: 'A brief needs at least {min} questions',
    maxQuestions: 'Keep at most {max} questions; remove unneeded ones first',
    saveEditingFirst: 'Please save the question being edited first',
    saveDraftFailed: 'Failed to auto-save the outline. Please try again later.',
    startBlockedByFailedFiles: '{count} file(s) failed to parse ({files}). Retry parsing or remove them before starting the brief.',
    startWithPendingFilesTitle: 'Files are still indexing',
    startWithPendingFilesConfirm: '{count} file(s) are still indexing. Continuing may produce an incomplete brief. Continue anyway?',
    startWithPendingFilesContinue: 'Continue',
    startWithPendingFilesCancel: 'Wait',
    deleteConfirmTitle: 'Delete confirmation',
    deleteConfirmMessage: 'Delete this research question?',
    deleteConfirmOk: 'Delete',
    defaultDimension: 'Custom question',
    intentConfirmHint: 'Would you like a quick brief for "{topic}"?',
    intentYes: 'Yes',
    intentNo: 'No',
    entitySuggestTypo: '「{original}」 was not found in the gene database. Did you mean 「{suggested}」{chinese}?',
    entitySuggestNotFound: '「{original}」 was not found in the gene/target database. Continuing may yield low-quality results.',
    entityAccept: 'Use suggestion',
    entityKeep: 'Keep original',
    protocolStartResearchWithTopic: 'Start research: {topic}',
    protocolRegenerateBriefWithTopic: 'Regenerate brief: {topic}',
  },
  expertCard: {
    boundaryTip: 'Would you like target research for {target}, or a holistic deep-dive for {focus}?',
    boundaryTarget: 'Target research',
    boundaryOverall: 'Holistic research',
    moduleIntro: 'Select modules to include in this research (around "{topic}"):',
    defaultTopic: 'this topic',
    addRoot: 'Add',
    addChild: 'Add sub-item',
    customModule: 'Custom module',
    customContent: 'Custom content',
    confirmModules: 'Start research',
    deselectAll: 'Deselect all',
    selectionCount: '{checked} / {total} selected',
    changePerspective: 'Try another angle',
    changePerspectiveText: 'Try another angle',
    outlineUnchanged: 'No outline changes were detected. Rephrase your request or edit the panel and try again.',
    revisionFailed: 'The outline revision did not meet the requirements. Adjust your instruction and try again.',
    minModules: 'Select at least one module',
    outlineIntro: 'Review or edit the report outline:',
    startResearch: 'Start research',
    reportStartUnavailable: 'Unable to start report generation. Please refresh and try again.',
    profileNotReady: 'Confirm the research type in chat (target survey or holistic research) before generating the report.',
  },
  common: {
    example: 'Example',
    semicolon: '; ',
    language: 'Language',
    chinese: '简体中文',
    english: 'English',
    switchTenant: 'Switch Tenant',
    ok: 'OK',
    cancel: 'Cancel',
    save: 'Save',
    done: 'Done',
    back: 'Back',
    refresh: 'Refresh',
    search: 'Search',
    clearFilters: 'Clear Filters',
    delete: 'Delete',
    loadMore: 'Load More',
    confirm: 'Confirm',
    close: 'Close',
    confirmTitle: 'Confirm',
    logoutConfirm: 'Are you sure you want to log out?',
    profile: 'Profile',
    account: 'Account',
    retry: 'Retry',
    please: 'Please',
    minuteShort: 'm',
    secondShort: 's',
    durationPrefix: 'Time used: ',
    loading: 'Loading...',
    loadingUserData: 'Loading user data...',
    preparing: 'Preparing, please wait...',
    logout: 'Logout',
    noPermission: 'No permission to access',
    unknownError: 'Unknown error',
    mermaidRenderFailed: 'Chart rendering failed',
    operationFailed: 'Operation failed',
    operationConfirm: 'Operation Confirm',
    unknown: 'Unknown',
    operation: 'Operation',
    edit: 'Edit',
    confirmDelete: 'Confirm Delete',
    confirmExecute: 'Confirm to execute this operation?',
    featureInDevelopment: 'Feature in development',
    contactSupport: "Please contact support: 400-123-4567 or email enterprise{'@'}example.com",
    balanceCheckFailed: 'Balance check failed, please try again later',
    feedback: 'Feedback',
    newChat: 'New Chat',
    knowledgeBase: 'Knowledge Base',
    manual: 'User Guide',
    copyright: 'Copyright © 2025 XtalPi Inc. ICP License No. 17120953-4',
    downloadStarted: 'Download started',
    downloadFailed: 'Download failed',
    browserNotSupportVideo: 'Your browser does not support video playback',
    browserNotSupportAudio: 'Your browser does not support audio playback',
    downloadFile: 'Download File',
    directDownload: 'Direct Download',
    loadingPreview: 'Loading preview...',
    previewFailed: 'Preview Failed',
    errorDetails: 'Error Details',
    openInNewWindow: 'Open in New Window',
    pages: 'pages',
    // Common rating texts
    veryPoor: 'Very Poor',
    poor: 'Poor',
    average: 'Average', 
    good: 'Good',
    excellent: 'Excellent',
    history: 'History',
    chooseFile: 'Select File',
    notificationCenter: 'Notification Center',
    warning: 'Warning',
    unnamedFile: 'Unnamed file',
    selectAll: 'Select All',
  },
  writeWizard: {
    outlineSelect: 'Outline',
    outlineSource: {
      upload: 'Upload outline',
      template: 'Use template',
      quick: 'Quick start'
    },
    outlineUploadBtn: 'Choose outline file',
    outlineUploadHint: 'Word, TXT, Markdown, PDF',
    outlineTemplatePlaceholder: 'Select template',
    outlineError: 'Please select or upload an outline',
    requirementsPlaceholder: 'You can describe instructions about:\n-Document length (word count, sections)\n-Writing style (e.g. rigorous, casual, academic)\n-How to use attached files\n-Phrases and content to avoid\n-Use case (e.g. work report, thesis defense)\nand more!',
    requirementsError: 'Please enter your writing requirements',
    userSummary: 'Writing requirements',
    outlineLabel: 'Outline',
    outlineDraftLabel: 'Outline content',
    outlineDraftTitle: 'Outline content',
    outlineDraftTemplateHint: 'Loaded from the template. You can keep editing.',
    outlineDraftUploadHint: 'TXT / Markdown files are read automatically. Add Word / PDF outlines manually.',
    outlineDraftQuickHint: 'Optional. Leave empty to let the system recommend a structure.',
    outlineDraftPlaceholder: 'Adjust the template outline here, such as section titles, hierarchy, and writing focus.',
    outlineDraftUploadPlaceholder: 'If the file content was not read automatically, paste or add the outline here.',
    outlineReviewTitle: 'Confirm writing outline',
    outlineReviewDescription: 'Review the section structure and writing focus. The document will be generated from this outline.',
    confirmOutlineAndGenerate: 'Confirm outline and generate',
    outlineFromUpload: 'From upload',
    outlineFromTemplate: 'From template',
    outlineFromQuick: 'Quick start (recommended structure)',
    modelPrefix: 'Model: '
  },
  composer: {
    clearAttachments: 'Clear',
    selectModel: 'Select Model',
    selectTemplate: 'Select template',
    clearTemplate: 'Clear template',
    templateLoading: 'Loading templates…',
    noTemplates: 'No templates available',
    templateDisabledWithFiles: 'Templates are unavailable while files are attached',
    withFilesPlaceholder: 'What would you like to learn from selected files?',
    quickTemplateReportPlaceholder: 'Enter a topic to generate a research report with the outline template',
    quickWithOutlinePlaceholder: 'Enter a research topic to apply the selected template',
    expertWithTemplatePlaceholder: 'Enter research topic (template: {name})',
    expertReportGeneratingHint: 'Your research report is being generated. Start a new conversation for other tasks.',
    expertReportReadyHint: 'Your "{name}" report has been generated.You can:\n- Ask questions about the report\n- Run hallucination detection (click the button in the preview area, or right-click selected text in the report)\n- Reconstruct content (copy or describe where you want to regenerate, and provide your requirements)\n- Edit the report',
    expertReportReadyTitle: 'Your "{name}" report has been generated. The report preview is on the right. You can:',
    expertReportReadyActionQa: 'Ask questions about the report',
    expertReportReadyActionHallucination: 'Hallucination detection',
    expertReportReadyActionHallucinationDesc: ' (click the button in the preview area, or right-click selected text in the report)',
    expertReportReadyActionEdit: 'Edit the report',
    expertReportAuditRejectedHint: 'Your "{name}" report was generated but did not pass content review, so preview and download are unavailable. See the report section below to adjust your request and regenerate, or request a manual review.',
    expertOutlineReadyHint: 'Edit the outline above and click "Start research" to open the balance confirmation.',
    expertModuleSelectionHint: 'Select modules above and click "Start research" to open the balance confirmation.',
    expertBoundaryHint: 'Choose the research scope above (target vs holistic).',
    writeReportGeneratingHint: 'Your document is being generated. Start a new conversation for other tasks.',
    reportGeneratingHint: 'Report generation is in progress. Start a new conversation for other tasks.',
    reportGeneratingBlocked: 'Report is generating. Input is disabled.',
    quickQuestionCardHint: 'Edit questions in the card above, then click "Start research".',
    modelsLoading: 'Loading models…',
    noModelsAvailable: 'No models available',
    aiDisclaimer: 'Content is AI-generated. Please verify carefully.'
  },
  quickTools: {
    title: 'Quick Tools',
    templateLibrary: {
      title: 'Research Template Library',
      subtitle: 'Manage your personal research templates for faster thematic research',
      searchPlaceholder: 'Search research templates',
      emptyDesc: 'No matching templates',
      modeBatch: 'Batch Research',
      modeExpert: 'Expert Mode',
      modeQuick: 'Quick Mode Templates',
      newQuickTemplate: 'New Quick Mode Template'
    },
    batchTemplates: 'Batch Templates',
    outlineTemplates: 'Outline Templates',
    batchDrawerTitle: 'Quick Tools · Batch Topic Research',
    batch: {
      newTemplate: 'New Batch Template',
      myTemplates: 'My Templates',
      noTemplates: 'No templates yet. Create a batch template.',
      loadTemplateFailed: 'Failed to load template',
      questionUnit: 'Q',
      questionCount: '{count} Q',
      usedCount: 'Used {count}×',
      edit: 'Edit',
      delete: 'Delete',
      historySection: 'Research History',
      searchHistory: 'Search history topics',
      noHistoryMatch: 'No matching history',
      noHistory: 'No research history yet',
      exampleCases: 'Examples · click to create a template',
      deleteHistory: 'Delete this history',
      managerTitle: 'Template Management',
      managerSubtitle: 'Manage batch research templates in Quick Tools',
      managerSubtitleMerged: 'Manage batch research and outline templates in Quick Tools',
      templateKindAll: 'All',
      templateKindBatch: 'Batch Templates',
      templateKindOutline: 'Outline Templates',
      sectionBatch: 'Batch Templates',
      sectionOutline: 'Outline Templates',
      newOutlineTemplate: 'New Outline Template',
      searchTemplateMerged: 'Search name, description, or research object',
      totalTemplatesMergedDetail: '{total} templates total (batch {batch} · outline {outline})',
      searchTemplate: 'Search template name or description',
      sort: 'Sort',
      sortByCreated: 'By created time',
      sortByName: 'By name',
      sortByRecent: 'By recent use',
      gridView: 'Grid view',
      listView: 'List view',
      totalTemplates: '{count} template(s) total',
      noMatchTemplates: 'No matching templates',
      recentUse: 'Last used: {time}',
      runResearch: 'Run Research',
      editTemplate: 'Edit Template',
      back: '← Back',
      emptySelectTitle: 'Choose a Research Template',
      emptySelect: 'Select a template first, or open template management',
      emptySelectPlaceholder: 'Select a research template',
      emptySelectAction: 'Start Research',
      templateManager: 'Template Management',
      noTopics: '(no topics)',
      noDescription: 'No description',
      noRecentUse: 'N/A',
      unsavedLeaveTitle: 'Unsaved Changes',
      unsavedLeaveMessage: 'You have unsaved changes. Leaving will discard them. Continue?',
      continueLeave: 'Leave anyway',
      stayOnPage: 'Stay on page',
      templateUpdated: 'Template updated',
      templateCreated: 'Template created',
      saveFailed: 'Save failed',
      sampleExists: 'A sample template with the same name already exists — opened for you',
      deleteTemplateConfirm: 'Delete template {name}? Historical runs are kept, but you cannot start new tasks from this template.',
      deleteConfirmTitle: 'Confirm Delete',
      deleted: 'Deleted',
      deleteFailed: 'Delete failed',
      loadHistoryFailed: 'Failed to load history',
      deleteHistoryConfirm: 'Delete this history record? Exported files and other reports are not affected.',
      historyDeleted: 'Deleted',
      exported: 'Exported {format}',
      exportFailed: 'Export failed',
      runnerHint: 'Enter research topics and click Start Research. The system runs clinical, patent, FDA, literature and web searches per question and returns structured comparable results.',
      runnerRunningHint: 'Research is running. Do not close the page or switch templates. Results will appear automatically when done.',
      topicsTitle: 'Research topics (up to 10)',
      topicPlaceholder: 'Enter a topic and press Enter, e.g. HER2',
      addTopic: '+ Add Topic',
      run: 'Run',
      topicsAdded: 'Added {count} / 10',
      chipHint: 'Click an example to add quickly',
      dataSourcesTitle: 'Data sources',
      dataSourcesHint: 'The system picks appropriate sources per question automatically',
      questionListTitle: 'Questions (from template: {name})',
      runSingleQuestion: 'Run this question only',
      runSummary: 'Will research <strong>{topics}</strong> topic(s) × <strong>{questions}</strong> question(s)',
      startResearch: 'Start research ({topics} topics × {questions} Q)',
      maxTopics: 'You can add up to 10 topics',
      needOneTopic: 'Please add at least one topic',
      runFailed: 'Run failed: invalid response',
      allQuestionsFailed: 'All questions failed. Check LLM config or network.',
      partialFailed: 'Partial failure: {success}/{total} succeeded',
      runComplete: 'Run complete ({label})',
      runFailedGeneric: 'Run failed',
      sourceClinical: 'Clinical trials',
      sourcePatent: 'Patents',
      sourceFda: 'FDA / regulatory',
      sourceLiterature: 'Literature (PubMed)',
      sourceWeb: 'Web search',
      resultAllSuccess: 'All succeeded',
      resultPartial: 'Partial success',
      resultFailed: 'Run failed',
      resultStats: '{total} Q / {success} succeeded / {seconds}s',
      dataSourcesLabel: 'Sources: {sources}',
      viewDetail: 'By topic',
      viewCompare: 'Compare questions',
      exportCsv: 'Export CSV',
      exportExcel: 'Export Excel',
      citationDetail: 'Citation details',
      citationDocument: 'Source document',
      citationQuote: 'Quoted sentence',
      citationSource: 'Source information',
      citationContext: 'Context',
      citationLinks: 'Related links',
      noCitationForSentence: 'No citations linked to this sentence. Review the conclusion and refine source requirements in later research.',
      noSnippet: '(no snippet)',
      noSourceContext: 'Unable to automatically retrieve source context. Open the related source below to view it on the original site.',
      sourcePrefix: 'Source: {source}',
      compareByQuestion: 'Compare {count} topics by question',
      colQuestion: 'Question',
      executeFailed: 'Failed',
      searchHits: '{count} hits',
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      colQuestionShort: 'Question',
      colAnswerDetail: 'Research details',
      unnamedQuestion: '(unnamed question)',
      retryHint: 'Retry this question later, or shorten the question details.',
      viewCitation: 'View citations',
      noCitation: 'No citations',
      expand: 'Expand',
      collapse: 'Collapse',
      copyAnswer: 'Copy answer',
      citationCount: 'Citations ({count})',
      noResults: 'No research results yet',
      noResultsDesc: 'Results appear here as “Question | Details” after the run completes.',
      nothingToCopy: 'Nothing to copy',
      copiedAnswer: 'Answer copied',
      copyFailed: 'Copy failed — select text manually',
      exampleTag: 'Example',
      statusRunning: 'Running',
      statusPartial: 'Partial success',
      statusFailed: 'Failed',
      researchComplete: 'Research complete',
      pollInterrupted: 'Polling interrupted — check history on the left',
      submittingTask: 'Submitting research task…',
      taskSubmitted: 'Task submitted ({label}), running in background',
      submitFailed: 'Submit failed: invalid response',
      submitFailedGeneric: 'Submit failed',
      topicsOverflow: '… {count} total',
      fullRunLabel: 'Full run',
      resultRunningBanner: 'Research is running in the background — you can switch pages or view partial results',
      resultProgress: 'Completed {completed} / {total} questions',
      resultElapsed: ' · Elapsed {seconds}s',
      rowStatusFailed: 'Failed',
      cancel: 'Back',
      citation: 'Citations',
      totalQuestions: '{count} Q total',
      sampleTag: 'Sample',
      sampleTemplateTag: 'Sample template',
      exampleCaseShort: 'Examples',
      listColName: 'Template name',
      listColSource: 'Source',
      listColDesc: 'Description',
      listColRecent: 'Last used',
      listColActions: 'Actions',
      sourceSample: 'System sample',
      sourcePersonal: 'Personal',
      sampleNotEditable: 'System sample templates cannot be edited. Run directly or create your own.',
      sampleNotDeletable: 'System sample templates cannot be deleted. Run directly or create your own.',
      editor: {
        guide: 'Create 3–5 research questions. The system generates a unified comparison table per topic. Click outside the table or save to normalize question order.',
        templateName: 'Template name',
        namePlaceholder: 'e.g. Target research snapshot',
        templateDesc: 'Template description',
        descPlaceholder: 'Briefly describe the template purpose (optional)',
        questionListTitle: 'Questions ({count} / 5, min 3)',
        addQuestion: 'Add question',
        colTitle: 'Question title',
        colTitleHint: '(≤50 chars, e.g. Pipeline & stages)',
        colDetail: 'Expected aspects',
        colDetailHint: '(≤250 chars; dimensions and fields)',
        titlePlaceholder: 'e.g. Pipeline & stages',
        detailPlaceholder: 'e.g. List global clinical-stage drugs with name, stage, company, indication, and milestones',
        deleteMinTip: 'Keep at least 3 questions',
        deleteQuestion: 'Delete this question',
        emptyQuestions: 'Add at least 3 questions',
        tableTip: 'Focus each question on one angle and specify expected fields such as drug name, stage, company, indication, and milestones.',
        saveTemplate: 'Save template',
        previewTitle: 'Batch research preview',
        previewSubtitle: 'After saving, multiple topics are compared side by side using the same question columns.',
        previewTopic: 'Research topic',
        questionFallback: 'Question {index}',
        previewCellText: 'Structured findings for {title} will appear here',
        nameRequired: 'Please enter a template name',
        minQuestions: 'Keep at least 3 questions',
        maxQuestions: 'You can add up to 5 questions',
        titleRequired: 'Question {index} title is required',
        detailRequired: 'Fill expected aspects for question {index}'
      },
      samples: [
        {
          name: 'Target research snapshot',
          description: 'Quick cross-topic scan for targets such as HER2, KRAS G12C, etc.',
          questions: [
            { title: 'Pipeline drugs & stages', detail: 'List global clinical-stage drugs for this target: name, highest phase, company, indications, and key milestones.' },
            { title: 'Mechanism & biology', detail: 'Summarize the target mechanism, related pathways, and biological rationale in major indications.' },
            { title: 'Competitive landscape', detail: 'Outline leading competitors, strengths/gaps, potential best-in-class opportunities, and differentiation paths.' }
          ]
        },
        {
          name: 'Technology direction comparison',
          description: 'Compare technology themes such as CAR-T in solid tumors',
          questions: [
            { title: 'Key technology routes', detail: 'Compare major technology routes, core mechanisms, use cases, and technical bottlenecks.' },
            { title: 'Representative programs', detail: 'List representative programs, developers, highest development stage, indications, and recent milestones.' },
            { title: 'Opportunities & risks', detail: 'Summarize translation opportunities, commercialization risks, regulatory challenges, and 2–3 year watch points.' }
          ]
        }
      ]
    },
    library: {
      title: 'Research Template Library',
      desc: 'Manage personal research templates to streamline topic research',
      descBatch: 'Manage batch-research templates to quickly reuse question sets for bulk tasks.',
      descExpert: 'Manage expert-mode templates to reuse structured outlines and research frameworks.',
      descQuick: 'Manage quick-mode templates to reuse high-frequency fast-research scenarios.',
      modeBatch: 'Batch Research',
      modeExpert: 'Expert Mode',
      modeQuick: 'Quick Mode',
      newBatchTemplate: 'New Batch Template',
      newExpertTemplate: 'New Expert Template',
      newQuickTemplate: 'New Quick Mode Template',
      scopeAll: 'All Templates',
      scopeMine: 'My Templates',
      scopeShared: 'Shared With Me',
      scopeFavorite: 'My Favorites',
      totalCount: '{count} templates',
      searchPlaceholder: 'Search by name or description',
      sortByCreated: 'Created time',
      sortByName: 'Name',
      sortByRecent: 'Recently used',
      emptyTitle: 'No matching templates',
      emptyDesc: 'Try a different mode, keyword, or create a new one',
      loadFailed: 'Failed to load templates',
      favoriteNotSupported: 'Favorites are not supported for batch templates'
    },
    card: {
      tagBatch: 'Batch Research',
      tagExpert: 'Expert Mode',
      tagQuick: 'Quick Mode',
      ownerOthers: 'Shared',
      lastUsed: 'Last used: {date}',
      lastUsedNever: 'Last used: never',
      usageCount: 'Used {count} times',
      btnUse: 'Use',
      btnEdit: 'Edit',
      btnDelete: 'Delete',
      btnPreview: 'Preview'
    },
    dialog: {
      useTitle: 'Use Template',
      useEntityLabel: 'Research Target',
      useEntityPlaceholder: 'Enter the research target, e.g. BRCA1',
      useEntityRequired: 'Please enter the research target',
      useAdditionalLabel: 'Additional Context (optional)',
      useAdditionalPlaceholder: 'Optional context for this research',
      useConfirm: 'Confirm',
      useCancel: 'Cancel',
      useSuccess: 'Template applied. Redirecting to research.',
      useFailed: 'Failed to use template',
      previewTitle: 'Template Preview',
      previewClose: 'Close',
      previewEmpty: 'No preview content for this template',
      deleteTitle: 'Delete Template',
      deleteMsg: 'Delete template "{name}"? This action cannot be undone.',
      deleteConfirm: 'Delete',
      deleteCancel: 'Cancel',
      deleteSuccess: 'Deleted',
      deleteFailed: 'Failed to delete'
    }
  },
  // Layout and menu related
  layout: {
    appTitle: 'epiXora Assistant',
    refreshMenu: 'Refresh Menu',
    enterAdminConsole: 'Admin Console',
    backToChat: 'Back to Chat',
    setAdmin: 'Set Admin',
    debugMenu: 'Debug Menu',
    adminDebug: 'Admin Debug',
    logoutConfirmTitle: 'Confirm',
    logoutConfirmMessage: 'Are you sure you want to logout?',
    logoutSuccess: 'Logged out successfully',
    getUserInfoFailed: 'Unable to get user info, please login again',
    menuRefreshed: 'Menu refreshed successfully',
    menuCacheCleared: 'Menu cache cleared, refreshing...',
    refreshFailed: 'Refresh failed, please login again',
    menuRefreshFailed: 'Failed to refresh menu, please login again',
    adminStatusSet: 'Admin status set',
    setAdminFailed: 'Failed to set admin status',
    menuDebugged: 'Menu status debugged'
  },
  menu: {
    loadFailed: 'Failed to load menu, please try again later',
    loadFailedWithMessage: 'Failed to load menu'
  },
  // Backend data internationalization mapping
  backend: {
    // Membership tier name mapping
    membershipTiers: {
      'Pro 专业版': 'Pro',
      'Pro专业版': 'Pro',
      'Enterprise 企业版': 'Enterprise',
      'Enterprise企业版': 'Enterprise',
      'Free': 'Free',
      'Internal 内部用户': 'Internal',
      'Plus 升级版': 'Plus',
      'Plus升级版': 'Plus'
    },
    // Balance source description mapping
    balanceSources: {
      '会员赠送': 'Membership Grant',
      '新用户注册赠送': 'New User Registration Gift',
      '邀请奖励': 'Invitation Reward',
      '充值': 'Recharge',
      '系统赠送': 'System Grant',
      '管理员发放': 'Admin Grant',
      '推广奖励': 'Promotion Reward'
    },
    // Transaction title mapping
    transactionTitles: {
      'target_chat消费': 'Target Chat Consumption',
      'quick_qa消费': 'Quick Mode Q&A Consumption',
      'quick_brief_generation消费': 'Quick Brief Generation Consumption',
      'expert_qa消费': 'Expert Mode Q&A Consumption',
      'expert_report_generation消费': 'Expert Report Generation Consumption',
      'writing_qa消费': 'Writing Mode Q&A Consumption',
      'writing_report_generation消费': 'Writing Report Generation Consumption',
      '报告生成消费': 'Report Generation Consumption',
      '会员开通': 'Membership Activation',
      '充值到账': 'Recharge Credited',
      '会员升级': 'Membership Upgrade',
      '系统退款': 'System Refund'
    },
    // Recharge type mapping
    rechargeTypes: {
      'X-Coin充值': 'X-Coin Recharge',
      '会员': 'Membership'
    },
    // Payment status mapping
    paymentStatus: {
      '已完成': 'Completed',
      '处理中': 'Pending',
      '失败': 'Failed'
    }
  },
  errors: {
    timeout: 'Request timed out, please try again later',
    chatTimeout: 'Chat service timeout. Your message was sent, processing may take longer',
    networkFailed: 'Network connection failed. Please check your network',
    networkFailedWithBackend: 'Network connection failed. Ensure backend service is running',
    serverSlow: 'Request timed out, server responded too slowly',
    unableConnect: 'Unable to connect to server. Check network and backend status',
    difyDisconnected: 'Backend AI service is temporarily unavailable; running in degraded mode',
    fileDownloadFailed: 'File download failed. Please try again later',
    fileDeleteFailed: 'File deletion failed. Please try again later',
    networkUnstable: 'Network is unstable. Please check your connection and retry',
    feishuIllegalRedirect: 'Feishu login failed: invalid redirect_uri. Please contact admin',
    feishuCodeInvalid: 'Feishu login failed: authorization code invalid or expired',
    loginExpired: 'Login expired, please sign in again',
    loginInvalid: 'Session invalid. Please sign in again to continue',
    forbidden: 'Access denied. Insufficient permissions',
    badRequest: 'Bad request',
    notFound: 'Resource not found',
    tooManyRequestsOrNoBalance: 'Too many requests or insufficient X-Coin. Please retry later',
    serverInternal: 'Internal server error',
    serviceUnavailable: 'Service temporarily unavailable, please try again later',
    fileDownloadEnFailed: 'This historical task does not support English report, the Chinese version is provided for you'
  },
  balance: {
    fetchFailed: 'Failed to fetch your balance. Please try again later',
    insufficientBrief: 'Insufficient balance! Current: {balance} X-Coin, Required: {required} X-Coin, Shortage: {shortage} X-Coin',
    insufficientOp: 'Insufficient balance to perform this action! Current: {balance} X-Coin, Required: {required} X-Coin, Shortage: {shortage} X-Coin',
    afterCriticalWarn: '⚠️ Balance will be critically low after this action. Proceed with caution!',
    afterLowWarn: '⚠️ Balance will be low after this action. Consider recharging.',
    current: 'Current balance',
    currentBalance: 'Current balance',
    currentBalanceLabel: 'Current Balance',
    estimatedCostLabel: 'Estimated Cost',
    afterBalanceLabel: 'Balance After Action',
    confirmTitle: 'Balance Confirmation',
    balanceDialogTitle: 'Balance Confirmation',
    confirmGeneration: 'Confirm generation',
    confirmGenerationPrompt: 'Confirm to generate analysis report?',
    insufficientChatMessage: 'Your X-Coin balance is insufficient. Please recharge before continuing the conversation.',
    insufficientChatMessageTemp: 'Your X-Coin balance is insufficient. Please recharge or upgrade your membership before continuing.',
    confirmExecute: 'Confirm',
    // New: Balance confirmation dialog texts
    insufficientTitle: 'Insufficient Balance',
    insufficientTip: 'Insufficient balance. Please recharge before continuing.',
    warningTitle: 'Balance May Be Insufficient',
    generationThresholdLabel: 'Minimum Required',
    warningThresholdLabel: 'Recommended Balance',
    shortageLabel: 'Shortage',
    upgradeMembershipTip: 'Upgrade membership for lower generation threshold and more benefits',
    rechargeTip: 'Please recharge to continue',
    zeroBalanceDesc: 'Your account balance is insufficient to continue. Please recharge and try again.',
    partialReportWarning: 'Your account balance may be insufficient to generate a complete report. We will deduct your balance to continue generating the report.',
    partialReportWarningSecondary: 'If the actual X-Coin consumption exceeds your account balance, you can preview part of the report content first, and view and download the full report after recharging.',
    partialReportTip: 'To ensure complete report generation, we recommend recharging first',
    rechargeRecommendation: 'Recharge to enjoy more services',
    becomeMember: 'Become a Member',
    confirmUpgrade: 'Confirm Upgrade',
    confirmContinue: 'Continue to Generate',
    rechargeNow: 'Recharge Now',
    goRecharge: 'Recharge',
    operations: {
      targetAnalysis: 'Run target analysis',
      reportGeneration: 'Generate analysis report',
      hallucinationDetection: 'Hallucination detection',
      chatMessage: 'Send chat message',
      audioTranscribe: 'Audio transcription',
      tts: 'Text-to-Speech',
      execute: 'Execute'
    },
    status: {
      critical: 'Balance is critically low! Current: {balance} X-Coin. Please recharge immediately',
      warning: 'Low balance! Current: {balance} X-Coin. Please recharge soon',
      low: 'Balance is a bit low. Current: {balance} X-Coin. Consider recharging',
      sufficient: 'Balance is sufficient. Current: {balance} X-Coin'
    },
    notifications: {
      titles: {
        exhausted: 'Account Balance Insufficient',
        critical: 'Account Balance Critically Low',
        warning: 'Account Balance Low',
        low: 'Account Balance Alert'
      },
      messages: {
        exhausted: 'Your account balance is insufficient (Remaining: ${remaining}). Please recharge promptly to continue using the service.',
        critical: 'Your account balance is critically low (Remaining: ${remaining}). We recommend recharging as soon as possible.',
        warning: 'Your account balance is low (Remaining: ${remaining}). Please consider recharging in time.',
        low: 'Your account balance (Remaining: ${remaining}) is below the warning threshold. Please monitor your balance changes.'
      }
    }
  },
  recharge: {
    title: 'Insufficient balance. Recharge required',
    reportProgress: 'Report generation progress',
    progressDesc: '{completedSteps}/{totalSteps} steps completed',
    costDetails: 'Cost details',
    consumed: 'Consumed',
    stillNeed: 'Still needed',
    tip: 'After recharging, report generation will continue and you can check progress anytime.',
    goRecharge: 'Recharge now'
  },
  command: {
    refreshed: 'Refreshed, {count} commands total',
    refreshFailed: 'Refresh failed',
    loadingCommands: 'Loading commands...',
    loadFailed: 'Load Failed',
    noCommands: 'No commands, click to add',
    labelRequired: 'Please enter command label',
    textRequired: 'Please enter command text',
    behaviorRequired: 'Please select command behavior',
    hotkeyConflict: 'Hotkey {hotkey} is already used by "{label}", please choose another',
    publicHelp: 'Public commands can be seen and used by other users'
  },
  // Intent clarify card (quick mode brief confirmation)
  intentClarify: {
    tip: 'Please confirm your research intent so I can generate a brief for you:',
    yes: 'Yes',
    no: 'No'
  },
      targetSimple: {
    backToList: 'Back to List',
    targetDetail: 'Target Detail',
    generating: 'Generating',
    generateReport: 'Generate Report',
    chatReport: 'Chat Report',
    downloading: 'Downloading...',
    downloadReport: 'Download Report',
    downloadFailed: 'Download failed: {status}',
    reportNotExist: 'Report file does not exist or download link cannot be generated',
    preparingDownload: 'Preparing download, please wait...',
    loadTargetFailed: 'Failed to load target info',
    confirmGenerate: 'Are you sure to generate report for target "{name}"?',
    confirmGenerateTitle: 'Confirm Generate',
    reportStarted: 'Report generation task started',
    reportStartFailed: 'Failed to start report generation'
  },
  notifDetail: {
    downloadResearchReport: 'Download Research Report (PDF)',
    clickToDownload: 'Click button to download the full research report',
    overspendDetails: 'Overspend Details',
    overspendAmount: 'Overspend Amount',
    actionMethod: 'Action Method',
    tempCredit: 'Temporary Credit',
    viewBalance: 'View Balance Details',
    rechargeNow: 'Recharge Now',
    markAsRead: 'Mark as Read',
    overspendReason: 'Overspend Reason',
    entityId: 'Related Entity ID',
    entityType: 'Related Entity Type',
    overspendThreshold: 'Overspend Threshold',
    preparingDownload: 'Preparing to download {type}...',
    downloadStarted: '{type} download started',
    noDownloadUrl: 'Download URL not available',
    downloadFailed: 'Download failed, please try again later',
    confirmDelete: 'Are you sure to delete this notification?',
    missingEntityInfo: 'Missing related entity info',
    noTargetPermission: 'No permission to access this target, it may be created by another user',
    targetNotExist: 'Target does not exist or has been deleted',
    cannotAccessTarget: 'Cannot access target details, please contact admin',
    unsupportedEntityType: 'Navigation to {type} type page is not supported yet',
    navigationFailed: 'Page navigation failed, please check your access permission',
    reportTypes: {
      pdf: 'PDF Report',
      markdown: 'Markdown File',
      metadata: 'Metadata File',
      details: 'Detailed Data'
    },
    types: {
      overspend: 'Overspend Alert',
      balanceLow: 'Low Balance',
      reportSuccess: 'Report Generated',
      reportFailed: 'Report Generation Failed',
      system: 'System Notification',
      security: 'Security Alert',
      notification: 'Notification'
    },
    actions: {
      allowNegative: 'Allow Negative Balance',
      creditExtension: 'Temporary Credit',
      setZero: 'Balance Zero Protection'
    }
  },
  chatDialog: {
    smartAssistant: 'Smart Assistant',
    inputPlaceholder: 'Enter your question...',
    send: 'Send',
    analyzing: 'Thank you for your question, I am analyzing the relevant information...'
  },
  cmdEditor: {
    editCommand: 'Edit Command',
    addCommand: 'Add Command',
    displayName: 'Display Name',
    namePlaceholder: 'e.g.: Confirm, Continue',
    replyContent: 'Reply Content',
    replyPlaceholder: 'Message content sent when button is clicked',
    category: 'Category',
    selectCategory: 'Select Category',
    icon: 'Icon',
    iconPlaceholder: 'Icon name (optional)',
    select: 'Select',
    color: 'Color',
    hotkey: 'Hotkey',
    hotkeyPlaceholder: 'e.g.: Ctrl+1, Alt+A (optional)',
    clear: 'Clear',
    hotkeyTip: 'Click the input box and press key combination to set hotkey',
    priority: 'Priority',
    priorityTip: 'Higher priority means more likely to be displayed in quick buttons area',
    update: 'Update',
    add: 'Add',
    nameRequired: 'Please enter display name',
    nameLengthLimit: 'Length should be 1-20 characters',
    replyRequired: 'Please enter reply content',
    replyLengthLimit: 'Length should be 1-200 characters',
    categoryRequired: 'Please select a category'
  },
  iconPicker: {
    title: 'Select Icon',
    searchPlaceholder: 'Search icons...',
    categories: {
      basic: 'Basic',
      communication: 'Communication',
      document: 'Document',
      interface: 'Interface',
      action: 'Action',
      business: 'Business',
      system: 'System',
      science: 'Science'
    }
  },
  chatPage: {
    unknownFileName: 'Unknown file name',
    uploadNoFileId: 'File ID not found in upload response',
    uploadSyncFailed: 'File "{name}" uploaded but failed to sync with Dify',
    uploadSuccess: 'File "{name}" successfully uploaded and bound to task "{target}"',
    uploadPartialSuccess: 'File "{name}" uploaded and bound to task "{target}" (Dify sync failed)',
    unknownSize: 'Unknown size',
    uploadFailed: 'Upload failed',
    cannotGetDownloadUrl: 'Cannot get download URL',
    downloadFileFailed: 'Failed to download file',
    modelSelect: 'Model Selection',
    notice: 'Notice',
    balanceLimitNotice: 'Due to balance limits, only a partial report may be generated. You can recharge to unlock full content after completion.',
    insufficientBalance: 'Insufficient balance',
    upgradeVipBenefit: 'Upgrade membership for lower generation thresholds and exclusive benefits',
    xcoinInsufficient: 'X-Coin balance insufficient',
    upgradeNow: 'Upgrade Now',
    laterTalk: 'Maybe Later',
    audioTranscribe: 'Audio Transcription',
    confirmTranscribe: 'Confirm transcription of this audio file?',
    speechServiceError: 'Speech recognition service error: {status}',
    speechInputPlaceholder: '[Please type what you just said]',
    reportQuotePrefix: '[Report Quote]',
    reportQuoteSuffix: 'Based on the above quoted content, ',
    reportContentSentToInput: 'Report content sent to input box, please add your question and send',
    reportQuestionPrefix: '📄 **Question based on report content:**',
    questionLabel: '**Question:**',
    processingError: 'Processing error',
    generatingAnswer: 'Generating answer...',
    referencesTitle: '📚 **References:**',
    referenceItem: 'Reference {n}',
    relevance: 'Relevance',
    references: '{n} references',
    reportQaFailed: 'Report Q&A failed, please check error details',
    noResponseError: '❌ No response received. Possible causes: 1) Request timeout 2) Server error 3) Network issue. Please check your connection and retry.',
    commandExecuted: 'Command executed: {label}',
    commandFilled: '"{label}" filled, please continue with specific content',
    outlineSaved: 'Outline template "{name}" saved! You can use it in the quick command panel',
    serverEmptyResponse: 'Server returned empty response',
    sendFailed: 'Failed to send message',
    sendFailedDetail: 'Failed to send message: {msg}',
    requestTimeout: 'Request timeout (waited 10 minutes). Complex queries like clinical trial searches may take longer, please retry later or contact admin',
    serverError: 'Server internal error, please retry later',
    tooManyRequests: 'Too many requests, please retry later',
    noReplyContent: 'Failed to get reply content',
    qaEvidenceHintEnough: 'Sufficient evidence',
    qaEvidenceHintSelectedOnly: 'Based only on selected content',
    qaEvidenceHintInsufficient: 'Insufficient evidence, recommend additional retrieval or review',
    quickBriefQualityGatePendingWithTotal: 'Quality gate: {failed}/{total} sections need review',
    quickBriefQualityGatePending: 'Quality gate: {failed} sections need review',
    quickBriefVerifierFail: 'Verifier failed: {count} issue(s)',
    quickBriefVerifierWarn: 'Verifier warning: {count} issue(s)',
    outlineDetectedSwitching: 'Outline for target "{name}" detected, auto-switching...',
    pendingConfirm: 'Pending Confirmation',
    outlineGeneratedConfirm: 'Outline for target "{name}" has been generated, please switch to view and confirm',
    reportGeneratingMsg: 'Preparing report generation. Title: {topic}, Keywords: {keywords}. AI-driven process includes literature, patent, clinical trial and web search data collection, agent-collaborative outline and chapter generation, and deep optimization. Estimated time: about 30–60 minutes.',
    reportStartMsg: 'Starting to generate [{name}] research analysis report. AI-driven process includes literature, patent, clinical trial and web search data collection, agent-collaborative outline and chapter generation, and deep optimization. Estimated time: about 30–60 minutes.',
    networkErrorDetail: '❌ Network connection failed: {msg}\n\nPlease check network and ensure backend service is running.',
    timeoutErrorDetail: '❌ Request timeout: {msg}\n\nPlease retry later or contact admin.',
    qaErrorDetail: '❌ Q&A failed: {msg}\n\nPlease retry later.',
    qaSteps: {
      contentAnalysis: 'Analyzing selected content',
      questionUnderstanding: 'Understanding user question',
      knowledgeRetrieval: 'Knowledge retrieval enhancement',
      reasoning: 'Intelligent reasoning analysis',
      answerGeneration: 'Generating answer',
      llmGeneration: 'AI model inference',
      finalAnswer: 'Answer completed',
      onlineSearch: 'Searching latest data online',
      contextPrep: 'Preparing context',
      reasoningContext: 'Intelligent reasoning analysis',
      cacheHit: '⚡ Cache hit'
    }
  },
  reportDetail: {
    sampleReport: 'Sample Report (Free)',
    expandCollapseAll: 'Expand/Collapse All',
    copyOutline: 'Copy Outline',
    quickNav: 'Quick Navigation',
    expandFullOutline: 'Expand Full Outline',
    regenFailed: 'Failed to regenerate report',
    fileOpenedInNewWindow: '{type} opened in new window, please use browser save to download',
    outlineCopied: 'Outline copied to clipboard',
    copyFailed: 'Copy failed, please select and copy manually'
  },
  cmdSettings: {
    title: 'Quick Command Settings',
    basicSettings: 'Basic Settings',
    customCommands: 'Custom Commands',
    allCommands: 'All Commands',
    usageStats: 'Usage Statistics',
    enableQuickCmd: 'Enable Quick Commands',
    enableTip: 'Quick reply buttons will be hidden when disabled',
    showCategories: 'Show Categories',
    categoriesTip: 'Organize commands by category',
    showHotkeys: 'Show Hotkeys',
    hotkeysTip: 'Show hotkeys in button tooltips',
    smartSuggestion: 'Smart Suggestions',
    smartTip: 'Recommend commands based on conversation context',
    maxButtons: 'Max Quick Buttons',
    maxButtonsTip: 'Number of quick buttons displayed in main area',
    recentCount: 'Recent Commands Count',
    recentCountTip: 'Number of recently used commands to save',
    suggestThreshold: 'Suggestion Threshold',
    suggestThresholdTip: 'Number of conversation rounds before smart suggestions',
    addCommand: 'Add Command',
    import: 'Import',
    export: 'Export',
    searchPlaceholder: 'Search commands...',
    custom: 'Custom',
    priority: 'Priority',
    recentUsed: 'Recently Used',
    favoriteCommands: 'Favorite Commands',
    commandDistribution: 'Command Distribution',
    resetDefault: 'Reset Default',
    saveSettings: 'Save Settings',
    settingsSaved: 'Settings saved',
    confirmReset: 'Are you sure you want to reset all settings? This will clear custom commands and preferences.',
    confirmResetTitle: 'Confirm Reset',
    confirmDeleteCmd: 'Are you sure you want to delete this custom command?',
    commandDeleted: 'Command deleted',
    commandUpdated: 'Command updated',
    commandAdded: 'Command added',
    commandAlreadyAdded: 'This command has already been added',
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} hr ago',
    daysAgo: '{n} days ago',
    configExported: 'Configuration exported',
    exportFailed: 'Export failed',
    importFailed: 'Import failed, invalid file format',
    unfavorite: 'Remove from favorites',
    favorite: 'Add to favorites',
    selectCmdType: 'Select command type',
    loadCmdTypeFailed: 'Failed to load command types'
  },
  targetAdmin: {
    confirmGenerate: 'Confirm Generate',
    forceRestartMsg: 'Force stop current analysis and restart task "{name}", executing as task creator "{creator}"',
    forceRegenTitle: 'Force Regenerate Report',
    forceRequeueMsg: 'Force requeue task "{name}", executing as task creator "{creator}"',
    regenOverwriteMsg: 'Regenerate report for task "{name}", original report will be overwritten, executing as creator "{creator}"',
    regenTitle: 'Regenerate Report',
    resumeGenMsg: 'Resume generating report for task "{name}", executing as creator "{creator}"',
    resumeGenTitle: 'Resume Report Generation',
    generateMsg: 'Generate report for task "{name}", executing as creator "{creator}"',
    resumeGenSimpleMsg: 'Resume generating report for task "{name}"',
    resumeGenCheckpointPartialMsg: 'Resume report for "{name}" reusing collected research data ({completed}/{total} research modules completed), executing as creator "{creator}"',
    resumeGenCheckpointPartialSimpleMsg: 'Resume will reuse collected research data ({completed}/{total} research modules completed)',
    resumeGenCheckpointSynthesisMsg: 'Resume report for "{name}" skipping completed data collection and continuing to organize the report, executing as creator "{creator}"',
    resumeGenCheckpointSynthesisSimpleMsg: 'Resume will skip completed data collection and continue organizing the report',
    regenSimpleMsg: 'Regenerate report for task "{name}"',
    generateSimpleMsg: 'Generate report for task "{name}"',
    forceRestartSuccess: 'Force regeneration started, original analysis stopped, will execute as creator "{creator}"',
    forceRequeueSuccess: 'Force regeneration started, task requeued, will execute as creator "{creator}"',
    regenOverwriteSuccess: 'Regeneration started, original report will be overwritten, executing as creator "{creator}"',
    resumeGenSuccess: 'Resume generation started, will continue from failure point, executing as creator "{creator}"',
    resumeGenSuccessLocalSurvey: 'Resume started; will continue target research with the same parameters, executing as creator "{creator}"',
    resumeGenSuccessCheckpoint: 'Resume started; reusing saved research progress.',
    resumeGenSuccessCheckpointAdmin: 'Resume started; reusing saved research progress, executing as creator "{creator}"',
    resumeGenHermesWritingSimpleMsg: 'Resume report for "{name}" and continue the unfinished report writing',
    resumeGenHermesWritingMsg: 'Resume report for "{name}" and continue the unfinished report writing, executing as creator "{creator}"',
    resumeGenSuccessHermesWriting: 'Resume started; continuing the unfinished report writing task.',
    resumeGenSuccessHermesWritingAdmin: 'Resume started; continuing the unfinished report writing task, executing as creator "{creator}"',
    adminGenSuccess: 'Admin-initiated report generation started, executing as creator "{creator}"',
    preparingDownload: 'Preparing download, please wait...',
    pdfOpenedInNewWindow: 'PDF opened in new window, please use browser save function to download',
    downloadStarted: 'Download started',
    downloadFailed: 'Download failed: {msg}',
    downloadFailedStatus: 'Download failed: {status}',
    audit: 'Audit',
    auditTask: 'Audit Task',
    fileTypes: {
      pdf: 'PDF Report',
      image: 'Image File',
      json: 'JSON Data',
      txt: 'Text File',
      docx: 'Word Document',
      xlsx: 'Excel Spreadsheet'
    },
    reportTypes: {
      pdf: 'Chinese Report',
      en_pdf: 'English Report',
      markdown: 'Markdown Document',
      metadata: 'Metadata Table'
    },
    resources: {
      processingTime: 'Processing Time',
      apiCalls: 'API Calls',
      dataSize: 'Data Size',
      memoryUsage: 'Memory Usage',
      cpuUsage: 'CPU Usage'
    }
  },
  register: {
    title: 'User Registration',
    titleWithInvite: 'User Registration - Invite Code: {code}',
    requestTimeout: 'Registration request timeout, please check network and retry',
    serverError: 'Server error, please retry later',
    inviteVerifyError: 'Invite code verification error, please retry later'
  },
      auth: {
    login: {
      title: 'Welcome to epiXora',
      username: 'Username or Phone',
      usernamePlaceholder: 'Enter phone number or username',
      password: 'Password',
      passwordPlaceholder: 'Enter account password',
      captcha: 'Verification Code',
      captchaPlaceholder: 'Enter verification code',
      captchaClickToLoad: 'Click to load',
      captchaRefreshHint: 'Click image to refresh verification code',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      login: 'Log In',
      loggingIn: 'Logging in...',
      registerTip: "Don't have an account?",
      registerNow: 'Register now',
      dividerOr: 'or',
      feishuLogin: 'Login with Feishu',
      success: 'Logged in successfully',
      feishuLoginSuccess: 'Feishu login successful',
      requestTimeout: 'Request timeout ({timeout}ms)',
      defaultTenant: 'Default Tenant',
      testTenant: 'Test Tenant',
      loginFailedMsg: 'Login failed: {msg}',
      feishuLoginProcessing: 'Processing Feishu login...',
      feishuLoginFailed: 'Feishu authorization failed, please try manual login',
      feishuCallbackFailed: 'Failed to process Feishu login callback',
      feishuAutoLoginFailed: 'Feishu auto-login failed, please retry',
      feishuAutoLoginFailedManual: 'Feishu auto-login failed, please login manually',
      feishuAccountLoginSuccess: 'Feishu account login successful',
      feishuUnavailable: 'Feishu login may be unavailable: {msg}',
      feishuMultiTenantTip: 'You have access to multiple tenants. Please select a tenant and click the "Feishu Login" button.',
      configError: 'Configuration issue detected, please contact admin',
      loginFailedRetry: 'Login failed, please retry',
      noTenantPermission: 'You do not have permission to access tenant: {name}',
      networkFailedLogin: 'Network connection failed, please check your network or server status',
      setTokenFailed: 'Failed to set token',
      feishuAuthProcessing: 'Feishu authorization processing...',
      responseFormatError: 'Response data format is incorrect',
      responseTypeError: 'Response type is incorrect: {type}',
      feishuAuthFailed: 'Feishu authorization failed, try manual login',
      feishuLoginFailedMsg: 'Login failed: {msg}',
      feishuErrors: {
        missing_code: 'Missing authorization code',
        missing_state: 'Missing state parameter',
        invalid_state: 'Invalid state parameter',
        expired_state: 'Authorization expired, please login again',
        invalid_tenant: 'Invalid tenant',
        tenant_inactive: 'Tenant is disabled',
        missing_tenant: 'Missing tenant information',
        token_failed: 'Failed to get Feishu token',
        missing_token: 'Missing access token',
        user_info_failed: 'Failed to get user info',
        incomplete_user_info: 'Incomplete user info',
        fetch_user_failed: 'Failed to fetch user info',
        user_creation_failed: 'Failed to create user',
        user_inactive: 'User has been deactivated',
        user_deleted: 'User has been deleted',
        tenant_unauthorized: 'No permission to access selected tenant',
        unknown: 'Unknown error'
      },
      preparingFeishuLogin: 'Preparing Feishu login...',
      feishuAuthUrlFailed: 'Failed to get Feishu authorization URL: invalid response.',
      redirectingToFeishu: 'Redirecting to Feishu authorization page...',
      feishuLoginDefaultError: 'Feishu login failed, please retry or contact admin.',
      feishuLoginNetworkError: 'Feishu login processing failed, please retry.',
      backendCheckFailed: 'Backend service check failed, please try again later or contact admin.',
      backendCheckFailedBrief: 'Backend service check failed.',
      feishuAuthUrlFailedDetail: 'Failed to get Feishu authorization URL, please check backend config or contact admin.',
      feishuAuthUrlFailedBrief: 'Failed to get Feishu authorization URL.',
      serviceRequestFailed: 'Service request failed ({status})',
      loginRequestFailed: 'Login request failed ({status})',
      networkFailedFeishu: 'Network connection failed, please check your network settings.',
      networkFailedBrief: 'Network connection failed.',
      unknownLoginError: 'Unknown error occurred during login.',
      internalLoginError: 'Internal error during login processing.',
      feishuConfigError: 'Feishu configuration error: {msg}',
      feishuAccountLogging: 'Logging in with Feishu account...',
      feishuAutoLoginFailedRetry: 'Feishu auto login failed, trying manual login',
      feishuAutoLoginFailedManualLogin: 'Feishu auto login failed, please login manually',
      feishuEnvDetected: 'Feishu environment detected, attempting auto login...',
      useFeishuLogin: 'Please login with Feishu account',
      loginInfoParseFailed: 'Failed to parse login info',
      loginFailed: 'Login failed',
      loginTip: 'Login Notice',
      multiFailMessage: 'Multiple login failures. Please check:\n1. Is the username/password correct?\n2. Is the network connected?\n3. Is the server online?\n\nIf the issue persists, please contact the system administrator.',
      accountRestricted: 'Account status restricted',
      accountRestrictedDetail: 'Your account is currently unavailable. Please contact the system administrator.',
      tenantRestricted: 'Tenant access restricted',
      tenantRestrictedDetail: 'Please try selecting another tenant or contact the administrator to resolve permission issues.',
      network: {
        checking: 'Checking server connection...',
        cannotConnect: 'Unable to connect to server. Please check network or contact admin',
        detectConfigIssue: 'Configuration issue detected. Please contact admin',
        tenantsUseCache: 'Unable to fetch latest tenants. Using cached data',
        tenantsFetchFailed: 'Failed to fetch tenant list. Please contact admin or try later',
        defaultTenantAdded: 'Default tenants added',
        defaultTenantName: 'Default Tenant',
        testTenantName: 'Test Tenant'
      },
      rules: {
        usernameRequired: 'Please enter phone number or username',
        passwordRequired: 'Please enter account password',
        captchaRequired: 'Please complete the verification code to continue login',
        captchaInvalid: 'Please enter a 4-character letters or digits verification code',
        passwordMin: 'Password must be at least 6 characters',
        emailInvalidFormat: 'Please enter a valid email address',
        usernameMin: 'Username must be at least 3 characters',
        phoneInvalid: 'Please enter a valid phone number',
        usernameInvalid: 'Please enter a valid username'
      }
    },
    router: {
      userInfoExpired: 'User info expired, please log in again',
      userInfoAbnormal: 'User info is abnormal, please log in again',
      noAdminPermission: 'You do not have permission to access this page',
      getUserInfoFailed: 'Failed to get user info, please log in again'
    },
    register: {
      title: 'Create an Account',
      invitationCode: 'Invitation Code',
      invitationPlaceholder: 'Enter invitation code',
      verify: 'Verify',
      getInvitationCode: 'Get Code',
      applyForRegistration: 'Apply for Registration',
      sourceChannel: 'Source Channel',
      sourceChannelPlaceholder: 'Please select how you heard about us',
      sourceChannelHint: 'Optional if you have an invitation code; otherwise please tell us how you heard about us',
      sourceChannelOptions: {
        wechat: 'WeChat Official Account',
        friend: 'Friend Recommendation',
        live: 'Live Stream',
        other: 'Other',
        none: 'No Referral Channel'
      },
      username: 'Username',
      usernamePlaceholder: 'Enter username',
      usernameFormatPlaceholder: '4-15 characters, letters and numbers only, not numbers only',
      email: 'Email',
      emailPlaceholder: 'Enter email address',
      emailHint: 'Please use corporate or educational email (.edu / .edu.cn)',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter password',
      industry: 'Industry',
      industryPlaceholder: 'Select industry',
      organization: 'Organization',
      organizationPlaceholder: 'Enter organization (optional)',
      register: 'Register',
      registering: 'Registering...',
      agreementPrefix: 'I have read and accept the',
      userAgreement: 'User Agreement',
      and: 'and',
      privacy: 'Privacy Policy',
      hasAccount: 'Already have an account?',
      loginNow: 'Login',
      messages: {
        verifyFirst: 'Please verify the invitation code first',
        acceptAgreements: 'Please read and agree to the User Agreement and Privacy Policy first',
        success: 'Registration successful, please go to your registration email to complete account activation!',
        successSimple: 'Registration successful',
        failed: 'Registration failed, please try again later',
        verifyFailed: 'Invitation code verification failed, please retry later',
        invitationOrSourceRequired: 'Please provide either invitation code or source channel',
        verifyInvitationFirst: 'Please verify the invitation code first'
      },
      rules: {
        invitationRequired: 'Please enter invitation code',
        invitationCodeRequired: 'Please enter invitation code',
        invitationCodeNotVerified: 'Invitation code not verified, please click "Verify" button',
        invitationOrSourceRequired: 'At least one of invitation code or source channel is required',
        sourceChannelRequired: 'Source channel is required when invitation code is not provided',
        sourceChannelLength: 'Source channel cannot exceed 200 characters',
        usernameRequired: 'Please enter username',
        usernameLength: 'Username length must be 2-20 characters',
        usernamePattern: "Only Chinese/letters/numbers/_- . and {'@'} allowed",
        usernameFormat: 'Username must be 4-15 characters, letters and numbers only, and not numbers only',
        officialName: 'Username contains an official name, please choose another one',
        usernameTaken: 'This username is already registered, please choose another one',
        emailRequired: 'Please enter email address',
        emailInvalid: 'Please enter a valid email address',
        emailNotCorporate: 'Please use corporate or educational email. Personal emails (QQ, 163, 126, Gmail, etc.) are not supported',
        industryRequired: 'Please select an industry',
        phoneRequired: 'Please enter phone number',
        phoneInvalid: 'Please enter a valid phone number',
        captchaRequired: 'Please enter captcha',
        smsCodeRequired: 'Please enter SMS verification code',
        smsCodeInvalid: 'Invalid verification code format',
        passwordFormat: 'Password must be 6-20 characters and include uppercase letters, lowercase letters, and numbers',
        passwordMismatch: 'Passwords do not match, please re-enter'
      },
      sms: {
        phone: 'Phone Number',
        phonePlaceholder: 'Enter phone number',
        captcha: 'Captcha',
        captchaPlaceholder: 'Enter captcha characters',
        captchaRefreshHint: 'Click image to refresh captcha',
        captchaClickToGet: 'Click to get',
        smsCode: 'SMS Code',
        smsCodePlaceholder: 'Enter SMS code',
        getCode: 'Get Code',
        resendCode: 'Resend',
        sending: 'Sending',
        resendAfter: 'Resend in {seconds}s',
        sendSuccess: 'Verification code sent, please check your phone',
        sendFailed: 'Failed to send, please try again later',
        getCaptchaFailed: 'Failed to get captcha, please retry',
        refreshCaptcha: 'Please refresh captcha',
        serviceUnavailable: 'SMS service is temporarily unavailable, please try again later',
        phoneRequired: 'Please enter phone number first',
        phoneInvalid: 'Please enter a valid phone number',
        captchaRequired: 'Please enter captcha'
      }
    },
    forgot: {
      title: 'Forgot Password',
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      sendLink: 'Send reset link',
      sending: 'Sending...',
      backToLogin: '← Back to login',
      successTitle: 'Email Sent',
      successDesc: 'Reset link has been sent to {email}. Please check your inbox and follow the instructions.',
      resend: 'Resend',
      messages: {
        sendSuccess: 'Password reset email sent successfully'
      },
      rules: {
        emailRequired: 'Please enter email address',
        emailInvalid: 'Please enter a valid email address'
      }
    },
    forgotSms: {
      title: 'Reset Password',
      subtitle: 'Complete verification and set a new password',
      backToLogin: 'Back to login',
      steps: {
        verifyIdentity: 'Verify Identity',
        smsVerify: 'SMS Verification',
        setPassword: 'Set Password'
      },
      form: {
        phone: 'Phone Number',
        phonePlaceholder: 'Enter your phone number',
        phoneNotRegisteredPrefix: 'This phone number is not registered. Please check your input or',
        phoneNotRegisteredSuffix: '.',
        goRegister: 'Register now',
        captcha: 'Captcha',
        captchaPlaceholder: 'Enter captcha',
        captchaRefresh: 'Click to refresh',
        refresh: 'Refresh',
        captchaHint: 'Cannot read? Click image to refresh',
        smsCode: 'SMS Code',
        smsCodePlaceholder: 'Enter 6-digit code',
        smsHint: 'Code is valid for 5 minutes. Request a new one after repeated failures.',
        newPassword: 'New Password',
        newPasswordPlaceholder: '6-20 chars with uppercase, lowercase, and numbers',
        confirmPassword: 'Confirm Password',
        confirmPasswordPlaceholder: 'Re-enter password'
      },
      actions: {
        getSmsCode: 'Get SMS Code',
        retryAfter: 'Retry in {seconds}s',
        nextStep: 'Next',
        resendSms: 'Resend code',
        resendAfter: 'Resend in {seconds}s',
        confirmReset: 'Confirm Reset',
        resetting: 'Resetting...'
      },
      success: {
        title: 'Password Reset Successful',
        desc: 'Please use the new password to sign in: {phone}'
      },
      validation: {
        phoneRequired: 'Please enter phone number',
        phoneInvalid: 'Please enter a valid phone number',
        captchaRequired: 'Please enter captcha',
        smsCodeRequired: 'Please enter SMS code',
        newPasswordRequired: 'Please enter new password',
        passwordRule: 'Password must be 6-20 characters and include uppercase, lowercase and numbers',
        confirmPasswordRequired: 'Please confirm your new password',
        passwordMismatch: 'The two passwords do not match'
      },
      messages: {
        captchaLoadFailed: 'Failed to load captcha. Please refresh and try again.',
        smsSent: 'SMS verification code sent',
        sendFailed: 'Failed to send. Please try again later.',
        resetSuccess: 'Password reset successful',
        resetFailed: 'Password reset failed. Please try again later.'
      }
    },
    reset: {
      title: 'Reset Password',
      invalidLinkTitle: 'Invalid or expired link',
      invalidLinkDesc: 'Please request a new password reset or contact admin',
      backToLogin: 'Back to login',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Enter new password',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter new password',
      reset: 'Reset Password',
      resetting: 'Resetting...',
      back: '← Back to login',
      messages: {
        alreadyLoggedIn: 'You are already signed in, redirecting to home...',
        tokenInvalid: 'Invalid reset token. Please request a new one',
        tokenExpired: 'Reset link expired. Redirecting to Forgot Password...',
        successTitle: 'Success',
        success: 'Password reset successfully! Please login with the new password.',
        unknownFailed: 'Password reset failed. Please retry',
        invalidOrExpired: 'Invalid or expired reset token'
      }
    }
  },
  // Feedback dialog
  feedback: {
    errors: {
      redirectError: 'Request redirect error, please contact admin',
      badRequest: 'Invalid request parameters, please check your input',
      authFailed: 'Authentication failed, please login again',
      noPermission: 'No permission to submit feedback',
      validationFailed: 'Data validation failed, please check input format',
      serverError: 'Internal server error, please try again later',
      submitFailedCode: 'Submit failed (error code: {code})',
      networkFailed: 'Network connection failed, please check your network',
      unknownError: 'Unknown error occurred: {msg}'
    },
    title: 'User Feedback',
    subtitle: 'We value every feedback and look forward to your valuable suggestions',
    // Admin/common
    searchLabel: 'Search',
    searchPlaceholder: 'Search content, username or email',
    status: 'Status',
    statusPlaceholder: 'Select status',
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusCompleted: 'Completed',
    statusClosed: 'Closed',
    username: 'Username',
    email: 'Email',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    detail: 'Feedback Detail',
    id: 'Feedback ID',
    contact: 'Contact',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    processor: 'Processor',
    processedAt: 'Processed At',
    search: 'Search',
    reset: 'Reset',
    export: 'Export CSV',
    submitTimeRange: 'Submitted',
    startTime: 'Start time',
    endTime: 'End time',
    empty: 'No feedback data',
    // Form & types
    content: 'Feedback Content',
    type: 'Feedback Type',
    typeRequirement: 'Feature Request',
    typeException: 'Bug Report',
    typeOther: 'Other',
    contentPlaceholder: 'Please describe your issue or suggestion in detail...',
    typePlaceholder: 'Please select feedback type',
    characterCount: 'Characters entered',
    minCharacters: 'Minimum 10 characters required',
    maxCharacters: 'Maximum 1000 characters allowed',
    options: {
      function_exception: 'Bug Report',
      requirement_suggestion: 'Feature Request',
      complaint: 'Service Complaint',
      other: 'Other Issues'
    },
    typeDescriptions: {
      function_exception: 'Page errors, functions not working properly, etc.',
      requirement_suggestion: 'New features or improvement suggestions',
      complaint: 'Service quality or experience issues',
      other: 'Other types of feedback or suggestions'
    },
    operation: 'Operation',
    processNote: 'Process Note',
    actions: {
      cancel: 'Cancel',
      submit: 'Submit Feedback',
      submitting: 'Submitting...'
    },
    steps: {
      step1: 'Select issue category',
      step2: 'Describe your issue',
      step3: 'Upload images/files (up to 5 files)'
    },
    upload: {
      images: 'Images',
      files: 'Files',
      maxImages: 'Up to 5 images',
      maxFiles: 'Up to 5 files',
      clickToUpload: 'Click to upload',
      reachedLimit: 'Limit reached',
      pasteHint: 'Support paste images (Ctrl+V / ⌘+V) or click to upload',
      imagePreview: 'Image Preview',
      previewImage: 'Preview Image',
      onlyImages: 'Only image files are allowed!',
      imageSizeLimit: 'Image size must not exceed 50MB!',
      onlyDocuments: 'Only PDF, Word, Excel, TXT, ZIP, RAR files are allowed!',
      fileSizeLimit: 'File size must not exceed 50MB!',
      maxImagesWarning: 'Maximum 5 images allowed, currently {count}. Please remove some images before uploading.',
      maxFilesWarning: 'Maximum 5 files allowed, currently {count}. Please remove some files before uploading.',
      pasteSuccess: 'Pasted image: {name}',
      pasteLimit: 'Maximum 5 images allowed',
      pasteSizeLimit: 'Pasted image size must not exceed 50MB!',
      uploadingFiles: 'Uploading {count} files in batch, please wait...'
    },
    rules: {
      contentRequired: 'Please enter your feedback',
      contentTooShort: 'Feedback must be at least 10 characters',
      contentTooLong: 'Feedback cannot exceed 1000 characters',
      typeRequired: 'Please select feedback type'
    },
    messages: {
      submitSuccess: 'Thank you for your feedback! We\'ll review it carefully',
      submitError: 'Submit failed, please try again later',
      sendMessageFailed: 'Send message failed',
      sendMessageFailedWithTimeout: 'Request timed out, research analysis needs longer time, please try again later',
      sendMessageFailedWithServerInternal: 'Server internal error, please try again later',
      sendMessageFailedWithTooManyRequests: 'Request too frequent, please try again later'
    }
  },
  // English - Profile
  profile: {
    title: 'Profile',
    edit: 'Edit Profile',
    cancelEdit: 'Cancel Edit',
    firstProfileTipPrefix: 'Complete your profile for the first time to get',
    username: 'Username',
    name: 'Name',
    phone: 'Phone Number',
    changePhone: 'Change Phone',
    changePhoneTitle: 'Change Phone Number',
    changePhoneStep1: 'Step 1: Verify current phone',
    changePhoneStep2: 'Step 2: Enter new phone',
    currentPhone: 'Current Phone',
    currentPhonePlaceholder: 'Enter your currently bound phone number',
    newPhone: 'New Phone',
    newPhonePlaceholder: 'Enter the new phone number',
    graphCaptcha: 'Captcha',
    graphCaptchaPlaceholder: 'Enter captcha',
    graphCaptchaRequired: 'Please enter the captcha',
    smsCode: 'SMS Code',
    smsCodePlaceholder: 'Enter SMS code',
    smsCodeRequired: 'Please enter the SMS code',
    getSmsCode: 'Get Code',
    resendIn: 'Resend in {seconds}s',
    smsSent: 'SMS code has been sent',
    smsSendFailed: 'Failed to send SMS, please try again later',
    captchaLoadFailed: 'Failed to load captcha',
    verifyOldFailed: 'Failed to verify current phone',
    currentPhoneMismatch: 'Please enter the phone number bound to your account',
    samePhoneError: 'New phone must be different from the current one',
    phoneRequired: 'Please enter phone number',
    phoneInvalid: 'Please enter a valid phone number',
    changePhoneSuccess: 'Phone updated. Please sign in with the new number.',
    changePhoneFailed: 'Failed to change phone, please try again later',
    changeSessionExpired: 'Change-phone session expired, please restart',
    changePhoneNoBind: 'No phone bound to this account. Contact admin.',
    next: 'Next',
    email: 'Email',
    emailVerified: 'Verified',
    emailUnverified: 'Unverified',
    sendActivationEmail: 'Send Activation Email',
    changeEmail: 'Change Email',
    password: 'Password',
    changePassword: 'Change Password',
    changePasswordSubtitle: 'For your account security, please set a new password',
    passwordStrength: 'Password Strength',
    passwordStrengthWeak: 'Weak',
    passwordStrengthMedium: 'Medium',
    passwordStrengthStrong: 'Strong',
    passwordTips: 'Password must be 6-20 characters and include uppercase letters, lowercase letters, and numbers',
    passwordMatch: 'Passwords match',
    passwordNotMatch: 'Passwords do not match',
    passwordContains: 'Contains',
    passwordCharTypes: {
      lowercase: 'Lowercase',
      uppercase: 'Uppercase',
      digits: 'Digits',
      special: 'Special chars'
    },
    industry: 'Industry',
    selectIndustry: 'Select industry',
    organization: 'Organization',
    organizationPlaceholder: 'Enter organization',
    language: 'Language',
    selectLanguage: 'Select language',
    notSet: 'Not set',
    lastLogin: 'Last login',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPasswordPlaceholder: 'Re-enter new password',
    industryOptions: {
      invest: 'Investment',
      preclinical: 'Biopharma (Preclinical)',
      clinical: 'Biopharma (Clinical)',
      basic: 'Basic Research',
      management: 'Management',
      bd: 'BD',
      school: 'School/Institute',
      other: 'Other'
    },
    validation: {
      currentRequired: 'Please enter current password',
      newRequired: 'Please enter new password',
      newMin: 'Password length must be at least 6 characters',
      confirmRequired: 'Please confirm the new password',
      confirmNotMatch: 'Passwords do not match'
    },
    messages: {
      loadFailed: 'Failed to load user info',
      updateSuccess: 'Profile updated successfully',
      updateFailed: 'Failed to update profile',
      emailCannotBeCleared: 'Email is already bound and cannot be cleared',
      passwordChanged: 'Password changed successfully',
      passwordChangeFailed: 'Failed to change password, please check your current password',
      badRequest: 'Invalid request parameters',
      authFailed: 'Authentication failed, please log in again',
      noPermission: 'No permission to modify this information',
      validationFailed: 'Data validation failed, please check your input',
      serverError: 'Internal server error, please try again later',
      updateFailedCode: 'Update failed ({code})',
      networkFailed: 'Network connection failed, please check your network',
      unknownError: 'Unknown error: {msg}'
    },
    neverLoggedIn: 'Never logged in',
    functionEntries: 'Quick Access',
    myPreferenceCenter: 'My Preference Profile',
    myUsageStatistics: 'My Usage Statistics'
  },
  // English - Account
  account: {
    loading: 'Loading account info... ',
    title: 'Account',
    subtitle: 'View your quota usage',
    totalAmount: 'Total Quota',
    usedAmount: 'Used Quota',
    remainingAmount: 'Remaining Quota',
    usageProgress: 'Usage Progress',
    lowBalanceTitle: 'Low Balance Alert',
    lowBalanceDesc: 'Your remaining balance is below 20% of the total quota. Please recharge in time. Current remaining: ',
    rechargeNow: 'Recharge Now',
    timeDistTitle: 'Average Report Generation Time Distribution (min)',
    timeDistSub: 'Report count distribution by time intervals in the last month',
    costDistTitle: 'Average X-Coin Consumption Distribution',
    costDistSub: 'Report count distribution by consumption intervals in the last month',
    taskOverview: 'Task Statistics Overview',
    taskOverviewSub: 'View statistics of your analysis tasks',
    totalTasks: 'Total Tasks',
    monthlySubmitted: 'Submitted This Month',
    completed: 'Completed',
    analyzing: 'Analyzing',
    failed: 'Failed',
    monthlyCompleted: 'Completed This Month',
    monthAvgDuration: 'Personal Monthly Average Duration',
    monthAvgCost: 'Personal Monthly Average X-Coin Consumption',
    recordsTitle: 'Consumption Records Details',
    recordsSub: 'View detailed consumption for each analysis task',
    columns: {
      usageType: 'Usage Type',
      model: 'Model',
      recordCount: 'Records',
      inputTokens: 'Input Tokens',
      outputTokens: 'Output Tokens',
      cost: 'X-Coin Cost',
      targetName: 'Task Name',
      status: 'Status',
      createdAt: 'Created At',
      duration: 'Generation Duration',
      modelsUsed: 'Models Used'
    },
    noData: 'No data',
    charts: {
      reportCount: 'Report Count',
      avgTime: 'Average Time',
      avgCost: 'Average X-Coin Cost',
      yAxisName: 'Count',
      reportCountUnit: 'Reports',
      avgTimeUnit: 'minutes',
      avgCoinConsumption: 'Average X-Coin Consumption',
      timeTooltip: 'Reports: {value} items',
      coinTooltip: 'Reports: {value} items',
      avgTimeTooltip: 'Average Time: {value} minutes',
      avgCoinTooltip: 'Average: {value} X-Coin'
    },
    usageLevel: {
      nearExhausted: 'Quota nearly exhausted, please recharge',
      high: 'High usage, please pay attention',
      normal: 'Usage is normal',
      sufficient: 'Sufficient quota'
    },
    messages: {
      fetchAccountFailed: 'Failed to fetch account info',
      fetchStatsFailed: 'Failed to fetch statistics',
      fetchTaskStatsFailed: 'Failed to fetch task statistics',
      fetchRecordsFailed: 'Failed to fetch consumption records',
      rechargeTip: 'Recharge feature is under development. Please contact admin.'
    }
  },
  target: {
    createFailed: 'Failed to create task. Please try again.',
    messages: {
      sendMessageFailed: 'Send message failed',
      sendMessageFailedWithTimeout: 'Request timed out. Research analysis may need more time. Please try again later.',
      sendMessageFailedWithServerInternal: 'Internal server error. Please try again later.',
      sendMessageFailedWithTooManyRequests: 'Too many requests. Please try again later.'
    },
    contract: {
      unclassified: 'Unclassified',
      taskMode: {
        quick: 'Quick mode',
        expert: 'Expert mode',
        writing: 'Writing mode',
      },
      workflowProfile: {
        'target-survey': 'Target survey',
        'deep-research': 'Deep research',
        'quick-brief': 'Quick brief',
        writing: 'Writing report',
      },
    },
    analysisPage: 'Task Analysis Page',
    searchPlaceholder: 'Search (name/description)',
    empty: 'No tasks yet',
    selectToView: 'Please select a task to view the report',
    confirmRightPanel: 'Please complete the confirmation in the chat panel first. The analysis will start automatically.',
    generating: 'Generating...',
    reportGenerating: 'epiXora is generating the analysis report. You can close the page and come back later.',
    report: 'Report',
    selectTargetFirst: 'Please select a target first',
    loadListFailed: 'Failed to load tasks',
    createAnalysisTitle: 'Create Analysis Task',
    createAnalysisConfirm: 'Create analysis task for "{name}"? ',
    createSuccess: 'Task created',
    selectTaskFirst: 'Please select a task first',
    analysisInProgressTip: 'The research task is running and will take about 30–60 minutes. Please wait patiently. You may close this window; the task will continue in the background.',
    cancelGeneration: 'Cancel generation',
    reportGenerationFailed: 'Report generation failed',
    retryOrContactSupport: 'Please try regenerating, or contact support',
    // 2026-06-01 P1-I: writing-mode (llm_agent) specific copy.
    writingTaskSubmitted: 'Writing report task submitted — watch the progress panel.',
    writingReportGenerationFailed: 'Writing report generation failed',
    writingModeUnavailable: 'Writing service is temporarily unavailable. Please retry later.',
    writingReportMarkdownHint: 'Writing-mode reports are delivered as Markdown. Edit/export below, or grab .md / .docx from the download menu.',
    v2MarkdownOnlyHint: 'No PDF preview is available for this report. Markdown view and editing are enabled — save, version, run hallucination checks, and export from the Markdown tab.',
    writingAck: {
      defaultIntent: 'Your writing request has been recorded',
      confirmEyebrow: 'Writing task ready',
      confirmTitle: 'Understood your writing request',
      confirmHint: 'You can add more requirements or generate the formal Markdown report now.',
      routeTitle: 'Ready to generate research report',
      regenerateEyebrow: 'Regeneration recommended',
      regenerateTitle: 'Major changes detected',
      regenerateHint: 'For large structural changes or a full rewrite, regenerate the report.',
      taskIntent: 'Task goal',
      deliverable: 'Deliverable',
      focus: 'Focus areas',
      constraints: 'Constraints',
      continueSupplement: 'Add more details',
      generateReport: 'Generate writing report',
      regenerateReport: 'Regenerate report'
    },
    workspace: {
      reportLayout: 'Report Layout',
      splitLayout: 'Side by Side',
      stackLayout: 'Stacked',
      reportGenerating: 'Generating Report',
      reportProgressSection: 'Report Progress',
      reportDraftPreview: 'Report Draft Preview',
      reportFailed: 'Report Generation Failed',
      reportCancelled: 'Report Cancelled',
      navigation: 'Navigation',
      chatTop: 'Chat Top',
      preReportChat: 'Pre-report Chat',
      postReportChat: 'Post-report Chat',
      postReportComposerFollowUp: 'Report follow-up',
      reportSection: 'Report Section',
      fullscreenReport: 'Fullscreen Report',
      chat: 'Chat',
      followUp: 'Follow-up',
      report: 'Report',
      fullscreen: 'Fullscreen',
      continueChat: 'Continue chatting...',
      useOutlineTemplate: 'Use Outline Template',
      manageOutlineTemplates: 'Manage Templates',
      outlineTemplateTip: 'Quickly generate an expert-mode outline from saved templates',
      quickOutlineTemplateTip: 'Reuse saved question frameworks to start quick research in one click',
      quickTemplateApplyQuery: 'Apply research question template: {name}',
      resizeReportHeight: 'Drag to resize report preview height; double-click to reset',
      resizeSplitPane: 'Drag to resize chat and report panes; double-click to reset',
      reportNav: 'Report navigation',
      reportQuickNav: 'Report quick navigation',
      analysisReportSidebar: 'Analysis report sidebar',
      feedbackSourceV2: 'Task Analysis V2',
      messages: {
        emptyInputDialogTitle: 'Input cannot be empty',
        emptyInputDialogMessage: 'No description was provided. Enter a research topic for a quick brief, or upload files for material Q&A.',
        balanceConfirmFailed: 'Balance confirmation failed. Please try again later.',
        balanceConfirmMessage: 'You are about to generate a report. Continue?',
        reportTaskStarted: 'Report generation task started',
        reportAlreadyRunning: 'Report generation is already in progress',
        resumeReportStarted: 'Resume started; will continue from the last failure point',
        resumeLocalSurveyStarted: 'Resume started; will continue the unfinished target survey steps',
        resumeCheckpointPartialStarted: 'Resume started; reusing saved research progress ({completed}/{total} research modules completed)',
        resumeCheckpointSynthesisStarted: 'Resume started; skipping completed data collection and continuing to organize the report',
        resumeHermesWritingStarted: 'Resume started; continuing the unfinished report writing task',
        reportGenerationFailed: 'Report generation failed. Please try again later.',
        reportEnqueueInProgress: 'Report generation is already starting. Please do not submit again.',
        reportCancelled: 'Report generation cancelled',
        cancelReportFailed: 'Failed to cancel report generation',
        writeModeDescribeFirst: 'Please describe your writing requirements in Write mode first',
        writingPdfUnavailable: 'Writing-mode reports are delivered as Markdown. Download Markdown or export Word from the editor.',
        adminWritingEngineLabel: 'Writing engine',
        adminWritingEngineDefault: 'Follow system config',
        adminWritingEngineRemote: 'Remote agent',
        adminWritingEngineLocal: 'Local LangGraph',
        adminWritingEngineHermes: 'Hermes free writing',
        adminEngineBadge: 'Admin',
        adminWritingEngineDefaultDesc: 'Use WRITING_ENGINE from admin config',
        adminWritingEngineRemoteDesc: 'Remote AGENT_SERVER llm_agent workflow',
        adminWritingEngineLocalDesc: 'Local LangGraph writing executor',
        adminWritingEngineHermesDesc: 'Hermes Gateway free-writing skill',
        adminSurveyEngineLabel: 'Target survey engine',
        adminSurveyEngineHint: 'Choose the report engine for this target survey run. Hermes is recommended by default; Local uses integrated_agent; Follow system reads TARGET_SURVEY_ENGINE from admin config.',
        adminSurveyEngineDefault: 'System',
        adminSurveyEngineLocal: 'Local agent',
        adminSurveyEngineHermes: 'Hermes',
        adminSurveyEngineDefaultDesc: 'Use TARGET_SURVEY_ENGINE from admin config',
        adminSurveyEngineLocalDesc: 'Local integrated_agent target survey',
        adminSurveyEngineHermesDesc: 'Hermes API Gateway target survey',
        adminHermesSurveyFlowLabel: 'Hermes survey skills',
        adminHermesSurveyFlowHint: 'Choose the Hermes target survey skills flow. Default reads TARGET_HERMES_SURVEY_FLOW from admin config; regular users always use that default.',
        adminHermesSurveyFlowH2Outline: 'hermes-h2_outline',
        adminHermesSurveyFlowH2OutlineDesc: '8-lane parallel collection + synthesis (h2_outline mode)',
        adminHermesSurveyFlowOutlinePlanner: 'hermes-outline_planner',
        adminHermesSurveyFlowOutlinePlannerDesc: 'Per-chapter H2 task decomposition from user outline (outline_planner mode)',
        adminEngineConfirmLine: 'Admin engine override: {engine}',
        adminWritingEngineHint: 'Choose the report engine for this writing task. When unset, WRITING_ENGINE from admin config is used.',
        outlineTemplateLoaded: 'Outline template "{name}" loaded. You can send or continue editing.',
        quickOutlineTemplateLoaded: 'Quick research template "{name}" loaded. Send to generate questions from this framework.',
        quickTemplateQuestionsLoaded: 'Loaded {count} research questions from template "{name}". Edit below, then start research.',
        templateAppliedLabel: '[Applied template: {name}]',
        loadAttachmentsFailed: 'Failed to load attachments',
        selectTaskBeforeUpload: 'Please select or create a task before uploading attachments',
        uploadBindSuccess: 'Uploaded and linked {success}/{total} attachment(s)',
        uploadAttachmentFailed: 'Failed to upload attachment',
        removeAttachmentConfirm: 'Remove attachment "{name}" from this task?',
        removeAttachmentTitle: 'Remove Attachment',
        removeAttachmentButton: 'Remove',
        attachmentRemoved: 'Attachment removed',
        removeAttachmentFailed: 'Failed to remove attachment',
        noPreviewContent: 'No previewable report content found',
        reportContentLoadFailed: 'Failed to load report content',
        auditRejectedNoDownload: 'Report audit rejected. Download is not available.',
        downloadPreparing: 'Preparing {format} report...',
        downloadStarted: '{format} download started',
        reportDownloadFailed: 'Report download failed. Please try again later.',
        ratingSaved: 'Report rating saved',
        ratingDeleted: 'Report rating deleted',
        segmentAddedToChat: 'Report excerpt added. Complete your question and send.',
        sectionAddedToChat: 'Section "{title}" added. Complete your question and send.',
        reportContentUpdated: 'Report content updated',
        createTaskBeforeAttachment: 'Please create a task before uploading or referencing attachments',
        deleteTaskConfirm: 'Delete task "{name}"? Creator: {creator}. It will be removed from your list.',
        deleteTaskSuccess: 'Task deleted successfully',
        deleteTaskFailed: 'Failed to delete task. Please try again later.',
        readingSelectedFilesPrompt: 'Reading the {count} selected file(s)...',
        analyzeAttachmentsPrompt: 'Please analyze based on the {count} referenced attachment(s).',
        reportSegmentPrompt: 'Please continue analysis based on this report excerpt:\n\n"{preview}"\n\nMy question:',
        reportSectionPromptWithContext: 'Please follow up on section "{title}":\n\n> Excerpt: {preview}{ellipsis}\n\nMy question:',
        reportSectionPrompt: 'Please follow up on section "{title}":\n\nMy question:',
        exportHtmlNeedMarkdown: 'Please load the Markdown report before exporting HTML',
        uploadMissingFileId: 'Upload response is missing file ID',
        downloadNoContent: 'Download API returned no file content',
        browserDownloadFailed: 'Browser download failed',
        downloadNoUrl: 'Backend did not return a download URL',
        downloadHttpStatus: 'Download failed with status code {status}',
        defaultUser: 'User',
        forkConversationSuffix: 'New chat',
        modeSwitchTitle: 'Switch task type',
        modeSwitchTitleTo: 'Switch to {mode}?',
        modeSwitchContinue: 'Continue',
        modeSwitchLeaveWriteWithRefs: 'After switching, a new conversation will be created and the currently uploaded attachments will be removed. The existing conversation will be saved in your research history. Continue?',
        modeSwitchLeaveWriteInChat: 'Your current writing-mode conversation is not finished yet. After switching, a new conversation will start, and the existing conversation will be saved together with this task in your research history. Continue?',
        modeSwitchToWriteInResearch: 'Report generation has not started yet. After switching, a new conversation will start, and the current progress will be saved in your research history. Continue?',
        modeSwitchExpertDoneToQuick: 'Your research task is completed. After switching, a new conversation will start, and the current research content and conversation will be saved in your research history. Continue?',
        modeSwitchQuickBriefToExpert: 'A quick brief has been generated (view it in the chat). No expert report file exists yet. After switching to Expert mode you will need to generate a formal report; the quick brief stays in the chat. Continue?',
        modeSwitchConfirmReportRunning: 'Switching task type will start a new conversation. Your current chat will be kept. Continue?',
        modeSwitchConfirmMidFlow: 'This conversation is in "{phrase}". Switching will start a new chat; the current one will be kept. Continue?',
        modeSwitchOutlineFlow: 'research flow',
        modeSwitchForkSuccess: 'New conversation started',
        modeSwitchLeaveWriteRefs: 'Leaving writing mode clears referenced attachments (files on the server are kept). Continue?'
      }
    },
    reportPanel: {
      title: 'Report Generation',
      writingTitle: 'Writing Generation',
      refresh: 'Refresh',
      cancel: 'Cancel Generation',
      resume: 'Resume Generation',
      loadingProgress: 'Loading report progress...',
      noProgress: 'No report progress yet',
      defaultStep: 'Report Generation',
      statusGenerating: 'Report is being generated. Please wait.',
      statusFailed: 'Report generation failed. You can try resuming.',
      statusCancelled: 'Report generation was cancelled. You can resume from the interruption.',
      statusCompleted: 'Report generation completed.',
      statusDefault: 'Progress will appear after research starts.',
      draftPreview: 'Draft preview while generating; the final report replaces it when ready.',
      durationRange: 'Estimated {min}–{max} min',
      durationSingle: 'Estimated ~{minutes} min',
      durationHighComplexity: 'Large outline — may approach the system timeout. Consider resume or ask admin to raise timeout.',
      durationHint: 'Estimated duration'
    },
    attachment: {
      title: 'Attachments & Document References',
      toolbarTitle: 'Task Attachments',
      toolbarDesc: 'After upload and reference, answers use material only (no web search). Text is parsed and injected before send.',
      formatHint: 'Supported: {formats}. Max {maxMb}MB per file (membership cap, hard limit 20MB).',
      modeQuickNote: '[Quick mode] Attachment limits are separate from Expert/Writing.',
      modeExpertNote: '[Expert/Writing] Attachment limits follow knowledge-base session rules.',
      quickQuotaHint: 'Quick mode: up to {perTask} attachments per session, max {maxMb}MB each',
      quickQuotaUnlimited: 'Quick mode: unlimited attachments per session, max {maxMb}MB each',
      quickUsageUnlimited: 'Quick mode · {count} referenced (no count limit)',
      quickUsageLimited: 'Quick mode · {count}/{perTask} attachments referenced',
      expertQuotaPerTask: 'Expert/Writing: up to {perTask} per session, max {maxMb}MB each',
      expertQuotaTotal: 'Expert/Writing: account library capacity {total} files',
      expertQuotaBoth: 'Expert/Writing: ≤ {perTask} per session, ≤ {total} account-wide, max {maxMb}MB each',
      expertUsageLimited: 'Expert/Writing · {count}/{perTask} attachments referenced',
      expertUsageCount: 'Expert/Writing · {count} attachments referenced',
      localFormats: 'Supported: {formats}',
      localMaxMb: 'Max {maxMb}MB per file',
      localPerTask: 'Up to {perTask} files per task',
      localTotal: 'Account capacity {total} files',
      localQuickUnlimited: 'No per-task attachment count limit',
      quotaHintPerTask: 'Up to {perTask} attachments per knowledge base/session (membership)',
      quotaHintTotal: 'Account library capacity: {total} files (membership)',
      quotaHintBoth: 'Per knowledge base/session ≤ {perTask} files, account total ≤ {total} (membership)',
      unsupportedType: 'Unsupported type ({ext}). Use PDF, Word, Excel, PPT, TXT, Markdown, HTML, or CSV.',
      sizeExceeded: 'File exceeds the size limit (max {max}MB)',
      refresh: 'Refresh',
      upload: 'Upload Attachment',
      localUploadTitle: 'Upload Local Literature',
      dragUploadHint: 'Drag files here to upload',
      selectFile: 'Select File',
      uploadedFiles: 'Uploaded Files',
      uploadCompleted: 'Completed',
      empty: 'No attachments',
      fileName: 'File Name',
      size: 'Size',
      actions: 'Actions',
      referenced: 'Referenced',
      reference: 'Reference',
      remove: 'Remove',
      close: 'Close',
      unnamedFile: 'Unnamed file'
    },
    sourcePanel: {
      title: 'Citation Details',
      collapse: 'Collapse panel',
      expand: 'Expand citation details',
      hide: 'Hide panel',
      clear: 'Clear',
      emptyTitle: 'Click a citation marker on the left',
      emptyDesc: 'View quoted sentences and literature sources — PubMed, ClinicalTrials, and more.',
      step1: '① Select sentence',
      step2: '② View source',
      step3: '③ Open original',
      quotedSentence: 'Quoted sentence',
      sourceExcerpt: 'Source excerpt',
      reportExpression: 'Report wording',
      articleInfo: 'Article details',
      contextInfo: 'Context',
      issue: 'Volume / issue',
      trialInfo: 'Trial details',
      patentInfo: 'Patent details',
      materialInfo: 'Material details',
      materialBadge: 'User material',
      knowledgeBaseInfo: 'Knowledge base details',
      loadingPubmed: 'Loading PubMed metadata…',
      authors: 'Authors',
      journal: 'Published in',
      openOriginal: 'Open original',
      copyLink: 'Copy link',
      pubmedAbstract: 'PubMed abstract',
      embedPreviewTitle: 'Source preview',
      referenceMaterial: 'Reference',
      literature: 'Literature',
      literatureSource: 'Literature source',
      externalLink: 'External link',
      opensearchBadge: 'Internal literature index · matched',
      internalIndexHit: 'index hit',
      pubmedTip: 'Academic sites usually block embedding. Matching keywords in the abstract are highlighted.',
      loadingClinicalTrial: 'Loading ClinicalTrials.gov study details…',
      trialStatus: 'Status',
      trialPhase: 'Phase',
      trialConditions: 'Conditions',
      trialSponsor: 'Sponsor',
      clinicalTrialTip: 'ClinicalTrials.gov blocks in-page embedding. Study metadata and highlighted snippets are shown below; use Open original for the full page.',
      clinicalTrialPage: 'ClinicalTrials study page',
      clinicalTrialFetchFailed: 'Live metadata is unavailable; showing indexed snippet. Use Open original for the registry page.',
      trialInterventions: 'Interventions',
      trialStartDate: 'Start date',
      registryEmbedTip: 'This trial registry blocks in-page embedding. Indexed snippet is shown; use Open original for full registration details.',
      citationPending: 'Citation details are still being prepared and will be filled in automatically.',
      citationUnavailable: 'This brief currently has no sentence-level citation data. Please refer to retrieval sources for now.',
      corpusFallbackHint: 'The exact source sentence was not located; the quote reflects the report wording. Context shows indexed snippets or on-demand excerpts.',
      bibliographyOnlyHint: 'Bibliography-level provenance only; a sentence-aligned source excerpt could not be retrieved.',
      loadingSourceExcerpt: 'Fetching source excerpt from literature index…',
      linkCopied: 'Link copied',
      copyLinkFailed: 'Copy failed — copy the link manually'
    },
    quickBrief: {
      badge: 'Research brief',
      headline: 'Research Brief',
      headlineWithTopic: '[Research Brief] {topic}',
      subtitle: 'Here is the research result. Swipe over sentences or use the buttons to save part or all of it to your Knowledge Map.',
      questionTag: 'Question {index}',
      metaWithSources: '{sentences} sentences · {sources} sources',
      metaNoSource: 'Sentence-level citations pending · structured brief available',
      metaRetrievalOnly: 'Retrieval-linked sources · click markers for details',
      sourceLinked: 'Retrieval source linked',
      syntheticSourceFootnote: 'Based on retrieval sources',
      metaModelSummary: 'Model summary · run deep research for full citations',
      exportBrief: 'Export brief',
      exportMarkdown: 'Markdown',
      exportHtml: 'HTML',
      exportWord: 'Word',
      exportPdf: 'PDF',
      sourceHint: 'This brief is shown by section without sentence-level citations yet. You can save/export a draft; citation links will appear after retrieval is connected.',
      sourceHintSoft: 'Some sentences have no clickable source markers yet. Continue reading or start deep research for more evidence.',
      empty: 'No brief content with citations yet',
      statusFormal: 'Generated',
      sourcePending: 'Evidence pending',
      viewCitationAria: 'View citation sources for this sentence',
      sourceFallback: 'Source',
      saveToMap: 'Save to knowledge map',
      noExportContent: 'Nothing to export',
      exportedMarkdown: 'Brief exported as Markdown',
      unsupportedFormat: 'Unsupported export format',
      generating: 'Generating {format}, please wait…',
      exportedAs: 'Brief exported as {format}',
      exportFailed: '{format} export failed — please retry',
      summaryTable: 'Key summary table',
      logicDiagram: 'Research logic diagram',
      referenceIndexTitle: 'References & source index',
      copyGbt7714: 'Copy GB/T 7714',
      copyBibtex: 'Copy BibTeX',
      unnamedSource: 'Untitled source',
      noReferencesToCopy: 'No references to copy',
      citationsCopied: 'Copied {count} {format} citation(s)',
      copyFailed: 'Copy failed — please retry',
      citationSource: {
        webSearch: 'Web search',
        internalLiterature: 'Internal literature index',
        internalClinicalTrial: 'Internal clinical trials index',
        internalPatent: 'Internal patent index',
        internalKnowledgeBase: 'Internal knowledge base',
        matchedExcerpt: 'Matched excerpt',
        matchedExcerptExport: '**Matched excerpt:**'
      },
      progress: {
        centerTitle: 'Generating research brief',
        centerHint: 'Progress also appears in the chat panel. The brief with citations will display automatically when done.',
        connecting: 'Connecting to live progress…',
        searchingDefault: 'Searching literature and organizing key points…',
        generatingDefault: 'Generating brief…',
        finalizing: 'Brief complete, preparing results…',
        streamInterrupted: 'Progress stream interrupted, waiting for result…',
        sessionRestored: 'Session restored, syncing generation progress…',
        streamDisconnected: 'Live progress disconnected, waiting for result…',
        httpTimeoutStillGenerating: 'The connection timed out, but the brief is still generating in the background. Please wait or refresh shortly.',
        streamConnectFailed: 'Failed to connect progress stream, waiting for result…',
        syncingProgress: 'Syncing generation progress…',
        chatPlaceholder: 'Generating research brief for "{topic}"…',
        steps: {
          analyzeDimensions: 'Analyze dimensions',
          evidenceSearch: 'Evidence search',
          sectionWriting: 'Section writing',
          sectionWritingProgress: 'Section writing {done}/{total}',
          finalOptimize: 'Final polish',
          literatureCollection: 'Literature collection',
          keyPoints: 'Key points',
          citationMarkup: 'Citation markup',
          patentCollection: 'Patent collection',
          clinicalTrials: 'Clinical trials',
          outlineGeneration: 'Outline generation'
        }
      }
    },
    modes: {
      expert: {
        manageTemplates: 'Manage outline templates'
      },
      write: {
        title: 'Generate writing report',
        description: 'I will generate a formal Markdown report from your writing request above. Add more requirements in the input below if needed.',
        generate: 'Generate writing report',
        regenerate: 'Regenerate report',
        postReportDescription: 'Your report is ready. Regenerate for major structural changes; ask follow-up questions in the input below.',
        generatingDescription: 'Your report is being generated. You can ask follow-up questions or regenerate once it is ready.'
      },
      quick: {
        manageTemplates: 'Manage outline templates',
        saveQuestionsTip: 'Save this question list as a template for reuse in other tasks',
        saveBriefAsTemplate: 'Save brief as template',
        actionsHint: 'Select text to save to the knowledge map, or right-click to save a section or the full brief',
        saveToMap: 'Save to knowledge map',
        copyBrief: 'Copy brief',
        regenerateBrief: 'Regenerate brief',
        regenerateBriefNoQuestions: 'Cannot restore questions from this brief (need at least {min}). Please start a new research flow.',
        saveSectionToMap: 'Save current section to knowledge map',
        copySectionMd: 'Copy section Markdown',
        saveTableToMap: 'Save table to knowledge map',
        copyTableMd: 'Copy table Markdown',
        tableParseFailed: 'Failed to parse table',
        tableCopied: 'Table Markdown copied',
        saveSelectionToMap: 'Save selected text to knowledge map',
        saveFullBriefToMap: 'Save full brief to knowledge map',
        quickSaving: 'Quick saving…',
        quickSaveToMap: 'Quick save to knowledge map',
        copySelection: 'Copy selected text',
        copyFullBrief: 'Copy full brief',
        generatingBrief: 'Generating research brief for “{topic}”…',
        statusProcessing: 'Processing',
        statusHistorical: 'Past question',
        statusCompleted: 'Research completed',
        statusPending: 'Pending',
        emptyContent: 'Content is empty — cannot save to knowledge map',
        emptyCopy: 'Content is empty — cannot copy',
        mapOpened: 'Knowledge map opened — confirm save location',
        sectionCopied: 'Section Markdown copied',
        briefCopied: 'Full brief Markdown copied',
        copied: 'Copied to clipboard',
        copyFailed: 'Copy failed — select text manually',
        quickSaveSuccess: 'Quick-saved to knowledge map — wiki will be organized in the background',
        quickSaveSuccessMapOnly: 'Quick-saved to knowledge map',
        quickSaveConfirm: 'Saved to “{topic}”. Open knowledge map now?',
        saveSuccessTitle: 'Saved',
        openKnowledgeMap: 'Open knowledge map',
        continueResearch: 'Continue research',
        quickSaveFailed: 'Quick save failed — try the confirmation dialog',
        briefFooter: 'Source: Quick-mode brief “{name}”',
        defaultTopic: 'current topic',
        unnamedTask: 'Untitled task',
        unnamedTopic: 'Unnamed topic',
        defaultDirectory: 'Target',
        defaultCategory: 'General content',
        citationExport: {
          contextTitle: 'Current citation context',
          citationId: 'Citation ID',
          source: 'Source',
          title: 'Title',
          link: 'Link',
          sentence: 'Matched sentence',
          snippet: 'Matched excerpt',
          sectionDefault: 'Section content',
          dimension: 'Dimension',
          status: 'Status',
          provenance: 'Provenance',
        },
      }
    },
    reportResult: {
      generated: 'Generated',
      locateSuccess: 'Located. Check the selection in the editor.',
      fullscreenViewEsc: 'Fullscreen (Esc to exit)',
      fullscreen: 'Fullscreen',
      expand: 'Expand',
      collapse: 'Collapse',
      expandReportPreview: 'Expand report preview',
      collapsePreviewSaveSpace: 'Collapse preview to save space',
      reloadReportContent: 'Reload report content',
      refresh: 'Refresh',
      fullscreenView: 'Fullscreen View',
      fullscreenRead: 'Read in Fullscreen',
      auditRejectedTitle: 'Report Audit Rejected',
      auditRejectedDesc: 'This report was rejected during audit and cannot be previewed. Please adjust your research request and regenerate, or contact an administrator.',
      auditRejectedAdjustAction: 'Adjust and regenerate',
      auditRejectedFeedbackAction: 'Request manual review',
      loadingReport: 'Loading report content...',
      loadFailedTitle: 'Failed to Load Report',
      reload: 'Reload',
      noPreviewContent: 'No report content available for preview',
      accessLimitedBalanceTitle: 'Insufficient balance. Partial report preview only',
      accessLimitedPreviewHint: 'Recharge to unlock the full report and downloads.',
      accessLimitedUnlocked: '{percentage} unlocked',
      accessLimitedUnlockNeed: '{amount} X-Coin needed to unlock',
      accessLimitedRecharge: 'Recharge',
      subtitleDraft: 'Report is still generating; preview shows the current draft.',
      collapsedPlaceholder: 'Report preview is collapsed. Expand preview or use fullscreen to view the full content.',
      exitFullscreenEsc: 'Esc to exit',
      exitFullscreen: 'Exit Fullscreen',
      fullscreenAriaWithName: 'Fullscreen report: {name}',
      fullscreenAria: 'View analysis report in fullscreen',
      downloadFromMarkdown: 'Export from current Markdown edits (including unsaved changes)',
      downloadFromServer: 'Download the generated report file from server',
      subtitleRejected: 'Report audit rejected; content is not available.',
      subtitleWritingMarkdownOnly: 'The writing document is ready as Markdown. Preview, edit, or export it here.',
      subtitleMarkdownOnly: 'Markdown report is ready. Preview, edit, or view in fullscreen.',
      subtitleDualFormat: 'Switch between PDF and Markdown; fullscreen is recommended for reading.',
      subtitleDefault: 'Report is ready. Click fullscreen for an immersive view.',
      collapsedHintWithName: 'Report for "{name}" is ready and currently collapsed.',
      collapsedHint: 'Report is ready and currently collapsed.',
      qualityGateTitleFail: 'Verifiable claims need review (high risk)',
      qualityGateTitleWarn: 'Uncited verifiable claims detected',
      qualityGateSummary: 'Rule scan: {high} high-risk and {medium} medium-risk uncited claims.',
      qualityGateObserveOnlyPrefix: '[Observe only — does not block publish] ',
      qualityGateSummaryWithScore: 'Quality score {score}/{threshold} (QA); critical {critical}. Rule scan: high {ruleHigh}, medium {ruleMedium}; QA also reports high {qaHigh}, medium {qaMedium}. Add footnotes or remove unverifiable claims.',
      qualityGateScoreTag: 'Score {score}/{threshold}',
      qualityGatePublishBlocked: 'Quality gate below publish threshold — revise before external use.',
      qualityGateRecommendation: 'Add [N] footnotes for NCT/PMID/patent/PDB/percentages (same format as in-body citations); otherwise mark as insufficient public evidence or remove the sentence.',
      qualityGateIssuesTitle: 'Issues (showing {displayed} of {total}{truncated}, critical first)',
      qualityGateIssuesTruncated: ' — first {limit} shown',
      qualityGateSeverityCritical: 'Crit',
      qualityGateSeverityHigh: 'High',
      qualityGateSeverityMedium: 'Med',
      qualityGateOpenReview: 'Open hallucination review',
      qualityGateIssue: {
        placeholder_or_tbd: 'Placeholder or TBD text',
        uncited_trial_or_pmid: 'Uncited trial or PMID',
        uncited_patent_id: 'Uncited patent ID',
        uncited_pdb_id: 'Uncited PDB ID',
        uncited_trial_phase_stat: 'Uncited trial phase/statistics',
        uncited_numeric_claim: 'Uncited numeric or efficacy claim',
        uncited_regulatory_claim: 'Uncited regulatory/approval claim',
        footnote_semantic_mismatch: 'Footnote does not match the claim',
        clinical_trial_field_needs_verification: 'Clinical trial fields need verification',
        patent_unclear_with_conclusion: 'Patent unclear but conclusion drawn',
        missing_reference: 'Missing citation',
        hallucination: 'Suspected hallucination',
        concept_confusion: 'Concept confusion',
        time_inconsistency: 'Temporal inconsistency',
        qa_issue: 'Quality issue',
      },
    },
    taskNameRequired: 'Task name cannot be empty',
    taskNameEmpty: 'Please enter a task name',
    taskIdInvalid: 'Invalid task ID. Please refresh and try again',
    updateNameFailed: 'Failed to update task name',
    targetNotExist: 'Task {id} does not exist or you do not have access',
    selectFirst: 'Please select a task first',
    // TargetList page related
    list: {
      title: 'Task Management',
      newTask: 'New Task',
      newTaskShort: 'New',
      questionnaireCreate: 'Create via Q&A',
      questionnaireCreateShort: 'Q&A',
      filters: 'Filters',
      status: 'Status',
      allStatus: 'All Status',
      taskId: 'Task ID',
      taskIdPlaceholder: 'Enter task ID',
      search: 'Search',
      searchPlaceholder: 'Search task name or description',
      creator: 'Creator',
      creatorPlaceholder: 'Enter username or email to search',
      membershipTier: 'Membership Tier',
      allMembershipTiers: 'All Tiers',
      allWorkflows: 'All Workflows',
      createdAt: 'Created At',
      dateRangeSeparator: 'to',
      startTimePlaceholder: 'Start Time',
      endTimePlaceholder: 'End Time',
      searchButton: 'Search',
      resetButton: 'Reset',
      statistics: {
        total: 'Total',
        analyzing: 'Analyzing',
        completed: 'Completed',
        pending: 'Pending'
      },
      table: {
        taskId: 'Task ID',
        taskName: 'Task Name',
        description: 'Description',
        status: 'Status',
        workflow: 'Workflow',
        creator: 'Creator',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        reportDuration: 'Duration',
        reportCost: 'Cost',
        actions: 'Actions',
        view: 'View',
        generate: 'Generate Report',
        regenerate: 'Regenerate',
        generating: 'Generating',
        chat: 'Chat',
        unknown: 'Unknown',
        intelligenceSubscribe: 'Intel subscription',
        intelligenceFeed: 'Intel updates',
        more: 'More'
      },
      mobile: {
        viewDetail: 'View Details',
        startChat: 'Start Chat'
      },
      createDialog: {
        title: 'New Task',
        taskName: 'Task Name',
        taskNamePlaceholder: 'Enter task name',
        taskDescription: 'Task Description',
        taskDescriptionPlaceholder: 'Enter task description',
        taskType: 'Task Type',
        taskTypePlaceholder: 'Enter research type',
        priority: 'Priority',
        priorityPlaceholder: 'Select priority',
        remark: 'Remark',
        remarkPlaceholder: 'Enter remark',
        cancel: 'Cancel',
        create: 'Create'
      },
      questionnaireDialog: {
        title: 'Create Task via Q&A',
        taskName: 'Task Name',
        taskNamePlaceholder: 'Enter research task name',
        taskDescription: 'Task Description',
        taskDescriptionPlaceholder: 'Enter task description',
        questions: 'Q&A Information',
        question: 'Question',
        questionPlaceholder: 'Enter question',
        answer: 'Answer',
        answerPlaceholder: 'Enter answer',
        delete: 'Delete',
        addQuestion: 'Add Question',
        cancel: 'Cancel',
        createTask: 'Create Task',
        taskNameRequired: 'Please enter task name',
        qaRequired: 'Please fill in at least one complete Q&A'
      },
      messages: {
        createSuccess: 'Task created successfully',
        createFailed: 'Failed to create task',
        loadFailed: 'Failed to load task list',
        noData: 'No valid data retrieved',
        pageAutoJump: 'Auto-jumped to page {page}',
        cancelSuccess: 'Report generation cancelled',
        statusNotSupportCancel: 'Current status does not support cancellation',
        taskNotExist: 'Task does not exist or has been deleted',
        cancelFailed: 'Cancellation failed, please try again later',
        reportGenerateStarted: 'Report generation task started, please check progress',
        startReportFailed: 'Failed to start report generation'
      },
      pageSizeLimitWarning: 'Page size limited to 1000'
    },
    // TargetChat page related
    chat: {
      backToDetail: 'Back to Details',
      targetChat: 'Target Chat',
      reportChat: 'Report Chat',
      clearHistory: 'Clear History',
      downloadReport: 'Download Report',
      welcomeTitle: 'Welcome to Chat with Research Report',
      welcomeMessage: 'You can ask any questions about "{name}", and I will answer based on the generated report.',
      suggestedQuestions: 'Suggested Questions:',
      you: 'You',
      aiAssistant: 'AI Assistant',
      inputPlaceholder: 'Please enter your question...',
      writingPlaceholder: 'Describe your writing task, or upload reference materials. I will help you create a customized document.',
      writingChatPlaceholder: 'Describe writing needs or request edits to generated content...',
      sending: 'Sending...',
      send: 'Send',
      invalidTaskId: 'Invalid task ID, please re-enter',
      reportNotReady: 'Report is not ready yet, cannot start chat',
      taskIdInvalid: 'Invalid task ID, please select another task',
      loadFailed: 'Failed to load task information',
      sendFailed: 'Failed to send message',
      clearConfirmTitle: 'Confirm Clear',
      clearConfirmMessage: 'Are you sure you want to clear all chat history? This action cannot be undone.',
      clearSuccess: 'Chat history cleared',
      downloadPreparing: 'Generating download link, please wait...',
      downloadCancelled: 'Download cancelled',
      downloadTimeout: 'Download link generation timeout, please try again later',
      downloadFailed: 'Failed to download report',
      fileNotExist: 'Report file does not exist or cannot generate download link',
      justNow: 'Just now',
      minutesAgo: '{minutes} minutes ago',
      hoursAgo: '{hours} hours ago',
      defaultQuestion1: 'What is the main function of this target?',
      defaultQuestion2: 'What is the current research status?',
      defaultQuestion3: 'What are the clinical application prospects?',
      unknownResponseFormat: 'Received unknown response format',
      noValidResponse: 'No valid response received'
    },
    // TargetDetail page related
    detail: {
      backToList: 'Back to List',
      targetDetail: 'Target Details',
      forceGenerate: 'Force Generate',
      chatReport: 'Chat Report',
      downloading: 'Downloading...',
      downloadReport: 'Download Report',
      targetInfo: 'Target Information',
      targetName: 'Target Name:',
      targetDescription: 'Target Description:',
      targetType: 'Target Type:',
      contractType: 'Task Type:',
      priority: 'Priority:',
      status: 'Status:',
      reportStatus: 'Report Status:',
      duration: 'Generation Duration:',
      cost: 'Generation Cost:',
      sampleReport: 'Sample Report (No Charge)',
      creator: 'Creator:',
      createdAt: 'Created At:',
      updatedAt: 'Updated At:',
      remark: 'Remark:',
      none: 'None',
      unclassified: 'Unclassified',
      unknown: 'Unknown',
      qaInfo: 'Q&A Information',
      question: 'Question:',
      answer: 'Answer:',
      dataDownload: 'Data Download',
      resourceConsumption: 'Resource Consumption',
      tokenConsumption: 'Token Consumption',
      searchConsumption: 'Search Consumption',
      model: 'Model:',
      inputTokens: 'Input Tokens:',
      outputTokens: 'Output Tokens:',
      totalTokens: 'Total Tokens:',
      searchCredits: 'Search Credits:',
      reportProgress: 'Report Generation Progress',
      refresh: 'Refresh',
      noLogs: 'No generation records',
      chatHistory: 'Chat History',
      enterChat: 'Enter Chat',
      noChatHistory: 'No chat history',
      user: 'User',
      showAll: 'Show all {count} records',
      collapse: 'Collapse',
      reportOutline: 'Report Outline',
      expand: 'Expand',
      collapseOutline: 'Collapse',
      noOutline: 'No outline information',
      showFullOutline: 'Show full outline (Total {count} items)',
      reportRating: 'Report Rating',
      inProgress: 'In Progress',
      completed: 'Completed',
      failed: 'Failed',
      startedAt: 'Started:',
      completedAt: 'Completed:',
      invalidTaskId: 'Invalid task ID, please re-enter',
      taskIdInvalid: 'Invalid task ID, please select another task',
      loadFailed: 'Failed to load task information',
      reportGenerateFailed: 'Report generation failed',
      refreshChatHistoryFailed: 'Failed to refresh chat history',
      cancelSuccess: 'Report generation cancelled',
      statusNotSupportCancel: 'Current status does not support cancellation',
      taskNotExist: 'Task does not exist or has been deleted',
      cancelFailed: 'Cancellation failed, please try again later',
      reportGenerateStarted: 'Report generation task started',
      startReportFailed: 'Failed to start report generation',
      fileNotExist: 'Report file does not exist or download link cannot be generated',
      downloadCancelled: 'Download cancelled',
      downloadTimeout: 'Download link generation timeout, please try again later',
      downloadFailed: 'Failed to download report',
      downloadStarted: '{fileType} file download started',
      getDownloadLinkFailed: 'Failed to get download link',
      downloadFileFailed: 'Failed to download {fileType} file: {msg}',
      metadata: 'Metadata',
      noReportContent: 'No report content available',
      intelligenceSubscription: 'Intel subscription',
      intelligenceUpdates: 'Intel updates',
      intelligenceAccessDeniedTier: 'Your membership tier does not include intelligence subscription',
      intelligenceAccessDeniedMenu: 'No intelligence subscription permission. Ask your admin to assign role menu permission',
      intelligenceFeedAccessDeniedTier: 'Your membership tier does not include intelligence feed viewing',
      intelligenceFeedAccessDeniedMenu: 'No intelligence feed permission. Ask your admin to assign role menu permission'
    },
    intelligence: {
      configTitle: 'Intelligence subscription',
      feedTitle: 'Intel update history',
      emptyRunsHint: 'After subscription is enabled, scans will run at intervals. You can also click "Scan now" on the subscription settings page.',
      feedIntroTitle: 'Scan result feed',
      feedIntroDesc: 'View report intelligence scan hits and push records by time',
      backToTask: 'Back to task',
      viewFeed: 'View updates',
      enabled: 'Enable scheduled scan',
      enabledOn: 'Enabled',
      enabledOff: 'Disabled',
      scheduleSection: 'Scan schedule',
      unsavedChanges: 'Unsaved changes',
      configSynced: 'Config synced',
      interval: 'Interval (minutes)',
      categories: 'Categories to watch',
      catAll: 'All',
      catLiterature: 'Literature',
      catPatent: 'Patents',
      catClinical: 'Clinical trials',
      catWeb: 'Web',
      catPipeline: 'Report pipeline',
      channels: 'Notification channels',
      chInApp: 'In-app notifications',
      chEmail: 'Email',
      chFeishuHook: 'Feishu group bot (Webhook)',
      chFeishuUser: 'Feishu app message (bind Feishu)',
      notifyEmail: 'Notify email (optional)',
      webhookUrl: 'Webhook URL',
      webhookHint: 'Paste hook URL from Feishu custom bot; choose “Update webhook” when saving',
      webhookPreserve: 'Keep existing webhook',
      webhookSet: 'Update webhook',
      webhookClear: 'Clear webhook',
      save: 'Save',
      triggerRun: 'Run now',
      testNotify: 'Test notify',
      loadFailed: 'Failed to load settings',
      saveSuccess: 'Saved',
      saveFailed: 'Save failed',
      triggerOk: 'Scan finished',
      triggerQueued: 'Scan job submitted',
      testOk: 'Test sent (check each channel)',
      emptyRuns: 'No runs yet',
      runStatus: 'Status',
      runTime: 'Time',
      runSummary: 'Summary',
      nextRun: 'Next run',
      lastRun: 'Last run',
      watermark: 'Log watermark',
      hintDefaultOff: 'Off by default; when on, scans report log deltas and pushes to selected channels.',
      loadMore: 'Load more',
      logEntriesTitle: 'Log entries ({count})',
      webhookConfiguredShort: 'Webhook',
      statusQueued: 'Queued',
      statusRunning: 'Running',
      statusSucceeded: 'Succeeded',
      statusPartialFailed: 'Partially failed',
      statusFailed: 'Failed',
      statusSkipped: 'No new updates',
      statusSkippedDuplicate: 'Same content already sent today',
      searchStatsTitle: 'Search & filter stats',
      itemKindExternal: 'External',
      itemKindReportLog: 'Report',
      pollRunPending: 'Inspection running, please wait…',
      pollRunTimeout: 'Inspection still running in background; check the feed shortly',
      testNotifyPartial: 'Some channels failed; check details or configuration',
      triggerFailed: 'Scan failed',
      intervalPresets: 'Quick interval',
      preset1h: '1 hour',
      preset6h: '6 hours',
      preset24h: '24 hours',
      preset7d: '7 days',
      warnEmailNoCreator: 'Email channel cannot deliver if the task creator has no email and override is empty.',
      warnFeishuUser: 'The task creator has no cached Feishu account yet. The system will try to match it from the Feishu directory by xtalpi.com email before delivery.',
      reportSubscriptionTypeTitle: 'Report content update subscription',
      reportSubscriptionTypeDesc: 'Subscribe to report pipeline log updates for this task (literature, patents, clinical trials, web, and report progress).',
      knowledgeMapSubscriptionHint: 'To subscribe by Knowledge Map topic keywords, go to Knowledge Map → Subscription updates.',
      notifyDetailTitle: 'Channel delivery results',
      notifyHint: 'Note',
      notifyDeliveryOk: 'Delivered',
      notifyDeliveryFail: 'Failed',
      notifyAttempted: 'Delivery attempted',
      webhookUrlPlaceholder: 'https://open.feishu.cn/open-apis/bot/v2/hook/...',
      runTimeRange: '{start} → {end}',
      totalNewLogs: '{n} log(s) in window',
      matchedItems: '{n} matched',
      externalHits: 'external {n}/{raw}',
      reportLogHits: 'report {n} valid',
      notifyNoDetailHint: 'No per-channel delivery details (channels off or nothing to push).',
      categoriesMutualHint: '“All” is exclusive with specific dimensions: choosing “All” keeps only that; choosing a specific category clears “All”.',
      saveBeforeAction: 'You have unsaved changes. Save before running a scan or testing notifications.'
    }
  },
  targetReportDetail: {
    title: 'Task Details',
    backToList: 'Back to List',
    interactiveEdit: 'Interactive edit',
    basicInfo: 'Basic Information',
    taskName: 'Task Name',
    taskDescription: 'Task Description',
    reportName: 'Report Name',
    reportDescription: 'Report Description',
    targetName: 'Target Name',
    status: 'Status',
    createdAt: 'Created At',
    reportDuration: 'Task Duration',
    priority: 'Priority',
    inputTokens: 'Input Tokens',
    outputTokens: 'Output Tokens',
    totalTokens: 'Total Tokens',
    xCoinConsumption: 'X-Coin Consumption',
    resourceConsumption: 'Resource Consumption',
    tokenConsumption: 'Token Consumption',
    searchConsumption: 'Search Consumption',
    model: 'Model',
    searchCredits: 'Search Credits',
    outline: 'Report Outline',
    questionsAndAnswers: 'Q&A Details',
    question: 'Question',
    answer: 'Answer',
    dataDownload: 'Data Download',
    chineseReport: 'Chinese Report',
    englishReport: 'English Report',
    markdownDoc: 'Markdown Document',
    metadataTable: 'Metadata Table',
    downloading: 'Downloading...',
    download: 'Download',
    regenerate: 'Regenerate',
    regenerateConfirm: 'This operation will regenerate the report and consume approximately {cost} X-Coin. Do you want to continue?',
    regenerateConfirmTitle: 'Confirm Regeneration',
    regenerateSuccess: 'Report generation request submitted, please check progress later',
    regenerateError: 'Failed to regenerate report, please try again later',
    reportNotReady: 'Report is not ready yet, please try again later',
    noQuestionsAnswers: 'No Q&A information',
    noDownloadData: 'No download data available',
    reportRating: 'Report rating',
    regenerateMessage: 'Regenerate report for task "{name}"',
    priority: {
      high: 'High',
      medium: 'Medium',
      low: 'Low'
    },
    status: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled'
    },
    messages: {
      invalidTaskId: 'Invalid task ID, please re-enter',
      noPermission: 'You do not have permission to view this target, it may have been created by another user',
      targetNotFound: 'Target does not exist or has been deleted',
      loadTargetFailed: 'Failed to load target information, please try again later',
      pdfDownloadStarted: 'PDF report download started',
      downloadLinkFailed: 'Failed to get download link',
      downloadReportFailed: 'Download report failed: {msg}',
      fileDownloadStarted: '{fileType} download started',
      downloadFileFailed: 'Download {fileType} failed: {msg}'
    }
  },
  chat: {
    files: 'Files',
    quickReplyConfirm: 'Confirm',
    quickReplyConfirmTip: 'Click to reply "Confirm"',
    close: 'Close Chat',
    start: 'Start Chat',
    selectTaskToStart: 'Please select a task to start chatting',
    uploadTip: 'Upload file (max {maxSize}MB)',
    upload: 'Upload',
    fileList: 'Files',
    thinking: 'AI is thinking, please wait...',
    creatingTask: 'Creating the task, please wait...',
    generatingOutline: 'Generating the outline, please wait...',
    documentAnalysis: 'Analyzing referenced documents, please wait...',
    confirmingOutline: 'Confirming the outline, please wait...',
    preparingReport: 'Opening report generation confirmation...',
    submittingReport: 'Submitting the report generation task...',
    inputPlaceholder: 'Type your question...',
    inputRequired: 'Please enter a question',
    inputTips: 'Press Ctrl/Cmd + Enter to send, Enter for new line',
    switchModel: 'Switch Model',
    send: 'Send',
    newline: 'New Line',
    getStarted: 'Start chatting with AI to learn more',
    resize: {
      leftMin: 'Left panel has reached minimum width',
      rightMin: 'Right panel has reached minimum width'
    },
    welcomeMessage: 'Here I can help you deep analyze and chat about the selected task:',
    quickQuestion1: 'Please introduce the basic information of this target',
    quickQuestion2: 'Analyze the market prospects of this target',
    quickQuestion3: 'What are the competitive advantages of this target',
    quickQuestionText1: 'Please introduce the basic information of this target',
    quickQuestionText2: 'Analyze the market prospects of this target',
    quickQuestionText3: 'What are the competitive advantages of this target',
    start: 'Start Chat',
    close: 'Close Chat',
    selectTaskToStart: 'Please select a task to start chatting',
    modelSwitch: {
      title: 'Friendly Reminder',
      message: 'You have successfully switched to 【{modelName}】. The X-Coin consumption per generation may vary.',
      confirmButtonText: 'OK'
    },
    templateLoaded: 'Template loaded: {name}{targetInfo}. Send or edit before sending.',
    newTargetSuffix: ' (New target: {target})',
    newResearchObjectSuffix: ' (Research object: {object})',
    createTaskSuccess: 'New task created: {name}',
    createTaskFailed: 'Failed to create task: {msg}',
    emptyReply: 'Received empty reply, please retry'
  },
  // @document mention feature
  docMention: {
    selectDocument: 'Select Document',
    searchPlaceholder: 'Search files...',
    tipSelectDoc: 'Select documents for AI to answer questions based on their content',
    selectedDocs: 'Selected',
    clearAll: 'Clear',
    noFiles: 'No files associated with this task',
    noMatchedFiles: 'No matching files',
    maxSelectReached: 'Maximum {max} documents can be selected',
    // Quick action buttons
    quickActions: 'Quick Actions',
    quickPrompts: 'Quick Prompts',
    summarize: 'Summarize',
    translateZh: 'To Chinese',
    translateEn: 'To English',
    analyze: 'Deep Analysis',
    extract: 'Extract Points',
    qa: 'Q&A',
    moreTemplates: 'More',
    // More template options
    outline: 'Generate Outline',
    keypoints: 'Extract Key Points',
    compare: 'Compare Analysis',
    rewrite: 'Rewrite',
    expand: 'Expand Content',
    simplify: 'Simplify',
    // Prompt template content
    tplSummarize: 'Please provide a comprehensive summary of the above document, including:\n1. Core theme and main points\n2. Key conclusions and findings\n3. Important data and facts\nPlease summarize in clear and concise language.',
    tplTranslateZh: 'Please accurately translate the above document content into Chinese:\n1. Maintain the original structure and format\n2. Use standard translations for technical terms\n3. Ensure natural and fluent language',
    tplTranslateEn: 'Please accurately translate the above document content into English:\n1. Maintain the original structure and format\n2. Use professional terminology\n3. Ensure idiomatic and fluent language',
    tplExtract: 'Please extract the following information from the above document:\n1. Key data and metrics\n2. Important conclusions and findings\n3. Core viewpoints and arguments\n4. Notable details\nPresent in a structured format.',
    tplAnalyze: 'Please provide an in-depth analysis of the above document, including:\n1. Evaluation of main arguments and evidence\n2. Logical structure and reasoning process\n3. Potential issues and shortcomings\n4. Possible improvement suggestions',
    tplQa: 'I would like to ask questions about the above document. Please first tell me what this document is mainly about, then I will ask specific questions.',
    tplOutline: 'Please generate a detailed outline for the above document, including:\n1. Main title\n2. Subheadings for each section/paragraph\n3. Core content summary for each part\nDisplay with clear hierarchical structure.',
    tplKeypoints: 'Please extract 5-10 most important key points from the above document, summarize each point in one sentence, and explain its significance.',
    tplCompare: 'Please analyze the above document content and compare it with similar research/reports, pointing out its unique aspects, advantages and shortcomings.',
    tplRewrite: 'Please rewrite and polish the above document content:\n1. Make the language more fluent and professional\n2. Make the structure clearer and more logical\n3. Make the expression more precise\nKeep the original meaning intact.',
    tplExpand: 'Please expand on the core viewpoints of the above document, supplementing with relevant background knowledge, case analysis and in-depth interpretation.',
    tplSimplify: 'Please re-explain the above document content in simple and easy-to-understand language, making it comprehensible for non-professionals, avoiding technical jargon.',
    // Input related
    referencedDocs: 'Referenced',
    inputWithDocPlaceholder: 'Enter questions or instructions about the referenced documents...',
    hint: "Type {'@'} to reference documents",
    defaultPrompt: 'Please help me analyze these documents: {files}',
    fileNotIndexed: 'This file is still indexing or failed. Try again later.',
    fileNotIndexedWithName: 'These files are not ready yet: {files}'
  },
  home: {
    inputPlaceholder: 'Type your request, then press Ctrl/Cmd + Enter to send',
    askEpixoraPlaceholder: 'Ask epiXora, e.g. latest research progress of HER2 in breast cancer',
    expertModePlaceholder: 'Enter a deep research topic or target, e.g.: PD-L1 or Alzheimer\'s latest progress',
    writeModePlaceholder: 'Describe your writing needs or upload references, e.g.: summarize key findings',
    greetingMorning: 'Good morning, {name}!',
    greetingAfternoon: 'Good afternoon, {name}!',
    greetingEvening: 'Good evening, {name}!',
    greetingDesc: 'You can ask a question first, or choose documents to conduct in-depth analysis.',
    modes: {
      quick: 'Quick Mode',
      expert: 'Expert Mode',
      write: 'Writing Mode'
    },
    nav: {
      home: 'Target analysis',
      homeShort: 'Home',
      homeDesc: 'New chat, three modes, report preview, and history',
      knowledgeBase: 'Knowledge base',
      knowledgeBaseShort: 'Library',
      knowledgeBaseDesc: "Upload docs, folders, and {'@'} cite in chat",
      knowledgeMap: 'Knowledge map',
      knowledgeMapShort: 'Map',
      knowledgeMapDesc: 'Topic Wiki, mind map, outline, and 3D graph',
      quickTools: 'Quick tools',
      quickToolsShort: 'Tools',
      quickToolsDesc: 'Batch topic research and template library'
    }
  },
  historyDrawer: {
    title: 'Research History',
    newChat: 'Start New Chat',
    searchPlaceholder: 'Search by name or task ID',
    empty: 'No research history',
    emptySearch: 'No matching tasks found',
    emptyById: 'Task not found, or you do not have access',
    untitled: 'Untitled task',
    pin: 'Pin to top',
    unpin: 'Unpin',
    delete: 'Delete',
    pinSuccess: 'Pinned',
    pinFailed: 'Pin failed, please try again later',
    unpinSuccess: 'Unpinned',
    unpinFailed: 'Unpin failed, please try again later',
    groups: {
      pinned: 'Pinned',
      today: 'Today',
      yesterday: 'Yesterday',
      within7Days: 'Within 7 days',
      within30Days: 'Within 30 days'
    }
  },
  files: {
    dialogTitle: 'Files of Task',
    emptyTip: 'You can add files for this task via Upload button',
    getListFailed: 'Failed to fetch file list',
    refreshed: 'File list refreshed',
    searchPlaceholder: 'Search filename...',
    selectFirst: 'Please select files first',
    alreadyBoundSelected: 'Selected files are already bound',
    bindSuccessWithCount: 'Successfully bound {count} files',
    bindFailed: 'Failed to bind files',
    unsupportedType: 'Unsupported file type. Please upload PDF, DOC, DOCX, PPT, PPTX, TXT, MD, CSV, JSON, XML, EML, EPUB, MSG, YAML or PROPERTIES',
    sizeExceeded: 'File size must not exceed {max}',
    uploadSuccessBindFailed: 'File uploaded but failed to bind to task: {msg}',
    uploadFailed: 'File upload failed',
    previewFailed: 'Failed to preview file',
    removeConfirmTitle: 'Confirm Remove',
    removeConfirmMessage: 'Remove file "{name}" from this task?',
    removeSuccess: 'File removed',
    removeFailed: 'Failed to remove file',
    downloadFailed: 'Failed to download file',
    cloudFilesLimit: 'Cloud storage limit reached ({max} files). Please delete some files before uploading',
    taskFilesLimit: 'Knowledge base/session file limit reached ({max} files). Please delete some files before uploading',
    uploadPending: 'No target selected. File uploaded but not bound',
    checkUploadFailed: 'Failed to check upload conditions. Please try again',
    indexStatus: {
      ready: 'Ready',
      pending: 'Indexing',
      failed: 'Failed',
      unknown: 'Unknown'
    },
    uploadSuccessIndexing: '"{name}" added. Indexing in progress (about 1–3 min).',
    kbAutoCreateSuccess: 'Synced to knowledge folder "{topic}"',
    kbBindSuccess: 'Added {count} file(s) from knowledge base',
    loadKbListFailed: 'Failed to load knowledge base list',
    loadKbFilesFailed: 'Failed to load knowledge base files',
    cleared: 'Attachments cleared',
    difySync: {
      successTitle: 'Knowledge Base Synced',
      successMessage: 'File "{fileName}" has been successfully synced to knowledge base',
      failedTitle: 'Knowledge Base Sync Notice',
      failedMessage: 'File "{fileName}" uploaded to system, but failed to sync to knowledge base',
      errorTitle: 'Knowledge Base Sync Failed',
      errorMessage: 'An error occurred while syncing file "{fileName}" to knowledge base',
      batchTaskCreatedTitle: 'Batch Upload Task Created',
      batchTaskCreatedMessage: 'Processing in background, please check the results later'
    }
  },
  urlUpload: {
    title: 'Upload File via URL',
    subtitle: 'Support file URLs and website URLs',
    fileUrlLabel: 'File/Website URL',
    fileUrlPlaceholder: 'Enter file URL or website URL, e.g.: https://example.com/document.pdf',
    customFilenameLabel: 'Custom Filename (Optional)',
    customFilenamePlaceholder: 'e.g.: Research Report.pdf (auto-detect from URL if not provided)',
    customFilenameRequiredPlaceholder: 'Enter filename, e.g.: Website Content.txt',
    formatHint: 'Supported: PDF, Word, Excel, TXT, Markdown files, or any website URL',
    websiteFilenameHint: 'Website URL requires filename',
    tip1: 'Support direct file URLs or website URLs',
    tip2: 'File size must not exceed {size}MB',
    cancel: 'Cancel',
    submit: 'Start Upload',
    uploading: 'Uploading...',
    validation: {
      required: 'Please enter file URL or website URL',
      invalidProtocol: 'Please use HTTP or HTTPS protocol',
      noExtension: 'No file extension detected, please ensure URL contains complete file path',
      invalidFormat: 'Invalid URL format',
      websiteUrl: 'ℹ Website URL - Please specify filename',
      fileUrl: '✓ File URL - Valid format',
      filenameRequired: 'Website URL requires filename'
    }
  },
  voice: {
    notSupported: 'Your browser does not support audio recording',
    recognitionSuccess: 'Speech recognized',
    recognitionFailed: 'Speech recognition failed. Please record again or type your message',
    balanceCheckFailed: 'Balance check failed. Please try again later',
    startRecording: 'Recording…',
    startRecordingFailed: 'Failed to start recording. Check microphone permissions',
    stopRecording: 'Recording stopped'
  },
  tenant: {
    switchSuccess: 'Tenant switched. Refreshing data…',
    getUserFailed: 'Cannot load user info. Tenant switch is unavailable',
    getUserError: 'Failed to load user info. Tenant switch is unavailable',
    dialogOpenFailed: 'Failed to open tenant switcher. Please refresh the page'
  },
  examples: {
    try: 'Try:',
    sample1: 'What is the market size of PRMT5 target',
    sample2: 'Draft a report on new obesity drug targets and challenges'
  },
  form: { enterTaskName: 'Please enter task name' },
  boundaryClarify: {
    tip: 'Please choose the scope for this research:',
    target: 'Target research',
    overall: 'Overall research'
  },
  moduleSelect: {
    tip: 'Select the report modules you need. Multiple selections and custom modules are supported:',
    confirm: 'Start research'
  },
  report: {
    generating: 'Generating analysis report...',
    generatingReport: 'Generating analysis report...',
    completed: 'Completed',
    failed: 'Failed',
    queueing: 'Pending',
    target: {
      noReportContent: 'No report content yet'
    },
    outlineConfirmedWithTarget: 'Great, outline confirmed. Submitting the research report generation task for [{target}]. The process is AI-driven, including literature, patents, clinical trials and web search collection/analysis, multi-agent outline and section drafting with deep refinement. Estimated time about 30–60 minutes; please wait patiently. You may close this window; the task will continue in the background.',
    outlineConfirmedNoTarget: 'Great, outline confirmed. Submitting the report generation task. Title: {topic}, Keywords: {keywords}. The process is AI-driven, including literature, patents, clinical trials and web search collection/analysis, multi-agent outline and section drafting with deep refinement. Estimated time about 30–60 minutes; please wait patiently. You may close this window; the task will continue in the background.',
    preparingNoTarget: 'Preparing to generate the report. Title: {topic}, Keywords: {keywords}. The process is AI-driven, including literature, patents, clinical trials and web search collection/analysis, multi-agent outline and section drafting with deep refinement. Estimated time about 30–60 minutes; please wait patiently. You may close this window; the task will continue in the background.',
    startGeneratingWithTarget: 'Okay, start generating the research report for [{target}]. The process is AI-driven, including literature, patents, clinical trials and web search collection/analysis, multi-agent outline and section drafting with deep refinement. Estimated time about 30–60 minutes; please wait patiently. You may close this window; the task will continue in the background.',
    cancelledInsufficient: 'Report generation cancelled due to insufficient X-Coin balance. Please recharge and try again.',
    cancelledByUser: 'Report generation has been cancelled.',
    cancelSuccess: 'Report generation cancelled',
    cancelNotSupported: 'Cancellation is not supported in the current status',
    cancelFailed: 'Cancellation failed. Please try again later.',
    targetNotFound: 'Task does not exist or has been deleted',
    outlineMissing: 'No available outline found. Please confirm and try again.',
    generateFailed: 'Failed to generate report. Please try again later.',
    generateTitle: 'Generate Analysis Report',
    generateConfirm: 'Generate report for "{name}"? **This may incur high cost**.',
    taskStarted: 'Report generation started',
    generationFailed: 'Failed to generate report',
    generateReportFailed: 'Report generation failed. Please try again',
    fileMissing: 'Report file missing or download link unavailable',
    downloadFailed: 'Download failed: {msg}',
    downloadReportFailed: 'Failed to download report',
    prepareTimeout: 'Preparation timed out. The file may be large; please retry later or contact admin',
    loadPreviewFailed: 'Failed to load report preview',
    saveToServerMayFailed: 'Report content may not have been saved to server, please check',
    saveContentFailed: 'Failed to save report content, changes only kept locally',
    emptyReply: 'Received empty reply, please retry',
    createTargetFailed: 'Failed to create task: {msg}',
    // Partial Report Related
    partialPreview: 'Partial Preview',
    currentPreview: 'Current Preview:',
    pageUnit: 'page(s)',
    remainingPages: '{count} page(s) remaining locked, recharge to view full report',
    unlockNow: 'Unlock Now',
    partialReportTitle: 'You are viewing a partial report',
    partialReportDesc: '{count} page(s) remaining unread, recharge to view and download the full report',
    unlockFullReport: 'Recharge to Read Full Report',
    unlockCostHint: 'Unlock cost: {cost} X-Coin',
    reportName: 'Report name',
    totalPages: 'Total pages',
    viewedPages: 'Viewed',
    consumed: 'Cost this time',
    deducted: 'Deducted',
    remainingCost: 'Still needed',
    unlockTip: 'After unlocking, you can view and download the full report.',
    confirmUnlock: 'Unlock now',
    unlockConfirmMessage: 'Use {cost} X-Coin to unlock the full report?',
    unlockSuccess: 'Unlocked successfully!',
    unlockFailed: 'Unlock failed. Please try again later.',
    // Download Related
    downloadReport: 'Download',
    downloading: 'Downloading',
    downloadBrief: 'Export Brief',
    downloadFormats: {
      pdf: 'PDF Format',
      word: 'Word Format',
      markdown: 'Markdown Format',
      html: 'HTML Format'
    },
    downloadMessages: {
      preparing: 'Preparing to download {format} report...',
      pdfStarted: 'PDF download started',
      wordStarted: 'Word download started',
      markdownStarted: 'Markdown download started',
      htmlStarted: 'HTML download started',
      pdfOpenedIOS: 'PDF opened in new window, please save the file using browser functions',
      pdfWordStaleHint: 'Report content has been modified and saved. Current PDF/Word is the original version. For latest content, download Markdown or use the editor Export.'
    },
    // Audit Rejected Notice
    rejected: {
      title: 'Hello, our system has identified that the AI-generated report from this request may contain information unsuitable for distribution. Therefore, it cannot be previewed or downloaded.',
      description: 'Available Options:',
      adjustRequest: 'Adjust Your Request',
      adjustRequestDesc: 'You may modify your task description or input and try regenerating.',
      requestReview: 'Request a Review',
      requestReviewDesc: "If you believe this is an error or require further assistance, you can contact us via epixora{'@'}xtalpi.com."
    },
    // Markdown Editor Related
    pdfPreview: 'PDF Preview',
    mdEditor: 'Markdown Editor',
    loadMd: 'Load MD Report',
    loadMdSuccess: 'Markdown report loaded successfully',
    loadMdFailed: 'Failed to load Markdown report',
    noTargetSelected: 'Please select a task first',
    noPdfAvailable: 'No PDF report available',
    editMode: 'Edit',
    previewMode: 'Preview',
    splitMode: 'Split',
    export: 'Export',
    exportMd: 'Export as Markdown',
    exportHtml: 'Export as HTML',
    exportSuccess: 'Export successful',
    noContentToExport: 'No content to export',
    markdown: 'Markdown',
    preview: 'Preview',
    modified: 'Modified',
    editorPlaceholder: 'Enter or paste Markdown content here...',
    emptyEditorTip: 'Click the button below to load report content, or directly enter Markdown content in the editor',
    emptyTitle: 'Start Editing Report',
    // Text Selection Related
    loadMdTip: 'Load Markdown format report from server',
    editModeTip: 'Show editor only',
    previewModeTip: 'Show preview only (select text to send to chat)',
    splitModeTip: 'Show both editor and preview',
    selectedChars: '{count} characters selected',
    sendToChat: 'Send to Chat',
    sendToChatTip: 'Send selected content as context to chat',
    sentToChat: 'Sent to chat',
    noTextSelected: 'Please select text to send first',
    selectTextTip: 'Select text to send as context to chat',
    canSelectText: 'Selectable',
    copyText: 'Copy Text',
    copySuccess: 'Copied to clipboard',
    more: 'More',
    selectAll: 'Select all',
    versionHistory: 'Version History',
    reportVersionHistory: 'Report Version History',
    versionCountUnit: 'versions',
    versionLatest: 'Latest archive',
    versionArchiveTip: 'Before each save or rollback, a pre-change snapshot is archived (not the current online copy) so you can compare it with today’s content.',
    versionLabel: 'Version',
    versionRemark: 'Note',
    versionSize: 'Size',
    versionViewCompare: 'View & compare',
    versionRestore: 'Restore this version',
    versionRestoreConfirm: 'Restore this version? Unsaved edits will be lost.',
    versionNoHistory: 'No version history yet',
    versionNoHistoryHint: 'After you edit and save, a pre-save snapshot is archived here for comparison with the current online version.',
    versionRefresh: 'Refresh version list',
    versionListLoadFailed: 'Could not load version history',
    versionContentLoadFailed: 'Could not load version content',
    versionManualSaveSuccess: 'Report saved manually; a new archive was created.',
    versionManualSaveFailed: 'Manual save failed. Please try again.',
    versionRollingBack: 'Restoring version {id}…',
    versionRollbackSuccess: 'Restored to version {id}.',
    versionRollbackFailed: 'Failed to restore version. Please try again.',
    versionTypeRollback: 'Rollback',
    versionTypeManual: 'Manual save',
    versionTypeAutosave: 'Auto-save',
    versionTypeHallucinationFix: 'Hallucination fix',
    versionTypeHallucinationNoRewrite: 'Hallucination check (no rewrite)',
    versionTypeBaseline: 'Generated draft',
    versionRestoreBaselineDraft: 'Restore generated draft',
    versionRestoreBaselineEarliest: 'Restore earliest archive',
    versionRestoreBaselineConfirmDraft: 'Restore the generated draft? Unsaved edits will be lost.',
    versionRestoreBaselineConfirmEarliest: 'No generated draft snapshot exists. Restore the earliest archived version ({versionId})? Unsaved edits will be lost; content may differ from the original generated report.',
    versionBaselineTagDraft: 'Generated draft',
    versionBaselineTagEarliest: 'Earliest archive',
    versionBaselineMissing: 'No restorable version found',
    versionBaselineRestoreSuccessDraft: 'Restored to generated draft',
    versionBaselineRestoreSuccessEarliest: 'Restored to earliest archive',
    versionCompareTitle: 'Version comparison',
    versionCompareSubtitle: '{id} · {summary}',
    versionCompareBaselineHint: 'Comparing archive {id} ↔ editor content (may include unsaved edits)',
    versionDiffLegend: '− History  + Current',
    versionDiffCompactOnly: 'Changed lines only',
    versionDiffHideWhitespace: 'Hide blank changes',
    versionDiffShowWhitespace: 'Show blank changes',
    versionDiffHideCitationRenumber: 'Hide citation renumber',
    versionDiffShowCitationRenumber: 'Show citation renumber',
    versionNoChangesHint: 'This archive matches the editor content; try an earlier version to see past edits.',
    versionRenderCompare: 'Rendered compare',
    versionDiffHighlight: 'Diff highlight',
    versionPrevChange: 'Previous',
    versionNextChange: 'Next',
    versionChangePos: '{current} / {total}',
    versionChangesTitle: 'Change summary',
    versionDiffFromLine: 'From line #{line}',
    versionNoChanges: 'Both versions are identical',
    versionCurrentOnline: 'Current online version',
    versionCurrentEditor: 'Current editor version',
    versionHistoryPane: 'History version ({id})',
    versionClosePreview: 'Close preview',
    versionRestoreNow: 'Restore this version now',
    modelGroupRecommended: 'Recommended',
    modelGroupMembership: 'Membership tier',
    modelGroupOther: 'Other available',
    switchModelTitle: 'Switch model: {model}',
    hallucinationModeSections: 'Sections',
    hallucinationSectionsTooltip: 'Select one or more report sections for partial detection',
    hallucinationNoSectionsTooltip: 'No detectable sections — use full text or selected content',
    hallucinationSelectSections: 'Select sections to detect',
    hallucinationSectionsSelected: '{count} selected · {chars} chars',
    hallucinationNoMarkdownSections: 'No Markdown heading sections found — use full text or select a passage.',
    hallucinationSectionPreview: 'Section content preview',
    hallucinationSelectSectionHint: 'Select at least one valid section, or switch to full-text mode.',
    hallucinationSectionCount: '{count}',
    hallucinationModeTabLabel: 'Detection mode',
    selectedContentPreview: 'Content to detect',
    hallucinationSelectRange: 'Please select the detection scope',
    hallucinationSelectedIntro: 'Select a sentence in the report, then click hallucination detection in the toolbar or above to run a targeted check on the selected content.',
    hallucinationFullTextLogic: 'Flow: reference verification, task decomposition, and intelligent review, then output evidence-backed findings with source traceability.',
    editorReadonlyHint: 'Read-only: no permission to edit this report',
    regenerateDiffTab: 'Line diff',
    regenerateSideTab: 'Side by side',
    diffLinesRemoved: '−{n} lines',
    diffLinesAdded: '+{n} lines',
    diffLinesSame: '{n} unchanged',
    diffHunkCount: '{n} change blocks',
    diffHunkCountHint: 'Line-level diff blocks in version compare; may include citation renumbering, whitespace, and layout—not the same as hallucination fix count',
    versionHallucinationAppliedCount: '{n} fix(es) applied',
    diffWhitespaceHunkHint: 'Blank blocks hidden {hidden}/{total}',
    diffCitationRenumberHunkHint: 'Citation renumber hidden {hidden}/{total}',
    manualSave: 'Save Manually',
    saveCurrentReport: 'Save current report content',
    reloadFromServer: 'Reload report from server',
    addToMapShort: 'Add to Map',
    addToMapTip: 'Add selected content to knowledge map',
    copyFailed: 'Copy failed',
    highlightText: 'Highlight',
    highlightAdded: 'Highlight added',
    highlightRemoved: 'Highlight removed',
    // Q&A and Regenerate related
    ask: 'Smart Ask',
    interactiveEdit: 'Interactive edit',
    askAboutThis: 'Ask about selected content',
    askDialogTitle: 'Ask About Content',
    askDialogSubtitle: 'Deep analysis based on selected content',
    selectedContent: 'Selected Content',
    yourQuestion: 'Your Question',
    questionLabel: 'Question',
    questionPlaceholder: 'Enter your question, e.g., What are the main points of this content?',
    quickQuestions: 'Quick questions:',
    quickQ1: 'What are the main points of this content?',
    quickQ2: 'Please explain the key terms in this content',
    quickQ3: 'What are the shortcomings of this content?',
    quickQ4: 'How can this content be improved?',
    aiGenerated: 'AI Suggested',
    refreshQuestions: 'Refresh question suggestions',
    aiResponse: 'AI Response',
    submitQuestion: 'Submit Question',
    questionSubmitted: 'Question submitted',
    questionFailed: 'Question failed, please retry',
    answerSyncedToChat: 'Answer synced to chat, you can continue asking',
    questionSentToChat: 'Question sent to chat',
    questionSentToDock: 'Question sent to report Q&A. See progress below',
    reportQaDockTitle: 'Report selection Q&A',
    reportQaDockHint: 'Q&A on selected report content; history is restored after refresh',
    reportQaDockPending: 'Task submitted. Generating answer...',
    detectionDetail: 'Detection details',
    latestRecord: 'Latest',
    historyRecord: 'History',
    retrySaveIssues: 'Retry save',
    hallucinationDetailInReport: 'See the comparison table and fix actions in the report preview on the right',
    hallucinationPreviewNotReady: 'Report preview is not ready. Please ensure the report panel on the right is loaded and try again.',
    hallucinationPreviewOpenReport: 'Report preview is not ready. Please open the report panel on the right and try again.',
    hallucinationDataLoadFailed: 'Failed to load hallucination detection data. Please refresh and try again.',
    hallucinationEmbedResultTitle: 'Hallucination check (in-report fixes)',
    hallucinationSectionsTruncatedHint: 'Many sections — showing first 24. Switch section mode in the report panel to view all',
    fixSuggestionCompare: 'Fix suggestion comparison',
    expandIssueEvidence: 'Expand issue details and evidence',
    hallucinationKeptOriginal: 'Original wording kept',
    hallucinationNoPendingItems: 'No pending items',
    hallucinationNoApplicablePending: 'No applicable pending items (failed quality checks or unlocatable items were skipped)',
    hallucinationNoLocatablePending: 'No locatable pending items',
    hallucinationNoFixSuggestion: 'No fix suggestion for this issue. Please edit manually',
    hallucinationSentenceNotLocated: 'Could not locate the original sentence. Use Interactive Edit for multi-turn fixes',
    hallucinationUndoMissingAnchor: 'Cannot undo: missing restore anchor. Use Undo in the report editor toolbar',
    hallucinationUndoLocateFailed: 'Undo failed: could not locate restore position in the report',
    hallucinationUndoSuccess: 'This fix was undone successfully',
    hallucinationRestoredToPending: 'Restored to pending',
    hallucinationReportUpdated: 'Updated {count} place(s) in the report{refHint}',
    hallucinationApplyFixFailed: 'Failed to apply fix. Please try again later',
    hallucinationUndoApplyFailed: 'Failed to undo applied fix',
    hallucinationPartialApplyFailed: 'Some items failed to apply. Please edit manually',
    hallucinationFixValidationFailed: 'Fix suggestion did not pass validation',
    hallucinationSuggestionValidationTitle: 'Suggestion validation',
    hallucinationApplyAnywayConfirm: 'Apply this fix anyway?',
  // Report Q&A thinking steps
    qaStep1: 'Analyzing selected content',
    qaStep2: 'Understanding user question',
    qaStep3: 'Intelligent reasoning',
    qaStep4: 'Generating answer',
    qaAnalyzing: 'Analyzing content...',
    qaUnderstanding: 'Understanding question...',
    qaReasoning: 'Reasoning...',
    qaGenerating: 'Generating answer...',
    qaCompleted: 'Answer generated',
    // Q&A thinking process related
    thinkingProcess: 'AI Thinking Process',
    thinkingText: 'Thinking...',
    thinkingStep1Title: 'Parse Question',
    thinkingStep1Detail: 'Analyze user question intent',
    thinkingStep2Title: 'Retrieve Context',
    thinkingStep2Detail: 'Locate key information in selected content',
    thinkingStep3Title: 'Intelligent Reasoning',
    thinkingStep3Detail: 'Generate answer based on professional knowledge',
    thinkingStep4Title: 'Optimize Output',
    thinkingStep4Detail: 'Format and organize answer content',
    regenerate: 'Regenerate',
    regenerateThis: 'Regenerate selected content',
    rewriteIntent: 'Rewrite intent',
    regenerateDialogTitle: 'Smart Rewrite',
    regenerateDialogSubtitle: 'AI-powered content optimization',
    originalContent: 'Original Content',
    customInstruction: 'Custom Instruction',
    regenerateInstruction: 'Modification Requirements',
    regeneratePlaceholder: 'Describe how you want to modify this content, e.g., make it more detailed, concise, or add data support',
    regenerateStyle: 'Rewrite Style',
    styleDetailed: 'More Detailed',
    styleConcise: 'More Concise',
    styleProfessional: 'More Professional',
    styleCustom: 'Custom',
    regeneratedContent: 'Rewrite Result',
    applyChange: 'Apply Change',
    discard: 'Discard',
    startRegenerate: 'Start Generation',
    chars: 'chars',
    contentTooLong: 'Selected content is too long. Please select a shorter range and try again.',
    regenerateSubmitted: 'Generation request submitted',
    regenerateFailed: 'Regeneration failed, please retry',
    cancelRegenerate: 'Cancel Generation',
    regenerateCancelled: 'Generation cancelled',
    changeApplied: 'Change applied',
    optimizingOutputFormat: 'Optimizing output format...',
    // Optimization additions
    undoChange: 'Undo last change',
    undoSuccess: 'Change undone',
    retry: 'Retry',
    generating: 'Generating response...',
    generatingContent: 'Generating content...',
    noResponseReceived: 'No response received, please try again',
    noTargetForQA: 'Please select a target first',
    noContentGenerated: 'No content generated, please retry',
    noTargetForRegenerate: 'Please select a target first',
    noContentToRegenerate: 'No content selected',
    pleaseEnterQuestion: 'Please enter a question',
    noSelectedContent: 'Please select content to ask about first',
    minCharsForQA: 'Please select at least 10 characters',
    minCharsForRegenerate: 'Please select at least 10 characters of content before regenerating',
    // Hallucination detection
    detectHallucination: 'Hallucination Check',
    hallucinationCheck: 'Hallucination Check',
    hallucinationDialogTitle: 'Hallucination Detection',
    hallDockTitle: 'Hallucination fix chat',
    hallucinationStepSelectShort: 'Select',
    hallucinationStepConfirmShort: 'Confirm',
    hallucinationStepRunningShort: 'Detect',
    hallucinationStepResultShort: 'Result',
    hallucinationStepSelect: 'Select scope',
    hallucinationStepConfirm: 'Confirm cost',
    hallucinationStepRunning: 'Analyzing',
    hallucinationStepFailed: 'Failed',
    hallucinationStepResult: 'Results',
    hallucinationPollingStoppedHint: 'Waiting stopped. The task continues in background. Refresh to view latest result.',
    autoTrack: 'Auto track',
    autoTrackRunning: 'Auto tracking',
    autoTrackLoaded: 'Latest result loaded',
    autoTrackTimeout: 'Auto tracking timeout',
    autoTrackDisabled: 'Auto tracking off',
    manual: 'Manual',
    viewLatestResult: 'View latest result',
    copy: 'Copy',
    refreshNow: 'Refresh now',
    stopWaitingKeepRunning: 'Stop waiting (runs in background)',
    backToReport: 'Back to report',
    detecting: 'Detecting...',
    contentInsufficient: 'Insufficient content',
    featureRestricted: 'Feature restricted',
    hallucinationCostHint: 'Estimated ~800 X-Coin',
    waited: 'Elapsed',
    issuesCount: 'issues',
    hallucinationAppliedShort: 'Applied {count} item(s)',
    hallucinationIssueDetails: 'Issue details & fixes',
    detectedIssues: 'Detected issues',
    severityHigh: 'High',
    severityMedium: 'Medium',
    severityLow: 'Low',
    hallucinationTableHeadline: 'Found {count} potential issue(s)',
    hallucinationTableHeadlineFull: 'Found {count} potential issue(s). Review and choose whether to replace.',
    hallucinationTableHeadlineMixed: 'Confirmed {refuted}, review {uncertain}',
    hallucinationTableHeadlineMixedFull: 'Confirmed {refuted}, review {uncertain}. Choose whether to replace.',
    hallucinationIssueCountMixed: 'Confirmed {refuted}, review {uncertain}',
    hallucinationIssueCountRefuted: 'Confirmed {count}',
    hallucinationIssueCountUncertain: 'Review {count}',
    hallucinationIssueCountTotal: '{count} issue(s)',
    hallucinationAppliedBanner: 'Applied {count} change(s)',
    hallucinationAppliedBannerFull: 'Applied {count} change(s); report updated',
    hallucinationColNo: 'No.',
    hallucinationColProblem: 'Problematic',
    hallucinationColContext: 'Context',
    hallucinationColSuggestion: 'Suggested',
    hallucinationColAction: 'Action',
    hallucinationColTools: 'Tools',
    hallucinationActionReplace: 'Replace',
    hallucinationActionDelete: 'Delete',
    hallucinationActionKeep: 'Keep',
    hallucinationProcessBtn: 'Process',
    hallucinationBatchProcess: 'Batch process',
    hallucinationBatchReplaceAll: 'Replace all',
    hallucinationBatchKeepAll: 'Keep all',
    hallucinationBatchDeleteAll: 'Delete all',
    hallucinationBatchHint: 'Choose replace/delete then Apply row, or Dismiss to leave text unchanged. Batch: replace-all / delete-all / trusted-only.',
    hallucinationApplyingFixes: 'Applying fixes in background. Please keep this page open.',
    hallucinationApplying: 'Applying fixes',
    hallucinationApplyStepValidate: 'Validating fixes…',
    hallucinationApplyStepRewrite: 'Rewriting & renumbering references…',
    hallucinationApplyStepSave: 'Saving report & syncing issues…',
    hallucinationApplyStepSync: 'Syncing detection issues…',
    hallucinationApplyTimeoutHint: 'The task may still be running. Refresh the report or reopen hallucination history shortly.',
    hallucinationApplyPollingStoppedHint: 'Waiting stopped. Fix task still runs in background. Refresh to view result.',
    hallucinationApplyCancelledBackend: 'Waiting stopped. Fix continues in background. Click refresh to check result.',
    refreshApplyResult: 'Refresh fix result',
    hallucinationApplyResultLoaded: 'Fix result loaded',
    hallucinationApplyStillRunning: 'Fix still in progress. Try again later.',
    hallucinationApplyBackgroundDone: 'Background fix completed; report updated',
    hallucinationApplyLocatableOnly: 'Apply locatable only',
    hallucinationApplyTrustedOnly: 'Apply trusted fixes only',
    hallucinationNoTrustedActions: 'No trusted fixes ready to apply',
    hallucinationSpecialistPolished: 'Specialist',
    hallucinationPostRecheckServerOk: 'Server recheck passed for {passed} item(s)',
    hallucinationPostRecheckServerWarning: 'Server recheck: {still}/{candidates} still flagged',
    hallucinationTruncationGuidance: 'Content truncated — select uncovered passages or use section mode',
    hallucinationRecheckRollbackNotice: 'Recheck failed — rolled back {rolled} fix(es)',
    hallucinationRecheckRollbackOnly: 'Fixes rolled back; document unchanged',
    hallucinationContinueWithSections: 'Continue with sections',
    hallucinationContinueWithSectionsHint: '{count} section(s) pre-selected — confirm to continue',
    hallucinationTruncationOpenReportPanel: 'Select in report panel',
    hallucinationTagReplaced: 'Replaced',
    hallucinationTagDeleted: 'Deleted',
    hallucinationTagKept: 'Kept',
    hallucinationTagDismissed: 'Dismissed',
    hallucinationSuggestionTooLong: 'Suggestion too long',
    hallucinationRefRenumbered: 'References renumbered to {count}',
    hallucinationUncitedRemoved: '({count} uncited removed)',
    hallucinationConfirmHintChat: 'After confirmation, progress and results appear in this chat area',
    openHallucinationInNewPage: 'Open in new page',
    openHallucinationReportPage: 'Open Detection Report',
    hallucinationConfirmHint: 'After confirmation, detection progress and results will be shown in this dialog',
    hallucinationConfirmHint: 'After confirmation, detection progress and results will be shown in this dialog',
    hallucinationDetecting: 'Detecting hallucination issues in selected content...',
    hallucinationDetectFailed: 'Hallucination detection failed',
    hallucinationConnectionError: 'Cannot connect to backend. Please check: 1) Backend is running 2) Network/proxy config 3) API URL is correct',
    minCharsForHallucination: 'Please select at least 10 characters, or switch to full-text detection mode',
    hallucinationSelectTip: 'Please select at least 10 characters in the report, or switch to Full-text mode',
    selectContentPlaceholder: 'Please select at least 10 characters in the report preview, or switch to Full-text mode',
    hallucinationLoadingEstimate: 'Usually takes 2-5 minutes, please wait',
    hallucinationErrorRetryHint: 'Please check your network and click Retry below',
    docTooShortForHallucination: 'Report content too short for hallucination detection',
    noHallucinationFound: 'No obvious hallucinations found',
    issuesFound: 'Potential issues detected',
    noIssuesFound: 'No obvious issues found',
    suggestion: 'Suggestion',
    refVerification: 'Reference Verification',
    referenceVerification: 'Reference Verification',
    verified: 'Verified',
    unverified: 'Unverified',
    goToCorrect: 'Go to Correct',
    hallucinationModeLabel: 'Detection Mode',
    hallucinationModeSelected: 'Selected Content',
    hallucinationModeFullText: 'Full Text',
    hallucinationSelectTip: 'Please select at least 10 characters in the report preview',
    hallucinationFullTextTip: 'Multi-agent hallucination detection (task decomposition + Reflection) for the entire report',
    hallucinationSelectedTip: 'Hallucination detection for selected segment',
    selectedContentPreview: 'Content to detect',
    startHallucinationDetect: 'Start Detection',
    refreshHallucinationStatus: 'Refresh status',
    detectHallucinationTip: 'Hallucination detection (multi-agent: task decomposition + Reflection)',
    hallucinationDetectingSteps: 'Detecting (task decomposition + Reflection)...',
    hallucinationStepRefs: 'Verifying references...',
    hallucinationStepDecompose: 'Task decomposing...',
    hallucinationStepReflection: 'Reflection reviewing...',
    hallucinationUpgradeToUse: 'Upgrade membership to use hallucination detection',
    editorFeatureDeniedTier: 'Your membership tier does not include 「{name}」',
    editorFeatureDeniedMenu: 'No menu permission for 「{name}」. Contact your administrator',
    editorFeatureDeniedGeneric: 'You do not have permission to use this feature',
    editorFeatureNameInteractive: 'Interactive edit',
    editorFeatureNameHallucination: 'Hallucination detection',
    editorFeatureNameSelectionQa: 'Selection Q&A',
    editorFeatureNameSelectionRegenerate: 'Selection rewrite',
    editorFeatureNameSelectionAddToMap: 'Selection add to map',
    detectionCompletedIn: 'Completed',
    seconds: 's',
    reDetect: 'Re-detect',
    retryHallucination: 'Retry',
    hallucinationHistory: 'Detection history',
    hallucinationHistoryEmpty: 'No history yet. Click Start Detection below to see results.',
    cancelHallucination: 'Cancel detection',
    hallucinationCancelled: 'Detection cancelled',
    hallucinationCancelledBackend: 'Polling stopped. Detection continues in background. Click refresh to check history.',
    hallucinationTaskDeduped: 'A detection task is already running. Continue waiting for that task to finish.',
    hallucinationStaleTask: 'Detection was interrupted or timed out. Please submit again.',
    hallucinationStaleTaskHint: 'The task was marked interrupted. Refresh detection history for the failure record, or click Retry.',
    hallucinationStaleTaskIdLabel: 'Task ID',
    hallucinationFullscreenCloseConfirm: 'Hallucination detection is in progress. Exiting fullscreen stops waiting (the backend task continues). Exit fullscreen?',
    hallucinationTimeout: 'Detection timed out. Check history for results.',
    hallucinationCanLeaveHint: 'You can leave this page and check history later for results.',
    deductFailedForHallucination: 'Detection completed, but deduction failed. Please recharge.',
    hallucinationConfirmMessage: 'Hallucination detection will consume ~800 X-Coin. Continue?',
    hallucinationConfirmMessageChat: 'Hallucination detection will consume significant tokens. Continue?',
    hallucinationBalanceDialogTitle: 'Hallucination Check Confirmation',
    hallucinationBalanceConfirmTitle: 'Hallucination Check Confirmation',
    hallucinationBalanceConfirmMessage: 'You are about to run a hallucination check. Estimated cost is ~800 X-Coin. Continue?',
    hallucinationBalanceConfirmButton: 'Confirm Hallucination Check',
    hallucinationConfirmBtn: 'Confirm',
    hallucinationSkipBtn: 'Not now',
    hallucinationApplyBtn: 'Apply',
    hallucinationUserRequestFullText: 'Run full-text hallucination check on {report}',
    hallucinationUserRequestSelected: 'Check hallucinations for: 「{text}」',
    hallucinationUserRequestSections: 'Run section-based hallucination check on {report}',
    hallucinationExpandHistory: 'View {count} past check(s)',
    hallucinationCollapseHistory: 'Collapse history',
    hallucinationResultCardTitleFull: 'Results · Full text ({report}): {count} suspected issue(s). Review and choose whether to replace.',
    hallucinationResultCardTitleSelected: 'Results · Selected: {count} suspected issue(s). Review and choose whether to replace.',
    hallucinationLoadingSelected: 'Checking selected sentence...',
    hallucinationLoadingFullText: 'Checking full report...',
    hallucinationReportDefault: 'research report',
    hallucinationColActionFull: 'Replace or keep',
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} hr ago',
    contentTruncatedNotice: 'Content truncated: full text',
    analyzedFirst: 'Only first',
    truncationMayMiss: 'later content may not be covered',
    refVerificationIncomplete: 'Reference verification incomplete; citation checks may be incomplete',
    evidenceEnrichmentNotice: 'Enriched full-text excerpts for {count} reference(s) via knowledge base and internal indexes',
    hallucinationUncertainHeadline: 'Review suggested (insufficient evidence); not flagged as clearly contradicting references',
    verdictUncertain: 'Insufficient evidence',
    verdictRefuted: 'Not supported by evidence',
    verdictNotEnoughEvidence: 'Insufficient evidence',
    verdictSupported: 'Supported by evidence',
    verdictCitationMismatch: 'Citation mismatch',
    issueRationaleLabel: 'Rationale',
    issueEvidenceLabel: 'Source evidence',
    issueEvidenceHintLabel: 'Evidence hint',
    issueContextSnippetLabel: 'Surrounding context (detection anchor)',
    evidenceVerifiedShort: 'Verified',
    evidenceSearchShort: 'External search',
    evidenceUnverifiedShort: 'Unverified',
    evidenceDirectMatch: 'Direct evidence',
    evidenceCrossLanguageMatch: 'Cross-language match',
    evidenceContextOnly: 'Related summary',
    evidenceSecondarySearch: 'Alternate source',
    crossLanguageTraceNotice: '{count} evidence item(s) traced via bilingual term alignment',
    p4UncertainEvidenceLoopNotice: 'Uncertain-item tool loop: processed {processed}, verdict updated {updated}',
    p5SpecialistPolishNotice: 'Specialist polish enhanced fixes for {count} refuted item(s)',
    evidenceStrengthStrong: 'Strong trace',
    evidenceStrengthModerate: 'Moderate trace',
    evidenceStrengthWeak: 'Weak trace',
    evidenceStrengthNone: 'No trace',
    confidenceLabel: 'Confidence',
    refCoverageNotice: 'Reference coverage: covered {covered}/{expected}, {ok} verified. Citation findings need manual review when coverage is incomplete.',
    hallucinationPruningNotice: 'Some detection subtasks were skipped by policy: {detail}. Related categories may be under-checked.',
    historyIssuesFound: 'Issues found',
    historyUncertainFound: 'Needs review',
    historyNoHallucinationFound: 'No obvious issues',
    noVerifiableRefs: 'No verifiable references found (PMID/DOI/NCT etc.)',
    issueTypeCitation: 'Citation Hallucination',
    issueTypeData: 'Data Hallucination',
    issueTypeFact: 'Fact Hallucination',
    issueTypeOvergeneralization: 'Overgeneralization',
    issueTypeAttribution: 'Attribution Hallucination',
    issueTypeOther: 'Other',
    locateInReport: 'Locate',
    locateInReportTip: 'Locate and select in report',
    locateReference: 'Locate reference',
    locateReferenceSuccess: 'Located matching content in report',
    locateReferenceInPanel: 'Located in reference verification list',
    locateReferenceMissing: 'No linked reference to locate',
    locateReferenceNotFound: 'Reference entry not found in report',
    locateReferenceExternal: 'Opened linked reference in new tab',
    secondaryReflectionUpdated: 'Re-reviewed',
    claimEvidenceAuditTitle: 'Claim search audit',
    locateSuccess: 'Located. Check the selection in the editor.',
    openInNewWindow: 'Open in new window',
    expandLocation: 'Expand',
    collapseLocation: 'Collapse',
    issueLocation: 'Source Location',
    relatedRef: 'Related Ref',
    correctThisIssue: 'Correct',
    selectParagraphFirst: 'Could not locate this passage in the report. Please select the paragraph containing this issue first, then use "Batch Correct"',
    // Auto-load related
    loadingMd: 'Loading report...',
    loadingMdTip: 'Please wait, fetching Markdown report from server',
    preloadingMdTip: 'Background preloading, almost done...',
    loadFailed: 'Load failed',
    retryLoad: 'Retry Load',
    createNew: 'Create New Report',
    // Replace related
    replaceManually: 'Auto-replace failed, please replace manually',
    contentCopied: 'New content copied to clipboard',
    noRegeneratedContent: 'No rewritten content to apply',
    originalTextLost: 'Original selected text lost, cannot complete replacement',
    documentContentError: 'Document content error, cannot complete replacement',
    replaceFailedCopied: 'Auto-replace failed, rewritten content copied to clipboard, please paste manually',
    manualReplaceHint: '💡 Hint: Find the original content in the editor, delete it and paste the new content',
    replaceProcessError: 'Error occurred during replacement',
    autoRestoredContent: 'Content automatically restored to pre-replacement state',
    replaceSuccess: '✅ Replacement successful',
    applySuccess: 'Fix applied automatically',
    replaceExactSuccess: '✅ Exact replacement successful',
    replaceAnchorSuccess: '✅ Anchor-based replacement successful',
    replaceAiSuccess: '✅ AI smart replacement successful',
    referencesOrganized: ', references organized ({count} items)',
    canUndoIn1Min: ', can undo within 1 minute',
    // Rewrite intent options
    intent: 'Intent',
    style: 'Style',
    intentAuto: 'Smart Detection',
    intentAutoDesc: 'AI automatically determines rewrite intent',
    intentOptimizeDetail: 'Only optimize expression without changing content scope',
    intentEnhanceDetail: 'Keep original content, add data and background',
    intentReplaceDetail: 'Can change topic and discussion angle',
    intentOptimize: 'Optimize Expression',
    intentOptimizeDesc: 'Keep meaning, improve language and logic',
    intentEnhance: 'Add Content',
    intentEnhanceDesc: 'Add related information around the topic',
    intentReplace: 'Complete Rewrite',
    intentReplaceDesc: 'Replace selected part with new content',
    // Rewrite style options
    styleDetailedDesc: 'Add details and supporting arguments',
    styleDetailedExample: 'Add data, cases, background',
    styleConciseDesc: 'Streamline redundancy, keep core content',
    styleConciseExample: 'Remove embellishments, get to the point',
    styleProfessionalDesc: 'Use professional terminology',
    styleProfessionalExample: 'Formal wording, academic style',
    styleAccessible: 'More Accessible',
    styleAccessibleDesc: 'Easy to understand expression',
    styleAccessibleExample: 'Conversational, everyday language',
    styleCustomDesc: 'Rewrite as per your requirements',
    styleCustomExample: 'Completely customizable',
    // Rewrite thinking steps
    rewriteStep1: 'Parse Original',
    rewriteStep1Detail: 'Analyze original content structure',
    rewriteStep2: 'Understand Intent',
    rewriteStep2Detail: 'Apply "{style}" rewrite strategy',
    rewriteStep3: 'Smart Rewrite',
    rewriteStep3Detail: 'Call AI model to reorganize content',
    rewriteStep4: 'Format Optimization',
    rewriteStep4Detail: 'Maintain Markdown format output',
    preparingRewrite: 'Preparing rewrite...',
    parsingOriginal: 'Parsing original structure...',
    callingAiModel: 'Calling AI model for rewrite...',
    optimizingFormat: 'Optimizing output format...',
    extractContentFailed: 'Failed to extract rewritten content',
    rewriteInProgress: 'Rewriting...',
    // Apply replacement steps
    applyStep1: 'Precise Locate',
    applyStep1Detail: 'Locate selected content in document',
    applyStep2: 'Smart Replace',
    applyStep2Detail: 'Replace rewritten content to correct position',
    applyStep3: 'Reference Processing',
    applyStep3Detail: 'Merge, deduplicate, renumber',
    applyStep4: 'Format Optimization',
    applyStep4Detail: 'Fix headings, lists and other format issues',
    applyStepNoProcess: 'No processing needed',
    applyStepFrontendNoProcess: 'Frontend solution, no processing needed',
    frontendReplaceRefHint: 'Frontend replacement used. References were not auto-organized. If selected content has citations, please check reference format and numbering.',
    methodExactMatch: 'Exact match replacement',
    methodNormalizedMatch: 'Normalized match replacement',
    methodPositionMatch: 'Position replacement',
    methodAnchorMatch: 'Anchor match replacement',
    methodApiSuccess: 'Located using {method} method',
    methodApiFailedFallback: 'API failed, using frontend solution',
    methodApiErrorFallback: 'API error, using frontend solution',
    contentReplacedCorrectly: 'Content replaced to correct position',
    formatOptimized: 'Format optimized',
    // Diff preview
    diffPreviewTitle: 'Replacement Comparison Preview',
    willBeReplaced: 'Will be replaced',
    afterReplace: 'After replacement',
    rewriteContent: 'Rewritten Content',
    undoHint: 'Last replacement can be undone',
    // AI rewrite process
    aiRewriteProcess: 'AI Rewrite Process',
    editModeHint: 'Edit mode - modify rewritten content',
    editRegeneratedContent: 'Edit rewritten content...',
    rewriteLabel: 'Rewrite:',
    // TOC related
    tableOfContents: 'Table of Contents',
    expandToc: 'Expand',
    collapseToc: 'Collapse',
    noHeadings: 'No headings',
    noHeadingsTip: 'Use # ## ### to create headings',
    searchHeading: 'Search headings...',
    noSearchResult: 'No results found',
    // Export related
    exportWord: 'Export as Word',
    exportPdf: 'Export as PDF',
    exporting: 'Exporting...',
    preparingPdf: 'Preparing PDF, please select "Save as PDF" in the print dialog...',
    generatingPdf: 'Generating PDF file, please wait...',
    noContentToExport: 'No content to export, please load Markdown report first',
    exportFailed: 'Export failed',
    // TOC levels
    tocLevel1: 'H1',
    tocLevel2: 'H2',
    tocLevel3: 'H3',
    clickToHideLevel: 'Click to hide {level} headings',
    clickToShowLevel: 'Click to show {level} headings',
    // Rewrite dialog extras
    intentDescription: 'Intent Description:',
    intentAutoLabel: 'Smart Detection',
    intentAutoDetail: 'AI automatically analyzes your request',
    intentOptimizeLabel: 'Optimize Expression',
    intentOptimizeDetail2: 'Keep original meaning, improve expression only',
    intentEnhanceLabel: 'Supplement Content',
    intentEnhanceDetail2: 'Add related information and details',
    intentReplaceLabel: 'Complete Rewrite',
    intentReplaceDetail2: 'Can change topic and angle',
    selectOneStyle: 'Select a style',
    recommended: 'Recommended',
    previewModeView: 'Preview mode - view rendered effect',
    supportMarkdown: 'Supports Markdown, Ctrl+E to toggle mode, Ctrl+Enter to apply',
    originalLabel: 'Original:',
    processingIntelligently: 'Processing intelligently...',
    discardBtn: 'Discard',
    diffPreviewBtn: 'Diff Preview',
    regenerateBtn: 'Regenerate',
    applyChangeBtn: 'Apply Changes',
    appliedToReport: 'Successfully applied to report',
    autoCloseIn: 'Auto close in {seconds}s',
    closeNow: 'Close Now',
    exitFullscreen: 'Exit Fullscreen',
    fullscreenMode: 'Fullscreen Mode',
    originalContentLabel: 'Original Content',
    originalLength: 'Original Length:',
    newContentLength: 'New Content Length:',
    changeLabel: 'Change:',
    charUnit: 'chars',
    closeBtn: 'Close',
    confirmApply: 'Confirm Apply',
    undoBtn: 'Undo',
    ignoreBtn: 'Ignore',
    undoApply: 'Undo applied',
    refNotFound: 'Reference [{refId}] not found, the report may not have a reference list',
    refNotFoundScrollTip: 'Scrolled to end of document. Please add a reference list at the end of the report.',
    refNotFoundScrollToRefSection: 'Scrolled to references section. Please check if the reference number is correct.',
    currentChapter: 'Current chapter: {chapter}',
    fetchQuestionsFailed: 'Failed to fetch questions',
    selectTextToCopy: 'Please select text to copy first',
    reportFileNotExist: 'Report file does not exist, please generate the report first',
    networkFailed: 'Network connection failed, please check your network',
    contentEmpty: 'Content is empty',
    pageNumber: 'Page {current} / {total}',
    exportDate: 'Export Date: {date}',
    platformGenerated: 'This document was automatically generated by AI4S platform',
    mdToHtmlFailed: 'Markdown to HTML conversion failed',
    cannotFindPdfContainer: 'Cannot find PDF content container',
    unknownError: 'Unknown error',
    pdfInvalidFormat: 'PDF file format is invalid or corrupted',
    pdfViewerLoadFailed: 'PDF viewer load failed',
          newReport: 'New Report',
    startWriting: 'Start writing your report content...',
    renderError: 'Markdown rendering error',
    requestTimeout: 'Request timeout',
    modelCallFailed: 'Model call failed',
    locatedWith: 'Located using {method} method',
    apiReturnFailed: 'API returned failure',
    apiCallError: 'API call error',
    proxyError: 'Proxy API: {msg}',
    ossError: 'OSS API: {msg}',
    legacyError: 'Legacy API: {msg}',
    pdfViewerComponentFailed: 'Unable to load PDF viewer component',
    // NetworkStatus
    networkDisconnected: 'Network Disconnected',
    networkDisconnectedDesc: 'Your network connection has been lost. Some features may not work properly.',
    retryConnection: 'Retry Connection',
    backendUnavailable: 'Backend Service Unavailable',
    backendUnavailableDesc: 'Server response is abnormal. Some features may be affected. We are working to restore service.',
    // FileDisplay
    previewable: 'Previewable',
    previewBtnLabel: 'Preview',
    downloadBtnLabel: 'Download',
    deleteBtnLabel: 'Delete',
    noFiles: 'No files',
    fileTypeImage: 'Image',
    fileTypeDocument: 'Document',
    fileTypeVideo: 'Video',
    fileTypeAudio: 'Audio',
    fileTypeOther: 'Other',
    fileTypeUnknown: 'Unknown',
    openFileFailed: 'Failed to open file: {msg}',
    downloadFileFailed: 'Failed to download file: {msg}',
    confirmDeleteFile: 'Are you sure you want to delete file "{name}"?',
    confirmDeleteTitle: 'Confirm Delete',
    fileDeleted: 'File "{name}" has been deleted',
    deleteFileFailed: 'Failed to delete file: {msg}',
    // AuthStatusMonitor
    loginNow: 'Login Now',
    renewLogin: 'Renew Login',
    dismissTemporarily: 'Dismiss',
    loginExpiringSoon: 'Login will expire in {minutes} minutes',
    loginWillExpire: 'Login will expire in {minutes} minutes',
    loginExpired: 'Login Expired',
    expiringSoon: 'Expiring Soon',
    loginNormal: 'Login Normal',
    expired: 'Expired',
    hoursMinutes: '{hours}h {minutes}min',
    minutesUnit: '{minutes} minutes',
    reloginConfirmMsg: 'You will be redirected to the login page. Unsaved data on the current page may be lost.',
    confirmRelogin: 'Confirm Re-login',
    continueBtn: 'Continue',
    statusRefreshed: 'Status refreshed',
    tokenValid: 'Token Valid',
    tokenInvalid: 'Token Invalid',
    clearAuthConfirmMsg: 'Are you sure you want to clear all authentication data? This will log you out immediately.',
    confirmClear: 'Confirm Clear',
    authDataCleared: 'Authentication data cleared',
    // F1 citation traceability
    citationTraceTitle: 'Source Trace',
    citationRefLabel: 'Reference [{refId}]',
    citationPassagesLabel: 'Source passages:',
    citationSyntheticAlert: 'Original evidence unavailable. The following is a synthesised summary based on metadata and is for reference only.',
    citationDataType: {
      europepmc_article: 'Literature · EuropePMC',
      pmc_article: 'Literature · PMC',
      openalex_work: 'Literature · OpenAlex',
      biorxiv_article: 'Preprint · bioRxiv',
      arxiv_article: 'Preprint · arXiv',
      google_patent: 'Patent · Google Patents',
      drug_products: 'Drug Information',
      drug_registration: 'Drug Registration',
      clinical_trial: 'Clinical Trial',
      web_page: 'Web Page'
    },
    addToKnowledgeMap: 'Add to Knowledge Map',
    // P1-C progress route chip
    progressRouteRemote: 'Deep Research Mode',
    progressRouteLocal: 'Quick Generation Mode',
    progressRouteRemoteTooltip: 'This report is being generated by the deep research engine, with more comprehensive data collection and analysis (takes longer)',
    progressRouteLocalTooltip: 'This report is being generated by the quick generation engine (faster)'
  },
  outline: {
    editTemplate: 'Edit Outline Template',
    saveTemplate: 'Save Outline Template',
    templateName: 'Template Name',
    templateNamePlaceholder: 'Enter template name, e.g.: EGFR Target Analysis Outline',
    templateDesc: 'Template Description',
    templateDescPlaceholder: 'Briefly describe the purpose and features of this outline template',
    templateIcon: 'Template Icon',
    selectIcon: 'Select Icon',
    templateColor: 'Template Color',
    promptTemplate: 'Prompt Template',
    promptTemplatePlaceholder: 'Guide prompt when using template, appended after outline',
    promptTemplateHint: 'When using this template, the system will append this guide prompt after the outline to instruct AI to generate a new outline based on this format',
    tags: 'Tags',
    addTag: '+ Add Tag',
    outlineContent: 'Outline Content',
    outlinePreview: 'Outline Preview',
    addToFavorite: 'Add to Favorites',
    openShareAfterSave: 'Open share settings after save',
    publicShare: 'Public Share (other users can use)',
    saveChanges: 'Save Changes',
    nameRequired: 'Please enter template name',
    nameLengthLimit: 'Template name should be 2-100 characters',
    templateUpdated: 'Template updated',
    templateSaved: 'Outline template saved',
    saveFailed: 'Save failed, please retry',
    chapterDescription: 'Chapter Description',
    contentPlan: 'Content Generation Plan',
    confirmButton: 'Confirm Outline',
    confirmTip: 'Confirm the outline to open report generation confirmation',
    editOutline: 'Edit Outline',
    changePerspective: 'Change Perspective',
    saveAsTemplate: 'Save as Template',
    saveAsNewTemplate: 'Save as New Template',
    updateTemplate: 'Update Template',
    updateTemplateConfirm: 'Are you sure you want to update the current template?',
    updateOriginalTemplate: 'Update Applied Template',
    saveUpdate: 'Save Update',
    updateSuccess: 'Template updated',
    updateFailed: 'Failed to update template, please retry',
    updateNoTemplate: 'No template is applied in this session',
    saveTip: 'Save as template for reuse',
    tag: 'Outline',
    noOutlineContent: 'Outline content not found',
    noQuickOutlineContent: 'No quick research content available to save',
    saveDialog: {
      generalizedDescription: 'Generalized from "{target}" with placeholder {entity}',
      currentTask: 'current task',
      targetOutlineName: '{name} Analysis Outline',
      tagGeneric: 'Generic template',
      tagPlaceholder: 'Placeholder',
      noSaveableContent: 'No outline content to save',
      quickTemplateName: '{name} Quick Research Question Framework',
      quickTemplateNameDefault: 'Quick Research Question Framework'
    },
    cardEditor: {
      switchedBack: 'Switched back to the original outline'
    },
    templateEditor: {
      moduleSectionTitle: 'Report Module Configuration',
      moduleSectionHint: 'Edit module names and sub-items; add custom modules and sub-items',
      questionSectionTitle: 'Research Question Configuration',
      questionSectionHint: 'Edit question titles and expected aspects; add custom questions',
      addModule: 'Add Module',
      addSubItem: 'Add Sub-item',
      moduleTitlePlaceholder: 'e.g. Mechanism & Pathways',
      subItemPlaceholder: 'Describe research points and generation requirements for this module',
      questionTitlePlaceholder: 'e.g. Pipeline & Stages',
      questionDetailPlaceholder: 'Describe expected aspects, e.g. drug name, stage, company, indication',
      previewTitle: 'Report Structure Preview',
      previewEmpty: 'Preview will appear here after you add modules and sub-items',
      moduleFallback: 'Module',
      subItemFallback: 'Sub-item {index}',
      saveTemplate: 'Save Template',
      moduleRequired: 'Please configure at least one module or question',
      subItemRequired: 'Please add at least one sub-item for module {index}',
      dragSort: 'Drag to reorder',
      quickDefaultPrompt: 'Generate a research question list from the framework above and start quick research.',
      quickFrameworkTitle: 'Quick Research Question Framework',
      quickTopicLabel: 'Topic',
      quickMaxQuestions: 'Quick mode allows at most {max} questions',
      quickMinQuestions: 'Quick mode requires at least {min} questions',
      quickQuestionCountRange: 'Quick mode requires between {min} and {max} questions',
      defaults: {
        expert: [
          {
            title: 'Mechanism & Pathways',
            children: ['Describe target-related signaling pathways, key biological nodes, and upstream/downstream regulation with core literature support.']
          },
          {
            title: 'Clinical Evidence Review',
            children: ['Retrieve and summarize clinical studies, trial readouts, efficacy/safety data, and evidence strength.']
          },
          {
            title: 'Differentiation Strategy',
            children: ['Summarize competitive positioning across indication, mechanism, combination therapy, and patent landscape.']
          }
        ],
        quick: [
          {
            title: 'Target Overview',
            children: ['Briefly introduce biological function, disease relevance, and drug development history.']
          },
          {
            title: 'Pipeline & Stages',
            children: ['List global clinical-stage drugs with name, highest stage, company, indication, and milestones.']
          },
          {
            title: 'Competitive Landscape',
            children: ['Summarize key competitors, differentiation strategies, and recent clinical/readout events.']
          }
        ]
      }
    },
    selectTemplate: 'Select Outline Template',
    selectTemplateBtn: 'Outline',
    searchTemplate: 'Search outline templates...',
    myTemplates: 'My Templates',
    recentUsed: 'Recent',
    favorites: 'Favorites',
    noTemplates: 'No outline templates available',
    emptyTip: 'Save confirmed outlines as templates for future use',
    outlineOnHomepageTip: 'Enter a question to create a task before using an outline template',
    usedTimes: 'Used {count} times',
    useTemplate: 'Use Template',
    favorite: 'Add to favorites',
    unfavorite: 'Remove from favorites',
    preview: 'Preview',
    newTargetOptional: 'Research Object (Optional)',
    enterNewTarget: 'Enter research object, e.g. KRAS, NSCLC, mRNA vaccine technology',
    newTargetTip: 'If you enter a research object, the system will generate a similar structured outline for it based on the selected template',
    researchObjectOptional: 'Research Object (Optional)',
    enterResearchObject: 'Enter research object, e.g. KRAS, NSCLC, mRNA vaccine technology',
    researchObjectTip: 'If you enter a research object, the system will generate a similar structured outline for it based on the selected template',
    researchObjectHomepageHint: 'No task created yet. Enter a research object (e.g. KRAS, NSCLC) manually, or placeholders cannot be replaced correctly.',
    researchObjectRequiredOnHomepage: 'Please enter a research object, or create a task by sending your first message before using an outline template.',
    useThis: 'Use This Template',
    templateCount: '{count} templates',
    allTemplates: 'All Templates',
    publicTemplates: 'Public Templates',
    // Sharing related
    sharedToMe: 'Shared with me',
    sharedToUsers: 'Shared with users',
    sharedToTenants: 'Shared with organization',
    public: 'Public',
    publicTemplate: 'Public template',
    sharedTemplate: 'Shared template',
    sharedBy: 'Shared by {name}',
    shareSettings: 'Share Settings',
    shareUpdated: 'Share settings updated',
    accessControl: 'Access Control',
    privateAccess: 'Private',
    privateDesc: 'Only visible and usable by yourself',
    shareToUsers: 'Share with Users',
    shareToUsersDesc: 'Select specific users to share with',
    shareToTenants: 'Share with Organization',
    shareToTenantsDesc: 'Share with all members of the organization',
    publicAccess: 'Public',
    publicDesc: 'All users can view and use',
    selectUsers: 'Select Users',
    selectTenants: 'Select Organizations',
    searchUsers: 'Search users...',
    searchUsersByNameOrEmail: 'Search by username or email',
    searchUsersHint: 'Enter a username or email to search',
    searchTenants: 'Search organizations...',
    permission: 'Permission',
    viewOnly: 'View Only',
    canUse: 'Can Use',
    canEdit: 'Can Edit',
    noResults: 'No results',
    pleaseSelectTargets: 'Please select share targets',
    saveFailed: 'Save failed',
    loadFailed: 'Load failed',
    addedToFavorites: 'Added to favorites',
    removedFromFavorites: 'Removed from favorites',
    useFailed: 'Failed to use template',
    templateApply: {
      quickWithEntity: 'Please follow the quick research question framework below and research around "{entity}":\n\n{outline}\n\n{prompt}',
      quickWithCurrentTarget: 'Please follow the quick research question framework below and research the current subject "{target}":\n\n{outline}\n\n{prompt}',
      quickGeneric: 'Please follow the quick research question framework below:\n\n{outline}\n\n{prompt}',
      expertWithEntity: 'Please use the outline template below to generate a similar analysis outline for "{entity}":\n\n{outline}\n\n{prompt}',
      expertWithCurrentTarget: 'Please use the outline template below to generate a similar analysis outline for the current subject "{target}":\n\n{outline}\n\n{prompt}',
      expertGeneric: 'Please use the outline template below to generate an analysis outline:\n\n{outline}\n\n{prompt}'
    },
    manager: {
      title: 'Outline Template Management',
      subtitle: 'Manage expert-mode outline structures — share and reuse across tasks',
      newTemplate: 'New outline template',
      searchPlaceholder: 'Search name, description, or research object',
      gridView: 'Grid',
      listView: 'List',
      totalCount: '{count} template(s) total',
      emptyDesc: 'No outline templates yet. Save one after confirming an outline in expert mode.',
      shareSettings: 'Share settings',
      previewAction: 'Preview',
      usageCount: 'Used {count}×',
      genericPlaceholder: 'Generic placeholder',
      use: 'Use',
      editTemplateTitle: 'Edit Template',
      createTemplateTitle: 'New Template',
      outlineMarkdown: 'Outline content (Markdown)',
      placeholderHint: 'Placeholder: {entity} — research object (target, technology, indication, etc.)',
      outlinePlaceholder: 'Markdown supported; use [ENTITY] for the research object',
      useTemplateTitle: 'Use outline template',
      useTemplateIntro: 'Apply “{name}” to the current task. Optionally set a research object to replace {entity}.',
      researchObjectLabel: 'Research object (replaces {entity}, optional)',
      researchObjectPlaceholder: 'Leave empty to use the current task name, e.g. KRAS, NSCLC',
      useFallbackHint: 'If empty, the current task name “{name}” will be used',
      confirmUse: 'Confirm use',
      nameRequired: 'Please enter a template name',
      outlineRequired: 'Please enter outline content',
      created: 'Outline template created',
      updated: 'Outline template updated',
      deleteConfirm: 'Delete outline template “{name}”?',
      deleteConfirmTitle: 'Confirm delete',
      deleted: 'Deleted',
      deleteFailed: 'Delete failed',
      favoriteAdded: 'Added to favorites',
      favoriteRemoved: 'Removed from favorites',
      actionFailed: 'Operation failed',
      publicTemplate: 'Public template',
      sharedTemplate: 'Shared template',
      sharedBy: 'Shared by {name}',
      defaultTemplateName: 'General research outline',
      defaultTemplateDesc: 'Sample template using [ENTITY] placeholders for any research object'
    }
  },
  tooltips: {
    fileManagement: 'File Management',
    viewBoundFiles: 'View bound files',
    chooseFile: 'Choose File'
  },
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    refreshList: 'Refresh',
    preview: 'Preview',
    download: 'Download',
    remove: 'Remove',
    localUpload: 'Upload from local',
    uploadList: 'Upload list',
    linkUpload: 'Upload from URL',
    cloudSelect: 'Select from Cloud',
    kbSelect: 'Select from Knowledge Base',
    create: 'Create',
    update: 'Update',
    joinNow: 'Join Now'
  },
  dialog: {
    editKnowledgeBase: 'Edit Knowledge Base',
    createKnowledgeBase: 'Create Knowledge Base',
    nameLabel: 'Name',
    namePlaceholder: 'Please enter knowledge base name',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Please enter knowledge base description (optional)',
    confirmDelete: 'Confirm Delete',
    deleteMessage: 'Are you sure you want to delete knowledge base "{name}"? This action cannot be undone.',
    deleteFileMessage: 'This will permanently delete file "{name}" and cannot be undone. Continue?',
    delete: 'Delete',
    validation: {
      nameRequired: 'Please enter knowledge base name',
      nameLength: 'Name length should be between 1 to 50 characters',
      nameEmpty: 'Knowledge base name cannot be empty'
    }
  },
  upgrade: {
    title: 'Upgrade to Pro, unlock your exclusive knowledge base',
    subtitle: 'Add your exclusive content before generating reports for more targeted report content',
    uploadTooltip: 'Upgrade to Pro membership to upload files'
  },
  targetStatusTooltips: {
    pending: 'Before report generation',
    processing: 'Report is being generated',
    success: 'Report generated successfully',
    failed: 'Report generation failed',
    // Chinese status keys (matching status values in code)
    '待分析': 'Before report generation',
    '分析中': 'Report is being generated',
    '已完成': 'Report generated successfully',
    '失败': 'Report generation failed',
    '已取消': 'Cancelled',
    unknown: 'Unknown status'
  },
  filesExt: {
    noBoundFiles: 'No files bound to this task yet',
    noMatched: 'No matching files found',
    tryDifferentKeywords: 'Try searching with different keywords',
    columns: {
      id: 'ID',
      name: 'Filename',
      size: 'Size',
      uploadTime: 'Uploaded At'
    }
  },
  kb: {
    backToAnalysis: 'Back to Analysis',
    list: 'Knowledge Base List',
    title: 'Knowledge Base Management',
    subtitle: 'Create and manage your knowledge base documents',
    searchPlaceholder: 'Search knowledge base name or description...',
    files: 'files',
    empty: 'No knowledge base available',
    noDescription: 'No description',
    preview: 'Preview',
    open: 'Open',
    download: 'Download',
    remove: 'Remove',
    renameFile: 'Rename File',
    renameFilePrompt: 'New file name',
    noFiles: 'No files in this knowledge base',
    uploadFirst: 'Upload first file',
    upload: 'Upload File',
    uploadFormatSizeHint: 'Supports PDF, DOC, DOCX, TXT, MD, etc. Max {max}MB per file',
    uploadSupportedTypes: 'Supports {types}, etc.',
    uploadMaxFileSize: 'Max {max}MB per file',
    uploadPerKbLimit: 'Up to {max} files per KB',
    uploadTotalLimit: 'Up to {max} files in total',
    batchUploading: 'Uploading {count} files, please wait...',
    related: 'Related Tasks',
    noLinkedTargets: 'No linked tasks',
    searchFilePlaceholder: 'Search filename...',
    editKB: 'Edit Knowledge Base',
    createKB: 'Create Knowledge Base',
    folderListTitle: 'Topic Folders',
    newFolder: 'New Folder',
    noMatchedFolder: 'No matching folder',
    sourceAuto: 'Auto',
    fileCount: '{count} files',
    reportCount: '{count} reports',
    updatedAt: 'Updated {time}',
    selectedCount: '{count} selected',
    selectedSuffix: ' selected',
    batchMode: 'Batch Actions',
    batchDelete: 'Batch Delete',
    sortLabel: 'Sort',
    moveTo: 'Move To',
    removeFromFolder: 'Remove',
    selectFolderHint: 'Select a folder on the left to view its content',
    uploadTargetTip: 'Upload to folder: {name}',
    uploadDragHint: 'Drop files here, or',
    uploadClickHint: 'click to upload',
    moveTip: 'Move {count} file(s) from "{from}" to:',
    noTargetFolder: 'No target folder available, please create one first',
    sort: {
      recentUpdate: 'Recently Updated',
      createdAt: 'Created Time',
      name: 'Name',
      updatedDesc: 'Updated Time (new to old)',
      updatedAsc: 'Updated Time (old to new)',
      nameAsc: 'Name (A→Z)',
      nameDesc: 'Name (Z→A)'
    },
    col: {
      name: 'File Name',
      type: 'Type',
      size: 'Size',
      status: 'Index Status',
      updatedAt: 'Updated At'
    },
    form: {
      name: 'Name',
      description: 'Description',
      namePlaceholder: 'Enter knowledge base name',
      fileBaseNamePlaceholder: 'Enter file name',
      fileNamePlaceholder: 'Enter file name',
      descriptionPlaceholder: 'Enter knowledge base description (optional)'
    },
    validation: {
      nameRequired: 'Please enter knowledge base name',
      nameLength: 'Name length must be between 1 and 50 characters',
      nameNotEmpty: 'Knowledge base name cannot be empty',
      nameDuplicate: 'A folder with the same name already exists',
      fileNameRequired: 'Please enter file name',
      fileNameLength: 'File name cannot exceed 255 characters',
      fileNameNoPathSeparator: 'File name cannot contain path separators',
      fileNameExtensionUnchanged: 'Renaming cannot change file extension {ext}',
      fileTooLarge: 'File "{name}" exceeds the {max}MB per-file limit',
      currentKbFull: 'The current knowledge base can contain up to {max} files',
      totalFull: 'All knowledge bases can contain up to {max} files in total',
      folderQuotaExceeded: 'This folder can accept {remaining} more file(s), but {count} were selected',
      totalQuotaExceeded: 'You can upload {remaining} more file(s) in total, but {count} were selected'
    },
    messages: {
      updateSuccess: 'Knowledge base updated successfully',
      createSuccess: 'Knowledge base created successfully',
      deleteConfirmTitle: 'Confirm Delete',
      deleteConfirmMessage: 'Are you sure to delete knowledge base "{name}"? This action cannot be undone.',
      deleteSuccess: 'Knowledge base deleted',
      noPermission: 'No permission to access this content',
      fetchFailed: 'Failed to fetch content, please try again',
      uploadSuccess: 'File {name} uploaded successfully',
      uploadBatchSuccess: 'Upload finished: {ok} succeeded, {fail} failed',
      uploadAllFailed: 'All uploads failed, please try again',
      downloadStart: 'Download started',
      removeFileConfirmTitle: 'Confirm Delete',
      removeFileConfirmMessage: 'This will permanently delete the file "{name}" and cannot be undone. Continue?',
      removeBatchConfirmMessage: 'Remove {count} selected files from this folder?',
      removeBatchSuccess: 'Remove finished: {ok} succeeded, {fail} failed',
      fileDeleted: 'File deleted',
      moveSuccess: 'Move finished: {ok} succeeded, {fail} failed',
      moveAllFailed: 'All operations failed, please try again later',
      renameSuccess: 'File renamed successfully',
      batchDeleteFolderConfirm: 'Delete the selected {count} folders?',
      batchDeleteFolderSuccess: 'Deleted {ok} folders, {fail} failed',
      batchDeleteFolderFailed: 'Batch delete failed: {fail} folder(s)'
    },
    relative: {
      justNow: 'Just now',
      minutesAgo: '{count} minutes ago',
      hoursAgo: '{count} hours ago',
      daysAgo: '{count} days ago',
      weeksAgo: '{count} weeks ago',
      monthsAgo: '{count} months ago'
    },
    // File processing status
    fileStatus: {
      pending: 'Pending',
      uploading: 'Uploading',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed'
    },
    closeConfirm: {
      title: 'File Status Confirmation',
      message: 'To ensure the best results for [Report Generation] and [AI Q&A], please confirm:',
      point1: 'All required files show "Upload Successful" status.',
      point2: 'Failed uploads have been handled.',
      point3: 'You can check file status in the task panel.',
      button: 'Confirm'
    }
  },
  knowledgeMap: {
    v2: {
      searchPlaceholder: 'Search topic names...',
      pinnedTopics: 'Pinned Topics',
      allTopics: 'All Topics',
      noTopicsFound: 'No topics found',
      newTopic: 'New Topic',
      batchMode: 'Batch Actions',
      mindmapView: 'Mind Map View',
      outlineView: 'Outline View',
      knowledgePointsCount: '{count} knowledge points'
    }
  },
  ipSecurity: {
    batchDeleteConfirm: 'Are you sure you want to delete the selected {count} records?',
    batchDeleteSuccess: 'Batch delete completed: {count} items',
    batchDeleteFailed: 'Batch delete failed',
    selectRecordsToDelete: 'Please select records to delete'
  },
  // Notifications
  notifications: {
    title: 'Notification Center',
    subtitle: 'Manage all your notification messages',
    markAllAsRead: 'Mark All as Read',
    totalCount: 'Total Notifications',
    unreadCount: 'Unread Notifications',
    criticalCount: 'Critical Notifications',
    readStatus: 'Read Status',
    category: 'Category',
    notificationType: 'Notification Type',
    severity: 'Severity',
    allNotifications: 'All Notifications',
    unreadOnly: 'Unread Only',
    clearFilters: 'Clear Filters',
    unreadSuffix: ' unread',
    viewAll: 'View All',
    notificationList: 'Notification List',
    batchRead: 'Batch Read',
    batchDelete: 'Batch Delete',
    markAsRead: 'Mark as Read',
    viewDetails: 'View Details',
    goToDetail: 'Go to detail',
    notificationDetails: 'Notification Details',
    notificationContent: 'Notification Content',
    basicInfo: 'Basic Information',
    detailedInfo: 'Detailed Information',
    createdTime: 'Created Time',
    updatedTime: 'Updated Time',
    readStatus: 'Read Status',
    read: 'Read',
    unread: 'Unread',
    relatedObject: 'Related Object',
    target: 'Target',
    deleteNotification: 'Delete Notification',
    defaultType: 'Notification',
    downloadReport: 'Download Report',
    downloadOptions: {
      pdf: 'PDF Report',
      markdown: 'Markdown File',
      metadata: 'Metadata File',
      details: 'Detailed Data'
    },
    types: {
      info: 'Info',
      warning: 'Warning',
      error: 'Error',
      success: 'Success',
      purchase_xcoin_success: 'X-Coin Purchase Succeeded',
      purchase_xcoin_failed: 'X-Coin Purchase Failed',
      subscribe_membership_failed: 'Membership Subscription Failed',
      upgrade_membership_failed: 'Membership Upgrade Failed',
      xcoin_granted: 'X-Coin Granted',
      xcoin_granted_invitation: 'Invitation Reward Credited',
      xcoin_granted_profile_completion: 'Profile Completion Reward Credited',
      xcoin_granted_platform: 'Platform Grant Credited',
      xcoin_expired: 'X-Coin Expired',
      monthly_bill: 'Monthly Bill',
      overspend: 'Overspend Alert',
      balance_low: 'Low Balance',
      system: 'System Notification',
      security: 'Security Alert',
      report_success: 'Report Generated Successfully',
      report_failed: 'Report Generation Failed',
      subscribe_membership_success: 'Membership Subscribed Successfully',
      upgrade_membership_success: 'Membership Upgraded Successfully',
      membership_expired: 'Membership Expired',
      membership_expiring: 'Membership Expiring Soon',
      membership_cancelled: 'Membership Cancelled',
      xcoin_expiring: 'X-Coin Expiring Soon',
      xcoin_granted_membership: 'Membership X-Coin Granted',
      feedback_reply: 'Feedback Reply',
      knowledge_map_subscription: 'Knowledge Map Subscription Update',
      intelligence_subscription: 'Intelligence Subscription Update'
    },
    categories: {
      account_change: 'Account Changes',
      usage: 'Usage Notifications',
      system: 'System Notifications'
    },
    entities: {
      target: 'Target',
      user: 'User',
      system: 'System'
    },
    severities: {
      info: 'Info',
      warning: 'Warning',
      error: 'Error',
      critical: 'Critical'
    },
    messages: {
      markReadSuccess: 'Marked as read successfully',
      markReadFailed: 'Failed to mark as read',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      loadFailed: 'Failed to load notifications',
      noNotifications: 'No notifications',
      noMatchingNotifications: 'No matching notifications found',
      operationFailed: 'Operation failed',
      allSelectedRead: 'All selected notifications are already read',
      batchReadSuccess: 'Marked {count} notifications as read',
      batchReadFailed: 'Batch mark as read failed',
      markAllReadSuccess: 'All notifications marked as read',
      batchDeleteConfirm: 'Are you sure you want to delete the selected {count} notifications?',
      batchDeleteSuccess: 'Successfully deleted {count} notifications',
      batchDeleteFailed: 'Batch delete failed',
      deleteConfirm: 'Are you sure you want to delete this notification?',
      reportRejected: 'Report content review failed. Download is temporarily unavailable. Please contact the administrator.',
      reportRejectedBrief: 'Report content review failed. Download is unavailable. Please contact the administrator.',
      cannotGetTarget: 'Unable to get target information',
      preparingDownload: 'Preparing to download {type}...',
      downloadFailedMsg: 'Download failed: {msg}',
      downloadStartedType: '{type} download started',
      pdfOpenedInNewWindow: 'PDF opened in new window, please use browser save to download',
      noDownloadUrl: 'Download URL not available',
      downloadFailedRetry: 'Download failed, please try again later',
      serverError: 'Server error, please try again later',
      networkError: 'Network connection failed, please check your network',
      noDownloadPermission: 'No download permission, please log in again',
      downloadResearchReport: 'Download Research Report'
    },
    time: {
      justNow: 'Just now',
      minutesAgo: '{minutes} minutes ago',
      hoursAgo: '{hours} hours ago',
      daysAgo: '{days} days ago'
    },
    severityLevels: {
      info: 'Info',
      warning: 'Warning',
      error: 'Error',
      critical: 'Critical'
    },
    dateFormat: '{month}/{day}/{year} {hours}:{minutes}'
  },
  sources: {
    noData: 'No source data available',
    title: 'Data Sources ({count})',
    subtitle: 'Data sources collected during the analysis process',
    index: 'No.',
    sourceType: 'Source Type',
    source: 'Source',
    collectTime: 'Collection Time',
    timeUnknown: 'Time unknown',
    timeFormatError: 'Time format error',
    unknownDomain: 'Unknown domain',
    unknownSource: 'Unknown source',
    sourceIndex: 'Source {index}',
    dataSource: 'Data Source',
    types: {
      journal: 'Academic Journal',
      patent: 'Patent',
      cnAcademic: 'Chinese Academic',
      bioDB: 'Bio Database',
      drugDB: 'Drug Database',
      other: 'Other'
    }
  },
  progress: {
    started: 'Analysis started, estimated about 30–60 minutes...',
    generating: 'Analyzing...',
    generatingOutline: 'Generating report structure',
    outlineCompleted: 'Outline has been completed',
    writingReport: 'Writing report',
    writingBody: 'Writing body content',
    refiningBody: 'Refining body content',
    typesetting: 'Optimizing layout',
    writingDoneEnterOptimize: 'Writing completed, entering optimization phase',
    optimizingAndReview: 'Optimizing report and final review',
    savingReport: 'Saving the analysis report',
    reportSavedPreviewBelow: 'Report saved. Preview below',
    allDone: 'All analysis work completed successfully',
    failed: 'Report generation encountered issues, possibly due to network/service fluctuations',
    // Writing-mode (llm_agent) progress labels. Writing is its own product
    // surface and has no outline/integration phases — these labels match
    // the step_name vocabulary emitted by
    // backend/app/workflows/writing/llm_agent_executor.py.
    writing: {
      submitted: 'Writing task submitted',
      started: 'Remote agent accepted the task, writing started',
      inProgress: 'Writing in progress',
      draftingBody: 'Drafting body text…',
      generatedChars: 'Generated ~{count} characters',
      callingTool: 'Calling tool: {tool}',
      researching: 'Searching sources',
      reading: 'Reading materials',
      editing: 'Editing the document',
      saving: 'Saving the document',
      sectionProgress: 'Section {index}/{total}',
      draftDone: 'Writing finished, saving the report',
      allDone: 'Report is ready — preview below',
      hermesStarted: 'Report writing started',
      hermesResearching: 'Searching sources and drafting the document…',
      hermesFinalizing: 'Integrating evidence and finalizing the document…',
      hermesPersisting: 'Saving the report draft…',
      hermesDone: 'Report writing complete',
      hermesResuming: 'Resuming the report writing task…',
      groundedCitationsOk: 'Citations verified ({count} sources)',
      groundedCitationsRemediated: 'Citations verified after local fix ({count} sources)',
      groundedCitationsDegraded: 'Citation check incomplete ({count} issues), delivered with warnings'
    },
    v2: {
      dataCollection: 'Searching multiple data sources for relevant literature',
      knowledgeGraph: 'Building research knowledge graph',
      outlineGeneration: 'Generating report structure',
      contentGeneration: 'Writing report',
      abstractDone: 'Report abstract completed',
      conclusionDone: 'Report conclusion completed',
      referencesDone: 'References organized',
      contentDone: 'Report writing completed, starting integration',
      integration: 'Integrating and finalizing the report'
    },
    targetSurvey: {
      pipelineAria: 'Target survey generation progress',
      dataCollection: 'Collecting target survey evidence',
      dataStructuring: 'Structuring collected evidence',
      contentGeneration: 'Generating target survey report',
      qualityCheck: 'Running quality checks',
      integration: 'Integrating report',
      workflowStarted: 'Starting target research'
    }
  },
  // Quick Commands UI Text
  ui: {
    quickActions: 'Quick Commands',
    showQuickActions: 'Show Quick Commands',
    manageCommands: 'Manage Commands',
    collapse: 'Collapse',
    expand: 'Expand',
    directSend: 'Direct Send',
    editSend: 'Edit Send',
    smartSuggestions: 'Smart Suggestions',
    outlineTemplates: 'Outline Templates',
    recentUsed: 'Recent Used',
    selectOutlineTemplate: 'Select Outline Template',
    viewAllTemplates: 'View All Templates',
    templateCount: '{count} templates',
    noOutlineTemplates: 'No outline templates',
    selectTarget: 'Please select a target first',
    // Management Interface
    commandManager: 'Quick Command Manager',
    myCommands: 'My Commands',
    publicLibrary: 'Public Command Library',
    addToMyCommands: 'Add to My Commands',
    noPublicCommands: 'No public commands',
    currentCommands: 'Current Commands',
    totalCommands: 'Total',
    addCommand: 'Add Command',
    editCommand: 'Edit Command',
    deleteCommand: 'Delete Command',
    quickSettings: 'Quick Settings',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    edit: 'Edit',
    delete: 'Delete',
    refresh: 'Refresh',  // Add refresh translation
    // Form Labels
    label: 'Label',
    description: 'Description',
    text: 'Text',
    icon: 'Icon',
    color: 'Color',
    clear: 'Clear',
    priority: 'Priority',
    sortOrder: 'Sort order',
    public: 'Public',
    create: 'Create',
    behavior: 'Behavior',
    hotkey: 'Hotkey',
    visible: 'Visibility',
    order: 'Display Order',
    publicShare: 'Public Share',
    show: 'Show',
    hidden: 'Hidden',
    hide: 'Hide',
    emptyCommandText: 'No content',
      commandInfo: 'Command Info',
      status: 'Status',
      actions: 'Actions',
      
      // Command types and templates
      commandType: 'Command Type',
      availableTemplates: 'Available Templates',
      usageScenarios: 'Usage Scenarios',
      templateUsedSuccess: 'Template used successfully',
      templateUseFailed: 'Failed to use template',
      createCustomCommand: 'Create Custom Command',
      commandCreatedSuccess: 'Command created successfully',
      commandCreateFailed: 'Failed to create command',
      
      // Command type scenarios
      actionScenario1: 'Quickly confirm or deny AI suggestions and questions',
      actionScenario2: 'Execute common operation commands like continue, re-analyze, etc.',
      actionScenario3: 'Simplify repetitive interaction operations',
      outlineScenario1: 'Provide structured outline templates for target analysis',
      outlineScenario2: 'Ensure comprehensive and consistent analysis',
      outlineScenario3: 'Quickly generate standardized analysis frameworks',
      analysisScenario1: 'Apply professional analysis methods and techniques',
      analysisScenario2: 'Provide guidance templates for in-depth analysis',
      analysisScenario3: 'Standardize complex analysis processes',
      replyScenario1: 'Quickly reply to common questions and requests',
      replyScenario2: 'Maintain professional and consistent communication style',
      replyScenario3: 'Improve communication efficiency',
      terminologyScenario1: 'Quickly input professional terms and abbreviations',
      terminologyScenario2: 'Ensure accuracy of terminology usage',
      terminologyScenario3: 'Build a unified terminology database',
      
      // Command creation form
      commandName: 'Command Name',
      commandNamePlaceholder: 'Enter command name',
      commandNameRequired: 'Please enter command name',
      commandNameLength: 'Command name length should be between 2-50 characters',
      displayLabel: 'Display Label',
      labelRequired: 'Please enter display label',
      labelLength: 'Display label length should be between 1-20 characters',
      commandContent: 'Command Content',
      contentRequired: 'Please enter command content',
      contentLength: 'Command content length should be between 1-500 characters',
      descriptionPlaceholder: 'Enter command description (optional)',
      behaviorRequired: 'Please select behavior type',
      directSendHelp: 'Send content directly when clicked',
      editSendHelp: 'Fill content into input box when clicked, can be edited before sending',
      hotkeyHelp: 'Click the input box and press key combination to set hotkey',
      publicHelp: 'Public commands can be seen and used by other users',
      usageCount: 'Usage Count',
      
      // Content placeholders
      actionContentPlaceholder: 'e.g.: Confirm, Continue analysis, Re-evaluate',
      outlineContentPlaceholder: 'e.g.: Please analyze according to the following outline: 1. Basic info 2. Market analysis 3. Risk assessment',
      analysisContentPlaceholder: 'e.g.: Please use SWOT analysis to comprehensively evaluate this target',
      replyContentPlaceholder: 'e.g.: OK, I understand. Please wait, let me analyze this in detail',
      terminologyContentPlaceholder: 'e.g.: Small Molecule Drug',
      
      // Storage modes
      storageMode: 'Storage Mode',
      localStorage: 'Local Storage',
      serverStorage: 'Server Storage',
      hybridStorage: 'Hybrid Storage',
      syncEnabled: 'Sync Enabled',
      lastSyncTime: 'Last Sync Time',
      syncNow: 'Sync Now',
      syncSuccess: 'Sync successful',
      syncFailed: 'Sync failed',
    // Form Placeholders
    labelPlaceholder: 'e.g.: Confirm, Cancel',
    textPlaceholder: 'Actual text to send',
    iconPlaceholder: 'e.g.: ✓, ✕, +',
    hotkeyPlaceholder: 'e.g.: Ctrl+Enter',
    orderPlaceholder: 'Smaller numbers appear first',
    // Messages
    commandAdded: 'Command added successfully',
    commandUpdated: 'Command updated successfully',
    commandDeleted: 'Command deleted successfully',
    commandsSaved: 'Command configuration saved successfully',
    fillCommand: 'Filled "{label}", please continue with specific content',
    executeCommand: 'Executed command: {label}',
    selectTarget: 'Please select a target first',
    cannotDeletePreset: 'Preset commands cannot be deleted',
    confirmDelete: 'Are you sure you want to delete this command?'
  },
  // Report Rating Related
  rating: {
    // Toolbar basics
    satisfaction: 'Satisfaction',
    detailedRating: 'Detailed Rating',
    rated: 'Rated',
    reportSatisfactionRating: 'Report Satisfaction Rating',
    
    // Actions
    viewRating: 'View Rating',
    editRating: 'Edit Rating',
    deleteRating: 'Delete Rating',
    submitRating: 'Submit Rating',
    updateRating: 'Update Rating',
    cancel: 'Cancel',
    
    // Rating Items
    overallRating: 'Overall Rating',
    usefulnessScore: 'Usefulness',
    accuracyScore: 'Accuracy',
    completenessScore: 'Completeness',
    readabilityScore: 'Readability',
    
    // Form
    comment: 'Comment',
    commentPlaceholder: 'Please enter your feedback...',
    tags: 'Tags',
    anonymous: 'Anonymous Rating',
    
    // Status Messages
    submitSuccess: 'Rating submitted successfully',
    updateSuccess: 'Rating updated successfully',
    deleteSuccess: 'Rating deleted successfully',
    submitFailed: 'Failed to submit rating',
    updateFailed: 'Failed to update rating',
    deleteFailed: 'Failed to delete rating',
    loadFailed: 'Failed to load rating',
    quickRatingSuccess: 'Quick rating successful',
    quickRatingFailed: 'Quick rating failed',
    
    // Confirmation Dialogs
    deleteConfirmTitle: 'Confirm Delete',
    deleteConfirmMessage: 'Are you sure you want to delete this rating? This action cannot be undone.',
    
    // Existing Rating Display
    existingRating: 'Your Rating',
    createdAt: 'Rated at',
    anonymousUser: 'Anonymous User',
    scoreOutOf5: '{score}/5',
    
    // Validation Messages
    pleaseSelectRating: 'Please select a rating',
    ratingRequired: 'Rating is required'
  },
  // Personal Center Page
  personalCenter: {
    title: 'Personal Center',
    nav: {
      accountInfo: 'Account Information',
      rechargeCenter: 'Recharge Center',
      notifyCenter: 'Notification Center',
      feedback: 'Feedback'
    },
    tabs: {
      overview: 'Account Overview',
      recharge: 'Recharge Management',
      invite: 'Invitation Management'
    },
    transaction: {
      empty: 'No transaction records',
      accountChange: 'Account Change',
      changeTime: 'Change Time',
      changeType: 'Change Type',
      xcoinAmount: 'X-Coin Amount',
      accountBalance: 'Account Balance',
      type: {
        expense: 'Expense',
        income: 'Recharge',
        reward: 'Reward',
        refund: 'Refund'
      }
    },
    recharge: {
      empty: 'No recharge records',
      rechargeTime: 'Recharge Time',
      rechargeType: 'Recharge Type',
      paymentAmount: 'Payment Amount',
      validity: 'Validity',
      status: 'Recharge Status',
      permanent: 'Permanent',
      memberSuffix: 'Membership',
      xcoinRecharge: 'X-Coin Recharge',
      statusText: {
        completed: 'Completed',
        pending: 'Processing',
        failed: 'Failed'
      }
    },
    transactionTypes: {
      expense: 'Expense',
      income: 'Income',
      reward: 'Reward',
      refund: 'Refund'
    },
    invite: {
      myInviteCode: 'My Invitation Code',
      inviteDescription: 'Invite 1 friend to recharge successfully, you and your friend will get corresponding invitation rewards',
      copy: 'Copy',
      codeNotLoaded: 'Invitation code not loaded, please try again later',
      steps: {
        step1: 'Invite friends to register',
        step2: 'Generate email invitation',
        step3: 'Both get rewards'
      },
      stats: {
        invitedCount: 'Successfully invited',
        totalRewards: 'Total invitation rewards',
        people: 'people'
      },
      noCode: {
        title: 'Invite friends, share rewards',
        description: 'Share your invitation link. After a friend registers and completes their first research task, both of you receive X-Coin rewards',
        generateBtn: 'Generate my invitation code'
      },
      rules: {
        title: 'Invitation Rules',
        rule1: 'Copy your exclusive invitation link and share it. Your friend registers via the link and completes their first login in epiXora.',
        rule2: 'After your friend completes their first research task (quick brief or expert report), you and your friend each receive 1,000 X-Coin. Rewards are usually credited within 24 hours.',
        rule3: 'If a participant is suspected of fraud or maliciously obtaining activity rewards during the event period, the official reserves the right to disqualify them and revoke the rewards.',
        rule4: 'Each user can earn this reward for up to 5 new invitees per month.',
      },
      dashboard: {
        cumulativeReward: 'Total Rewards',
        viewDetails: 'View Details',
        successfulInvites: 'Successful Invites',
        pendingRewards: 'Pending Rewards',
        peopleSuffix: 'people'
      },
      method: {
        title: 'How to Invite',
        step1: 'Step 1',
        step2: 'Step 2',
        step3: 'Step 3',
        step1Desc: 'Copy your exclusive invitation link and share it with colleagues or research partners',
        step2Desc: 'Friends register via the link and complete their first login in epiXora',
        step3Desc: 'After the friend completes the first research task, rewards are automatically credited to both sides',
        copyLink: 'Copy Link'
      },
      rewardDetails: {
        title: 'Invitation Records',
        invitedUser: 'Invited User',
        registerTime: 'Registration Time',
        rewardType: 'Reward Type',
        rewardAmount: 'Reward Amount',
        status: 'Status',
        empty: 'No invitation records',
        loadFailed: 'Failed to load invitation records',
        types: {
          invite: 'Invite Reward',
          register: 'Registration Reward',
          recharge: 'Recharge Reward',
          generateReport: 'First Research Reward'
        },
        statusText: {
          pending: 'Pending',
          completed: 'Credited',
          failed: 'Failed',
          cancelled: 'Cancelled'
        }
      }
    },
    notify: {
      listTitle: 'Notifications',
      markAllRead: 'Mark all as read',
      loading: 'Loading notifications...',
      empty: 'No notifications',
      defaultTitle: 'Notification',
      groups: {
        today: 'Today',
        yesterday: 'Yesterday',
        earlier: 'Earlier'
      },
      time: {
        justNow: 'Just now',
        hoursAgo: '{hours}h ago'
      },
      categories: {
        all: 'All Notifications',
        account: 'Account Updates',
        system: 'System Notifications',
        reportFailed: 'Report Failed',
        reportSuccess: 'Report Succeeded',
        xcoinExpiring: 'X-Coin Expiring',
        xcoinGrantedInvitation: 'Invitation Reward Credited',
        xcoinGrantedRecharge: 'Recharge Credited',
        xcoinConsumed: 'X-Coin Consumed',
        membershipExpiring: 'Membership Expiring',
        membershipActivated: 'Membership Activated',
        other: 'Other Notifications'
      },
      messages: {
        loadFailed: 'Failed to load notifications, please try again later',
        markAllReadSuccess: 'All notifications have been marked as read',
        markAllReadFailed: 'Failed to mark notifications as read, please try again later'
      }
    },
    footer: {
      description: 'epiXora is an enterprise-level AI intelligent research and analysis platform for investment institutions, universities, research institutes and drug development enterprises. Relying on the multi-source retrieval and automated analysis capabilities driven by agents, epiXora integrates public literature, preprints, patents, global clinical trial databases, and user-owned files for calculation and analysis, automatically generating customizable Outlines, structured, and traceable target and R&D research reports. It aims to provide high-quality and reproducible knowledge output for scientific research decision-making, investment evaluation and pipeline planning.',
      helpTitle: 'Help & Support',
      userAgreement: 'User Agreement',
      privacyPolicy: 'Privacy Policy',
      productManual: 'Product Manual',
      intellectualProperty: 'Intellectual Property',
      contactTitle: 'Contact Us',
      copyright: '© 2025 XtalPi Technology Co., Ltd. All rights reserved.',
      icp: 'ICP License No. 12345678-1'
    },
    messages: {
      loadTransactionFailed: 'Failed to load transaction records, please try again later',
      loadRechargeFailed: 'Failed to load recharge records, please try again later',
      copySuccess: 'Invitation code copied to clipboard',
      copyFailed: 'Copy failed, please copy the invitation code manually',
      generateSuccess: 'Invitation code generated successfully!',
      generateFailed: 'Failed to generate invitation code'
    }
  },
  preference: {
    stats: {
      zeroMin: '0 min',
      activities: 'Activities'
    }
  },
  // Account Balance Cards Component
  accountBalance: {
    accountName: 'Account',
    phone: 'Phone',
    totalAssets: 'Total Assets',
    freeTier: 'Free',
    membershipBadge: {
      format: '{tier}-{period}',
      tier: {
        plus: 'Plus',
        pro: 'Pro',
        enterprise: 'Enterprise'
      },
      period: {
        monthly: 'Monthly Membership',
        yearly: 'Yearly Membership',
        default: ''
      }
    },
    membershipValidity: 'Membership Validity',
    daysRemaining: '{days} days (expires on {date})',
    temporaryXCoin: 'Temporary X-coin',
    permanentXCoin: 'Permanent X-coin',
    reportGeneration: 'Report Generation',
    times: 'times',
    reportCount: '{count}',  // 英文直接显示数字,不加times单位
    viewDetails: 'View Details',
    recharge: 'Recharge',
    generateDetails: 'Generation Details',
    // Upgrade Button Text
    upgradeButton: {
      upgradeMembership: 'Upgrade Membership',
      renewMembership: 'Renew Membership',
      renewOrUpgrade: 'Renew/Upgrade'
    },
    // Dialogs
    dialogs: {
      temporaryXCoinDetails: 'Temporary X-Coin Details',
      reportGenerationDetails: 'Report Generation Details'
    },
    // Table Columns
    table: {
      xcoinBalance: 'X-Coin Balance',
      initialAmount: 'Initial Amount',
      usedAmount: 'Used',
      source: 'Source',
      grantedTime: 'Granted Time',
      expiryTime: 'Expiry Time',
      status: 'Status',
      reportName: 'Report Name',
      generationTime: 'Generation Time',
      xcoinConsumed: 'X-Coin Consumed'
    },
    // Status
    status: {
      active: 'Active',
      expired: 'Expired'
    },
    // Loading and Error Messages
    messages: {
      loading: 'Loading...',
      noData: 'No data',
      loadXCoinFailed: 'Failed to load X-Coin balance',
      loadMembershipFailed: 'Failed to load membership status',
      loadDetailsFailed: 'Failed to load details',
      loadTaskStatsFailed: 'Failed to load task statistics',
      loadReportDetailsFailed: 'Failed to load report details'
    }
  },
  // X-Coin Business Types (for Account page)
  xcoin: {
    transactionTypeLabels: {
      batchResearch: 'Batch Task Consumption',
      quickBrief: 'Quick Brief Consumption',
      expertReport: 'Expert Report Consumption',
      writingReport: 'Writing Report Consumption',
      hallucinationDetection: 'Hallucination Detection Consumption',
      chat: 'Chat Consumption',
      reportInteractiveEdit: 'Report Interactive Edit Consumption',
      reportInteractiveEditTool: 'Interactive Edit Tool Consumption',
      rewardGrant: 'Reward Granted'
    },
    accountChangeLabels: {
      registerRewardGrant: 'User Registration Reward Granted',
      profileCompletionRewardGrant: 'Profile Completion Reward Granted'
    },
    businessTypes: {
      // Income types
      recharge: 'Recharge',
      member_grant: 'Membership Grant',
      member_monthly_grant: 'Monthly Grant',
      invite_reward: 'Invitation Reward',
      behavior_reward: 'Behavior Reward',
      refund: 'Refund',
      monthly_refresh: 'Monthly Refresh',
      system_init: 'System Initialization',
      // Expense types
      expire: 'Expired',
      target_chat: 'Chat Consumption',
      outline_generation: 'Report Consumption',
      target_report: 'Report Consumption',
      quick_qa: 'Quick Mode Q&A Consumption',
      quick_brief_generation: 'Quick Brief Generation Consumption',
      expert_qa: 'Expert Mode Q&A Consumption',
      expert_report_generation: 'Expert Report Generation Consumption',
      writing_qa: 'Writing Mode Q&A Consumption',
      writing_report_generation: 'Writing Report Generation Consumption',
      hallucination_detection: 'Hallucination Detection Consumption',
      report_interactive_edit: 'Report Interactive Edit Consumption',
      report_interactive_edit_tool: 'Interactive Edit Tool Consumption',
      target_wiki_classify: 'Wiki Classification Consumption',
      target_wiki_compile: 'Wiki Compilation Consumption',
      target_wiki_heal: 'Wiki Healing Consumption',
      target_wiki_query: 'Wiki Q&A/Check Consumption',
      target_wiki_extract: 'Knowledge Map Extraction Consumption',
      knowledge_subscription_extract: 'Subscription Extraction Consumption',
      consume: 'Consumption',
      target: 'Target Analysis',
      // Special types
      correction: 'Data Correction',
      data_fix: 'Data Fix',
      test_deduct: 'Test Deduction',
      // Legacy compatibility
      test_charge: 'Test Deduction',  // Compatibility for old value, mapped to test_deduct
      report_generation: 'Report Generation',
      knowledge_base_usage: 'Knowledge Base Usage',
      xcoin_expired: 'X-Coin Expired'
    },
    messages: {
      loadSummaryFailed: 'Failed to load balance summary',
      loadDetailsFailed: 'Failed to load balance details',
      loadTransactionsFailed: 'Failed to load transaction history'
    }
  },
  // Membership Center
  membership: {
    // Basic text
    title: 'Membership Center',
    currentMembership: 'Current Membership',
    membershipStatus: 'Membership Status',
    expiryTime: 'Expiry Time',
    subscriptionType: 'Subscription Type',
    autoRenewal: 'Auto Renewal',
    enabled: 'Enabled',
    disabled: 'Disabled',
    daysRemaining: '{days} days remaining',
    upgrade: 'Upgrade',
    renew: 'Renew',
    downgrade: 'Downgrade',
    purchase: 'Purchase',
    
    // Membership status
    status: {
      active: 'Active',
      expired: 'Expired',
      cancelled: 'Cancelled'
    },
    
    // Subscription types
    subscriptionTypes: {
      monthly: 'Monthly Subscription',
      yearly: 'Yearly Subscription'
    },
    
    // Tier related
    free: 'Free',
    plus: 'Plus',
    pro: 'Pro',
    tier: 'Membership Tier',
    currentTier: 'Current Tier',
    targetTier: 'Target Tier',
    maxTierReached: 'User already at highest tier',
    
    // Benefits usage
    benefitsUsage: {
      title: 'Benefits Usage',
      concurrentTasks: 'Concurrent Tasks',
      knowledgeBaseFiles: 'Knowledge Base Files (Total)',
      monthlyReports: 'Reports This Month',
      xcoinBalance: 'X-Coin Balance',
      unlimited: 'Unlimited',
      priority: '{level} Priority'
    },
    
    // Membership comparison
    comparison: {
      title: 'Membership Benefits Comparison',
      recommended: 'Recommended',
      currentTier: 'Current Tier',
      currentMember: 'Current Member',
      lowerTier: 'Lower Tier',
      upgradeMember: 'Upgrade Membership',
      purchaseMember: 'Purchase Membership',
      
      // Price related
      firstPurchaseDiscount: 'First Purchase Discount',
      originalPrice: 'Original Price',
      monthlySubscription: 'Monthly Subscription',
      yearlySubscription: 'Yearly Subscription',
      perMonth: '/month',
      perYear: '/year',
      
      // X-Coin grant
      monthlyXCoinGrant: 'Monthly Subscription: {amount} X-Coin per month',
      yearlyXCoinGrant: 'Yearly Subscription: {amount} X-Coin per month',
      validity: 'Validity',
      validityDays: '{days} days',
      permanent: 'Permanent',
      
      // Features
      features: {
        maxConcurrentTasks: 'Generate up to {count} reports simultaneously',
        maxReportsPerMonth: 'Up to {count} reports per month',
        unlimitedReports: 'Unlimited report generation',
        withWatermark: 'Reports with watermark',
        noWatermark: 'Reports without watermark',
        canDownload: 'Can download reports',
        cannotDownload: 'Cannot download reports',
        knowledgeBase: 'Knowledge base total {count} files',
        cannotUseKnowledgeBase: 'Cannot use knowledge base',
        filesPerTask: '{count} files per task',
        commercialUse: 'Commercial use allowed',
        personalUseOnly: 'Personal use only',
        hallucinationOn: 'Hallucination detection & output quality tools',
        hallucinationOff: 'No hallucination tools',
        intelligenceSubscriptionOn: 'Target intelligence subscription & manual polling',
        intelligenceSubscriptionOff: 'No intelligence subscription',
        intelligenceFeedOn: 'Target intelligence feed viewing',
        intelligenceFeedOff: 'No intelligence feed viewing',
        reportInteractiveEditOn: 'Online interactive report editing (agents/tools)',
        reportInteractiveEditOff: 'No interactive editing',
        selectionQaOn: 'Selection Q&A & quick prompts',
        selectionQaOff: 'No selection Q&A',
        selectionRegenerateOn: 'Selection rewrite & smart replace',
        selectionRegenerateOff: 'No selection rewrite',
        selectionAddToMapOn: 'Selection add to knowledge map',
        selectionAddToMapOff: 'No selection add-to-map',
        knowledgeMapLlmWikiOn: 'Knowledge map LLM Wiki & graph (organize, Q&A, lint, heal, wikilink topology)',
        knowledgeMapLlmWikiOff: 'No LLM Wiki or graph (mind map & outline unaffected)',
        websearchOn: 'Commercial search (Tavily)',
        websearchOff: 'No commercial search (SearXNG default)'
      },
      
      // Priority
      priority: {
        low: 'Low Priority',
        normal: 'Standard Priority',
        high: 'High Priority',
        vip: 'VIP Priority'
      }
    },
    
    // Subscription history
    history: {
      title: 'Subscription History',
      viewAll: 'View All',
      membershipTier: 'Membership Tier',
      subscriptionType: 'Subscription Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      actions: 'Actions',
      cancelSubscription: 'Cancel Subscription',
      
      // Status
      statusActive: 'Active',
      statusExpired: 'Expired',
      statusCancelled: 'Cancelled'
    },
    
    // Purchase dialog
    purchaseDialog: {
      upgradeTitle: 'Upgrade Membership',
      purchaseTitle: 'Purchase Membership',
      tierSummary: 'Membership Tier',
      subscriptionType: 'Subscription Type',
      monthlyOption: 'Monthly Subscription - ¥{price}',
      yearlyOption: 'Yearly Subscription - ¥{price}',
      firstPurchaseTip: '(First purchase discount, original price ¥{originalPrice})',
      paymentMethod: 'Payment Method',
      amountDue: 'Amount Due',
      monthlyGrant: 'Monthly Grant',
      cancel: 'Cancel',
      confirmUpgrade: 'Confirm Upgrade',
      payNow: 'Pay Now',
      
      // Upgrade price details
      upgradeDetails: {
        title: 'Membership Upgrade Price Details',
        calculating: 'Calculating upgrade price...',
        calculatingTip: 'Calculating optimal upgrade price for you, please wait...',
        originalPrice: 'Original Package Price:',
        remainingValue: 'Current Membership Remaining Value:',
        remainingDays: '({days} days remaining)',
        actualPayment: 'Actual Payment:',
        formula: 'Calculation Formula',
        
        // Important notice
        importantNotice: 'Important Notice',
        upgradeMethod: 'Upgrade Method: Immediate Upgrade (Remaining Value Deduction)',
        paymentAmount: 'Pay ¥{price}, immediately get {duration} {tier} membership',
        remainingWillExpire: 'Your current membership remaining {days} days will expire immediately',
        valueDeductedTip: 'Remaining value has been deducted from upgrade cost, this is how you get the discount',
        thirtyDays: '30 days',
        threeSixtyDays: '360 days',
        
        // Error status
        loadFailed: 'Failed to Load Upgrade Price',
        loadFailedMessage: 'Unable to get upgrade price information, please refresh or contact support'
      },
      
      // Normal purchase price
      priceSummary: {
        totalAmount: 'Amount Due:',
        monthlyGrant: 'Monthly Grant:'
      }
    },
    
    // Confirmations
    confirmations: {
      upgradeTitle: 'Confirm Upgrade',
      upgradeMessage: 'You have {days} days remaining in your current membership. After upgrading, the remaining days will expire immediately.\n\nUpgrade Cost: ¥{price}\nBenefits: {duration} {tier} membership\n\nConfirm upgrade?',
      confirmUpgrade: 'Confirm Upgrade',
      cancel: 'Cancel',
      
      cancelSubscriptionTitle: 'Confirm Cancel Subscription',
      cancelSubscriptionMessage: 'Are you sure you want to cancel the subscription?'
    },
    
    // Legacy fields for compatibility
    monthly: 'Monthly',
    yearly: 'Yearly',
    
    // Upgrade operations
    upgradeTitle: 'Upgrade Membership',
    upgradeUserMessage: 'Upgrade membership tier for user {username}',
    upgradeSuccess: 'Membership upgraded successfully',
    upgradeFailed: 'Upgrade failed',
    upgradeButton: 'Upgrade Now',
    upgradeWarning: 'Upgrade Notice',
    selectTierLabel: 'Select Tier:',
    durationDaysLabel: 'Validity (days):',
    
    // Downgrade operations
    downgradeTitle: 'Downgrade Membership',
    downgradeConfirm: 'Confirm downgrading user {username} to Free tier?',
    downgradeSuccess: 'Membership downgraded successfully',
    downgradeFailed: 'Downgrade failed',
    downgradeReason: 'Downgrade Reason',
    
    // Messages
    messages: {
      loadTiersFailed: 'Failed to load membership tiers',
      autoRenewEnabled: 'Auto renewal enabled',
      autoRenewDisabled: 'Auto renewal disabled',
      subscriptionCancelled: 'Subscription cancelled',
      cancelSubscriptionFailed: 'Failed to cancel subscription',
      renewalInDevelopment: 'Renewal feature in development',
      upgradePriceLoadFailed: 'Failed to load upgrade price',
      calculateUpgradePriceFailed: 'Failed to calculate upgrade price: {error}',
      unknownError: 'Unknown error',
      getUpgradeOptionsFailed: 'Failed to get upgrade options'
    },
    // Renew operations
    renewTitle: 'Renew Membership',
    renewSuccess: 'Membership renewed successfully',
    renewFailed: 'Renewal failed',
    
    // Benefits
    benefits: 'Membership Benefits',
    upgradeBenefitsTitle: 'Upgrade to enjoy more benefits:',
    plusBenefits: 'Plus: Up to 13,000 X-Coin monthly',
    plusBenefitsDetail: 'Plus: 13,000 X-Coin monthly + Basic features',
    proBenefits: 'Pro: Up to 55,000 X-Coin monthly + Knowledge Base',
    proBenefitsDetail: 'Pro: 55,000 X-Coin monthly + Knowledge Base + Priority Support',
    premiumBenefits: 'Higher priority and exclusive services',
    
    // Price and duration
    price: 'Price',
    originalPrice: 'Original Price',
    actualPrice: 'Actual Price',
    discountAmount: 'Discount',
    remainingValue: 'Remaining Value',
    remainingDays: 'Remaining Days',
    duration: 'Validity',
    startDate: 'Start Date',
    endDate: 'End Date',
    
    // XC related
    xcoinGrant: 'X-Coin Grant',
    xcoinSchedule: 'Grant Schedule',
    immediateGrant: 'Immediate Grant',
    monthlyGrant: 'Monthly Grant',
    firstGrant: 'First Grant',
    nextGrantDate: 'Next Grant Date',
    grantCount: 'Grants Count',
    totalGrant: 'Total Granted',
    
    // Error messages
    noActiveMembership: 'You have no active membership',
    tierNotFound: 'Target membership tier not found',
    cannotDowngrade: 'Downgrade not supported',
    cannotUpgradeToMonthly: 'Yearly members should not upgrade to monthly',
    useRenewInstead: 'Please use renewal to extend membership',
    upgradeSuggestion: 'Suggest waiting for {currentTier} to expire before purchasing {targetTier}',
    
    // Messages
    messages: {
      // Upgrade price related
      upgradePriceLoadFailed: 'Failed to load upgrade price, please try again later',
      upgradePriceDataInvalid: 'Invalid upgrade price data, please refresh and try again',
      upgradePriceCalculateFailed: 'Failed to calculate upgrade price: {error}',
      upgradePriceLoadFailedUseOriginal: 'Failed to load upgrade price, will use original package price',
      
      // Upgrade confirmation messages
      upgradeConfirmMessage: 'Current membership: {currentTier} {currentType} ({remainingDays} days remaining)\nUpgrade to: {targetTier} {targetType}\n\n💰 Price Details:\n• Original Price: ¥{originalPrice}\n• Remaining Value Deduction: -¥{remainingValue}\n• Actual Payment: ¥{actualPrice}\n{formula}{xcoinNotice}\n\nConfirm upgrade?',
      upgradeConfirmTitle: 'Confirm Membership Upgrade',
      upgradePriceConfirmTitle: 'Membership Upgrade Price Confirmation',
      upgradeConfirmButton: 'Confirm Payment ¥{actualPrice}',
      
      // Tier related
      loadTiersFailed: 'Failed to load membership tiers',
      loadTiersFailedWithError: 'Failed to load membership tiers: {error}',
      
      // Subscription related
      autoRenewEnabled: 'Auto-renewal enabled',
      autoRenewDisabled: 'Auto-renewal disabled',
      cancelSubscriptionConfirm: 'After canceling subscription, membership benefits will expire after the end date. Are you sure?',
      cancelSubscriptionTitle: 'Confirm Cancellation',
      subscriptionCancelled: 'Subscription cancelled',
      cancelSubscriptionFailed: 'Failed to cancel subscription',
      
      // v7.0 New - Upgrade errors and confirmations
      renewalInDevelopment: 'Renewal feature in development',
      getUpgradeOptionsFailed: 'Failed to get upgrade options',
      calculateUpgradePriceFailed: 'Failed to calculate upgrade price: {error}',
      unknownError: 'Unknown error'
    },
    
    // v7.0 New - Upgrade error dialog
    upgrade: {
      errorDialog: {
        defaultTitle: 'Notice',
        remainingDays: '{days} days remaining',
        suggestions: 'Suggestions:'
      },
      
      // Error codes
      errors: {
        DOWNGRADE_NOT_ALLOWED: {
          title: 'Downgrade Not Allowed',
          message: 'You are currently a {currentTier} member and cannot downgrade to {targetTier}',
          suggestions: [
            'Consider purchasing {targetTier} after your {currentTier} membership expires',
            'Or continue enjoying higher benefits with your current membership'
          ],
          actions: {
            dismiss: 'Got it',
            viewBenefits: 'View Benefits'
          }
        },
        
        YEARLY_TO_MONTHLY_CROSS_TIER_NOT_ALLOWED: {
          title: 'Upgrade to {targetTier} - We recommend {targetTier} Yearly for full benefits!',
          message: 'Your {currentTier} yearly membership has {days} days remaining',
          suggestions: [
            '{targetTier} Yearly advantages:',
            '• {xcoin} XC per month',
            '• Fixed price ¥{price} (based on {days} remaining days)',
            '• Immediate access to {targetTier} features'
          ],
          actions: {
            upgradeYearly: 'Upgrade to {targetTier} Yearly',
            dismiss: 'Not now'
          }
        },
        
        YEARLY_TO_MONTHLY_SAME_TIER_NOT_ALLOWED: {
          title: 'Yearly membership is more cost-effective, downgrade not recommended!',
          message: 'Your {currentTier} yearly membership has {days} days remaining',
          suggestions: [
            'Continue enjoying yearly benefits',
            'Or upgrade to Pro Yearly for more benefits'
          ],
          actions: {
            dismiss: 'Got it',
            upgradeProYearly: 'Upgrade to Pro Yearly'
          }
        },
        
        PRO_YEARLY_TO_MONTHLY_NOT_ALLOWED: {
          title: 'Pro Yearly Renewal Notice',
          message: 'Your Pro yearly membership has {days} days remaining',
          suggestions: [
            'Please renew after your Pro yearly membership expires',
            'Or choose Pro Yearly plan for longer benefits'
          ],
          actions: {
            renewProYearly: 'Renew Pro Yearly',
            dismiss: 'Got it'
          }
        },
        
        SAME_TIER_SAME_TYPE: {
          title: 'Notice',
          message: 'Please use the renewal function to extend membership',
          suggestions: ['The renewal function can directly extend your membership validity'],
          actions: {
            renew: 'Go to Renewal',
            dismiss: 'Cancel'
          }
        }
      },
      
      // Plus Monthly → Pro Monthly confirmation
      crossTierConfirm: {
        title: 'Upgrade to Pro Monthly (v7.4)',
        upgradeInfo: 'Upgrade Information',
        upgradeFee: 'Upgrade Fee:',
        membershipDuration: 'Membership Duration:',
        xcoinNote: 'XC Grant:',
        totalXcoin: 'Total XC After Upgrade:',
        
        // v7.4: Value deduction logic
        feeCalculationV74: '(Remaining {days} days value deduction)',
        durationFixed: 'Fixed 30 days Pro Monthly',
        durationLoss: '(Original {days} days forfeited)',
        xcoinDiffOnly: 'Only grant difference {diff} XC',
        totalXcoinValue: '52,000 XC (Same as direct purchase)',
        
        // v7.4: New formula
        formulaV74: 'Upgrade Fee = Pro Monthly Price - Plus Remaining Value',
        formulaExampleV74: 'Example: ¥{proPrice} - (¥{plusPrice} / 30 × {days}) = ¥{proPrice} - ¥{remainingValue} = ¥{result}',
        
        importantNotice: 'Important Notice',
        notices: [
          '✅ Immediately switch to Pro privileges, enjoy stronger AI capabilities',
          '✅ Your existing Plus Monthly XC (12,000) is retained',
          '✅ Only grant difference XC (40,000) to prevent duplication',
          '✅ Total XC after upgrade is 52,000 (Same as direct purchase)',
          '⚠️ Original Plus Monthly remaining {days} days will be forfeited, fixed 30 days Pro Monthly granted'
        ],
        
        betterChoice: '💡 Better Choice',
        betterChoiceContent: 'For longer duration and complete Pro benefits, we recommend <strong>Pro Yearly</strong> (Fixed price ¥{price}):',
        betterChoiceReasons: [
          'Monthly grant 55,000 XC (3,000 more than monthly)',
          'Yearly subscription is more cost-effective, only ¥{avgPrice} per month on average',
          'Immediately get 360 days membership duration, no duration loss'
        ],
        
        actions: {
          cancel: 'Cancel',
          chooseProYearly: 'Choose Pro Yearly',
          confirmUpgrade: 'Confirm Upgrade to Pro Monthly'
        }
      }
    },
    
    // v6.0 specific
    v6: {
      // Core features
      fixedPrice: 'Fixed Price',
      accurateCalc: 'Accurate Daily Calculation',
      noImmediateXC: 'No Immediate XC',
      fromOriginalDate: 'From Original Expiry Date',
      grantTimes: '{times} grants total',
      savedAmount: 'Save ¥{amount}',
      keepEndDate: 'Keep Original Expiry Date',
      
      // Plus monthly to Plus yearly
      plusMonthlyToYearly: {
        title: 'Upgrade to Plus Yearly',
        subtitle: 'v6.0 Optimized - Anti-abuse',
        fixedPriceDesc: '• Fixed Price: ¥907.5 (¥990 × 330 days / 360 days)',
        startDateDesc: '• Membership Start: From your original expiry date {date}',
        durationDesc: '• Duration: 330 days (Keep remaining {days} days + 330 days)',
        xcoinDesc: '• XC Grant: Starting from {date}, 13,000 XC monthly, 11 times total',
        warning: '⚠️ Note: XC will not be granted immediately after upgrade, will be granted monthly from original expiry date',
        tip: '💡 Tip: This design prevents abuse and ensures fairness'
      },
      
      // Plus yearly to Pro yearly
      plusYearlyToProYearly: {
        title: 'Upgrade to Pro Yearly',
        subtitle: 'v6.0 Fair Pricing - Accurate Daily Calculation',
        calcMethodDesc: '• Calculation: (¥3990 - ¥990) × {days} remaining days / 360 days',
        priceDesc: '• Upgrade Price: ¥{price} (Daily accurate, fairer)',
        keepDateDesc: '• Expiry Date: Keep original expiry date {endDate}',
        xcoinDesc: '• XC Grant: Keep original grant schedule, change to 55,000 XC monthly',
        fairness: '✅ Fair: Save ¥{saved} compared to original plan',
        tip: '💡 Tip: No rounding down, completely fair pricing'
      },
      
      // Plus monthly to Pro monthly
      plusMonthlyToProMonthly: {
        title: 'Upgrade to Pro Monthly',
        subtitle: 'Keep remaining days, no extra XC',
        priceDesc: '• Upgrade Price: ¥{price} (Calculated for {days} remaining days)',
        durationDesc: '• Duration: Keep {days} remaining days',
        rightsDesc: '• Rights Upgrade: Enjoy Pro features immediately',
        xcoinWarningTitle: '⚠️ XC Notice:',
        noExtraXC: '• No extra XC for this upgrade',
        keepPlusXC: '• Your Plus monthly XC ({amount}) can still be used',
        proXCLater: '• Pro monthly XC (52,000) will be granted upon membership renewal',
        suggestion: '💡 Suggestion: For complete Pro benefits, consider Pro yearly (Fixed ¥3657.5, 55,000 XC monthly)'
      },
      
      // Plus monthly to Pro yearly
      plusMonthlyToProYearly: {
        title: 'Upgrade to Pro Yearly',
        subtitle: 'v6.0 Optimized',
        fixedPriceDesc: '• Fixed Price: ¥3657.5 (¥3990 × 330 days / 360 days)',
        startDateDesc: '• Membership Start: From your original expiry date {date}',
        durationDesc: '• Duration: 330 days',
        xcoinDesc: '• XC Grant: Starting from {date}, 55,000 XC monthly, 11 times total',
        warning: '⚠️ Note: XC will not be granted immediately after upgrade, will be granted monthly from original expiry date'
      },
      
      // Pro monthly to Pro yearly
      proMonthlyToYearly: {
        title: 'Upgrade to Pro Yearly',
        subtitle: 'v6.0 Optimized',
        fixedPriceDesc: '• Fixed Price: ¥3657.5 (¥3990 × 330 days / 360 days)',
        startDateDesc: '• Membership Start: From your original expiry date {date}',
        durationDesc: '• Duration: 330 days',
        xcoinDesc: '• XC Grant: Starting from {date}, 55,000 XC monthly, 11 times total',
        warning: '⚠️ Note: XC will not be granted immediately after upgrade, will be granted monthly from original expiry date'
      },
      
      // General upgrade price display
      upgradePrice: {
        title: 'Membership Upgrade Price Details',
        originalPrice: 'Original Package Price',
        remainingValue: 'Current Membership Remaining Value',
        actualPrice: 'Actual Payment',
        remainingDays: '{days} days remaining',
        formula: 'Calculation Formula',
        upgradeNow: 'Confirm Upgrade',
        cancelUpgrade: 'Cancel',
        loading: 'Calculating price...',
        error: 'Failed to load upgrade price',
        errorMessage: 'Failed to get upgrade price information, please refresh or contact support'
      }
    }
  },
  // Payment Page
  payment: {
    // Page Title
    rechargeCenter: 'Recharge Center',
    // Tabs
    tabs: {
      membership: 'Membership',
      monthly: 'Monthly Subscription',
      yearly: 'Yearly Subscription',
      xcoin: 'X-Coin Recharge',
      payMonthly: 'Pay Monthly',
      payYearly: 'Pay Yearly',
      yearlyDiscount: 'Save More with Yearly'
    },
    // Membership Subscription
    membership: {
      firstPurchaseBadge: 'First Purchase Discount',
      monthlyTitle: '{tier} Monthly Membership',
      yearlyTitle: '{tier} Yearly Membership',
      monthlyGrant: '{amount} X-Coin monthly',
      defaultDescription: 'Enjoy exclusive membership benefits',
      validityDays: 'Valid for {days} days',
      selectBtn: 'Activate Now',
      selectedBtn: 'Selected',
      recommendedRibbon: 'Recommended',
      priceUnitMonth: '/ month',
      priceUnitYear: '/ year',
      monthlyGrantText: '{amount} X-Coin monthly',
      yearlyGrantText: '{amount} X-Coin monthly',
      grantValidityText: 'Bonus validity: {days} days',
      freeGiftText: '10,000 X-Coin bonus on registration',
      freeGiftSubText: 'Valid for 30 days',
      customPriceText: 'Custom Quote',
      customGiftText: 'Custom X-Coin quota by needs',
      customGiftSubText: 'Dedicated customer success support',
      currentPlanBtn: 'Current Plan',
      contactUsBtn: 'Contact Us',
      upgradeNowBtn: 'Upgrade Now',
      cardTitles: {
        free: 'Free',
        plus: 'Plus',
        pro: 'Pro',
        enterprise: 'Enterprise'
      },
      tierDisplayNames: {
        free: 'Free',
        plus: 'Plus',
        pro: 'Pro',
        enterprise: 'Enterprise',
        internal: 'Internal',
        academic: 'Academic'
      },
      featureMatrix: {
        proResearch: 'Professional Research',
        researchAndReport: 'Research & Report Generation',
        reportWatermark: 'Report Generation (with watermark)',
        reportGeneration: 'Report Generation',
        reportHallucination: 'Report Hallucination Check',
        reportRegenerate: 'Report Regeneration',
        reportEdit: 'Online Report Editing',
        reportDownload: 'Report Download',
        knowledgeBase: 'Knowledge Base',
        personalKnowledgeMap: 'Personalized Knowledge Map',
        priorityQueue: 'Priority Compute Queue',
        proAllBenefits: 'All Pro Benefits',
        teamCollaboration: 'Team Collaboration & Permissions',
        enterpriseCustomization: 'Enterprise Domain Customization',
        onPremise: 'On-premise Deployment',
        priorityService: 'Priority Access to Dedicated Services'
      },
      // Tier descriptions
      tierDescriptions: {
        free: 'Individual Students / Initial Experience',
        plus: 'Individual Researchers, Graduate Students',
        pro: 'Lab Directors, Startup Biotech Companies',
        enterprise: 'Medium to Large Pharma, CRO, Research Institutions',
        internal: 'Xtalpi Internal Employees Exclusive',
        academic: 'Academic Users from Universities/Research Institutions'
      }
    },
    // Payment Method
    paymentMethod: {
      title: 'Select Payment Method',
      paymentMethodSelected: 'Payment Method Selected',
      alipay: 'Alipay',
      wechat: 'WeChat Pay',
      qrCodeAlt: 'Payment QR Code',
      selectPaymentHint: 'Generate payment QR code after selecting payment method',
      refreshQRCode: 'Refresh QR Code',
      paymentRemaining: 'Payment time remaining: {time}',
      scanToPay: 'Please scan with {method} to pay'
    },
    // X-Coin Recharge
    xcoin: {
      selectPackageTitle: 'Select Package',
      hotBadge: 'Hot',
      recommendedBadge: 'Recommended',
      baseLabel: 'Base',
      bonusLabel: 'Bonus',
      permanentPeriod: 'Permanent',
      daysUnit: 'days',
      enterpriseTitle: 'Enterprise Customization',
      enterpriseSubtitle: 'Dedicated Account Manager · Custom Feature Development · 7x24 Technical Support',
      contactService: 'Contact Support',
      priceLabel: '¥{price}',
      amountLabel: '{amount} X-Coin',
      breakdown: '{base} Base + {bonus} Bonus',
      customPlaceholder: 'Or enter custom amount',
      customUnit: 'Yuan',
      selectAmountHint: 'View order details after selecting recharge amount',
      customRechargeDescription: 'Custom Recharge - {amount} Yuan',
      packageNames: {
        xcoin_50: 'Starter Package',
        xcoin_99: 'Value Package',
        xcoin_199: 'Popular Package',
        xcoin_399: 'Premium Package',
        xcoin_999: '999 Package',
        xcoin_999_1: '999 Package',
        xcoin_2999: '2999 Package',
        xcoin_2999_1: '2999 Package',
        xcoin_custom: 'Custom Recharge'
      },
      orderTypeLabel: 'Order Type:',
      amountDueLabel: 'Amount Due:',
      grantXCoinLabel: 'Bonus X-Coin:',
      cancelBtn: 'Cancel',
      payNowBtn: 'Pay Now',
      closeBtn: 'Close',
      businessTypes: {
        // Income types
        recharge: 'Recharge',
        member_grant: 'Membership Grant',
        member_monthly_grant: 'Monthly Grant',
        invite_reward: 'Invitation Reward',
        behavior_reward: 'Behavior Reward',
        refund: 'Refund',
        monthly_refresh: 'Monthly Refresh',
        system_init: 'System Initialization',
        // Expense types
        expire: 'Expired',
        target_chat: 'Chat Consumption',
        outline_generation: 'Report Consumption',
        target_report: 'Report Consumption',
        quick_qa: 'Quick Mode Q&A Consumption',
        quick_brief_generation: 'Quick Brief Generation Consumption',
        expert_qa: 'Expert Mode Q&A Consumption',
        expert_report_generation: 'Expert Report Generation Consumption',
        writing_qa: 'Writing Mode Q&A Consumption',
        writing_report_generation: 'Writing Report Generation Consumption',
        consume: 'Consumption',
        target: 'Target Analysis',
        // Special types
        correction: 'Data Correction',
        data_fix: 'Data Fix',
        test_deduct: 'Test Deduction',
        // Legacy compatibility
        test_charge: 'Test Deduction',  // Compatibility for old value, mapped to test_deduct
        report_generation: 'Report Generation',
        knowledge_base_usage: 'Knowledge Base Usage',
        xcoin_expired: 'X-Coin Expired'
      }
    },
    notice: {
      exchangeRule: '¥1 = 100 X-Coin',
      period: '.',
      membership: {
        title: 'Membership Subscription Notes:',
        prefix: 'Users pay for feature benefits. After successful subscription, corresponding X-Coin will be granted; granted X-Coin is valid for ',
        validity: '30 days',
        rulePrefix: '. Base exchange rule: '
      },
      xcoin: {
        title: 'X-Coin Recharge Notes:',
        prefix: 'Base exchange rule ',
        middle: '; recharged X-Coin is ',
        permanent: 'permanently valid',
        suffix: ', and can be used together with membership bonus quota. Tiered recharge includes extra bonus; custom amount follows base conversion ratio without bonus.'
      },
      // Payment result notification (success / failed) — replaces hardcoded strings
      paymentResult: {
        period: { monthly: 'Monthly', yearly: 'Yearly' },
        defaultDash: '--',
        success: {
          xcoin: 'You have successfully purchased {packageName}. {xcoin} X-Coin (permanent validity) has been credited. Current balance: {balance}.',
          xcoinFallbackPackage: 'Custom Recharge',
          subscribe: 'You have successfully subscribed to {period}-{tier}, valid from {startDate} to {endDate}. {xcoin} X-Coin from the membership package (valid for 30 days) has been credited. Current balance: {balance}.',
          renew: 'Membership renewal successful: your {period}-{tier} membership has been extended to {endDate}. {xcoin} X-Coin will be granted in the next billing cycle. Current balance: {balance}.',
          upgrade: 'You have successfully upgraded from {fromTier} to {toTier}. Membership is valid until {endDate}. Payment this time: ¥{paid}.',
          deferredGrant: 'You have successfully subscribed to {tier}. Membership period: {startDate} - {endDate}. The included {xcoin} X-Coin will be granted in the next billing cycle. Current balance: {balance} X-Coin.',
          deferredUpgradeGrant: 'You have successfully upgraded to {tier}. Membership period: {startDate} - {endDate}. The included {xcoin} X-Coin will be granted in the next billing cycle. Current balance: {balance} X-Coin.',
          crossTierUpgradeNoGrant: 'You have successfully upgraded to {tier}. Membership period: {startDate} - {endDate}. Current balance: {balance} X-Coin.'
        },
        failed: {
          template: 'Sorry, the payment for {product} was not successful. If you were charged, please check your account balance first or contact us on the Feedback page in Personal Center.',
          xcoinProduct: '{amount} {packageName}',
          xcoinPackageFallback: 'Custom Recharge Package',
          upgradeProduct: '{from} upgraded to {to}',
          subscribeProduct: '{period} {tier} Membership'
        }
      }
    },
    deductRules: {
      title: 'Chat / Generation Deduction Rules',
      rule1Title: 'Prioritize time-limited X-Coin',
      rule1Body: ': Consumption deducts from time-limited balance first, then permanent balance.',
      rule2Title: 'By expiry within same type',
      rule2Body: ': For time-limited X-Coin, deduct from the batch with the shortest remaining validity first.',
      rule3Title: 'Recharge balance first when same expiry',
      rule3Body: ': If expiry time is the same, deduct paid-recharge X-Coin first, then free/bonus X-Coin.',
      sourcesTitle: 'X-Coin source notes:',
      sourcesText: '1) New user registration bonus (valid 30 days); 2) Monthly/yearly membership bonus (valid 30 days); 3) Invitation rewards (permanent); 4) Paid recharge (permanent).'
    },
    // Membership Benefits Table
    benefits: {
      title: 'Membership Benefits',
      headers: {
        feature: 'Benefits',
        free: 'Free User',
        plus: 'Plus VIP',
        pro: 'Pro VIP',
        enterprise: 'Enterprise VIP'
      },
      features: {
        reportGeneration: 'Professional Report Generation',
        reportGenerationFree: '✓ (with watermark)',
        reportGenerationPaid: '✓ (no watermark)',
        reportGenerationEnterprise: '✓',
        concurrentTasks: 'Concurrent Tasks',
        concurrentTasksFree: '1',
        concurrentTasksPlus: '3',
        concurrentTasksPro: '5',
        concurrentTasksEnterprise: 'Based on customization',
        reportDownload: 'Report Download',
        priority: 'Generation Priority',
        priorityFree: 'Low Priority',
        priorityPlus: 'Standard Priority',
        priorityPro: 'High Priority',
        priorityEnterprise: 'Enterprise Dedicated Channel',
        modelAccess: 'Model Access',
        modelAccessFree: 'Basic Models',
        modelAccessPlus: 'Plus Exclusive Models',
        modelAccessPro: 'Pro Exclusive Models',
        modelAccessEnterprise: 'Enterprise Exclusive Models',
        knowledgeBase: 'Dedicated Knowledge Base',
        commercialAuth: 'Commercial Authorization'
      },
      checkMark: '✓',
      crossMark: '✕'
    },
    // Footer
    footer: {
      copyright: 'Copyright © 2025 XtalPi Inc. ICP License No. 17120953-4'
    },
    // Recharge Management Page
    rechargeManagement: {
      title: 'Recharge Management',
      pageDescription: 'Recharge X-Coin, enjoy more services, get invitation rewards on first recharge',
      backButton: 'Back',
      balanceCard: {
        title: 'Account Balance',
        rechargeNow: 'Recharge Now',
        currentBalance: 'Current Balance',
        totalRecharge: 'Total Recharge',
        rechargeCount: 'Recharge Count',
        firstRecharge: 'First Recharge',
        yuan: 'Yuan',
        times: 'times'
      },
      recordsCard: {
        title: 'Recharge Records',
        orderNo: 'Order No.',
        filterStatus: 'Filter Status',
        allRecords: 'All Records',
        paymentSuccess: 'Payment Success',
        pending: 'Pending',
        paymentFailed: 'Payment Failed',
        cancelled: 'Cancelled',
        searchBtn: 'Search',
        emptyText: 'No recharge records',
        rechargeAmount: 'Recharge Amount',
        xcoinAmount: 'X-Coin',
        paymentMethod: 'Payment Method',
        paymentStatus: 'Payment Status',
        isFirstRecharge: 'First Recharge',
        firstRechargeTag: 'First',
        transactionId: 'Transaction ID',
        createdAt: 'Created At',
        paymentTime: 'Payment Time',
        actions: 'Actions',
        cancelAction: 'Cancel',
        payAction: 'Pay',
        viewDetails: 'Details'
      },
      paymentMethods: {
        alipay: 'Alipay',
        wechat: 'WeChat Pay',
        manual: 'Manual Recharge'
      },
      paymentDialog: {
        title: 'Pay Order',
        orderInfo: 'Order Information',
        orderNo: 'Order No.',
        rechargeAmount: 'Recharge Amount',
        xcoinAmount: 'X-Coin Amount',
        paymentMethod: 'Payment Method',
        qrCodeTitle: 'Scan to Pay',
        scanToPay: 'Please scan with {method} to pay',
        countdown: 'Payment time remaining',
        cancelPayment: 'Cancel Payment',
        refreshStatus: 'Refresh Status'
      }
    },
    // Messages
    messages: {
      paymentSuccess: 'Payment successful, experience it now!',
      paymentSuccessRedirect: 'Payment successful! Redirecting to knowledge base...',
      paymentFailed: 'Payment failed',
      createOrderFailed: 'Failed to create order',
      createOrderFailedWithError: 'Failed to create order: {error}',
      loadTiersFailed: 'Failed to load membership tiers',
      loadPackagesFailed: 'Failed to load recharge packages',
      // Package related
      packageDataInvalid: 'Invalid package data format',
      packagePriceInvalid: 'Invalid package price information, please refresh and try again',
      // Payment related
      selectPaymentMethodFirst: 'Please select a payment method first',
      scanToPay: 'Please scan to pay',
      paymentInfoLoadFailed: 'Failed to get payment information, please try again',
      loadRechargeRecordsFailed: 'Failed to load recharge records',
      paymentSuccessMessage: 'Payment successful!',
      paymentFailed: 'Payment failed',
      checkPaymentStatusFailed: 'Failed to check payment status',
      paymentCancelled: 'Payment cancelled',
      cancelPaymentFailed: 'Failed to cancel payment',
      cancelRechargeConfirm: 'Are you sure you want to cancel this recharge order?',
      cancelRechargeTitle: 'Confirm Cancellation',
      rechargeCancelled: 'Recharge order cancelled',
      cancelRechargeFailed: 'Failed to cancel recharge',
      // Form validation warnings
      selectSubscriptionPeriod: 'Please select subscription period',
      selectRechargePackage: 'Please select recharge package',
      minRechargeAmount: 'Minimum recharge amount is ¥1',
      selectPaymentMethodWarning: 'Please select payment method',
      // Membership Selection Warnings
      duplicatePurchaseTitle: 'Duplicate Purchase Not Supported',
      duplicatePurchaseMessage: 'You have an active {tier} {type} membership{remaining}{expiry}.\n\nPlease wait until your current membership expires before purchasing the same tier again.',
      upgradeProYearlyTitle: 'Upgrade to Pro Yearly Membership',
      upgradeProYearlyMessage: 'You have Plus yearly membership{remaining}{expiry}.\n\nUpgrade to Pro Yearly for enhanced benefits!',
      upgradeProYearlyBtn: 'Upgrade to Pro Yearly Now',
      downgradeTitle: 'Membership Downgrade Not Supported',
      downgradeMessage: 'You currently have Pro {type} membership{remaining}{expiry}.\n\nTo protect your interests, downgrading to Plus membership is not supported. We recommend waiting for your Pro membership to expire before purchasing other membership types.',
      yearlyToMonthlyDowngradeTitle: 'Yearly to Monthly Downgrade Not Supported',
      yearlyToMonthlyDowngradeMessage: 'You currently have {tier} yearly membership{remaining}{expiry}.\n\nTo protect your interests, downgrading from yearly to monthly membership is not supported. We recommend waiting for your membership to expire before purchasing a monthly membership.',
      confirmBtn: 'I Understand',
      continueBtn: 'Continue',
      cancelBtn: 'Maybe Later',
      remainingDays: ' ({days} days remaining)',
      expiryDate: ', expires on: {date}',
      monthlyType: 'monthly',
      yearlyType: 'yearly',
      monthlySubscription: 'Monthly Subscription',
      yearlySubscription: 'Yearly Subscription',
      // X-Coin Grant Notice
      xcoinGrantNoticeTitle: 'X-Coin Distribution Notice',
      xcoinGrantNoticeMessage: 'X-Coins from your upgraded/renewed membership will be distributed at the start of your next billing cycle. For immediate X-Coin access, please purchase an X-Coin package.',
      xcoinGrantNoticeConfirm: 'Confirm Purchase',
      xcoinGrantNoticeBuyXCoin: 'Buy X-Coin First'
    },
    // Upgrade Confirmation Dialog
    upgradeDialog: {
      title: 'Membership Upgrade',
      currentTier: 'Current Membership',
      remainingDays: 'Remaining Days',
      daysCount: '{days} days',
      upgradeTarget: 'Upgrade Target',
      priceDetails: 'Price Details',
      originalPrice: 'Original Price',
      remainingValueDiscount: 'Remaining Value Discount',
      remainingValueFormula: 'Remaining Value = (Remaining Days ÷ 365) × Original Price',
      durationExtension: 'Membership Extension',
      daysExtension: '+365 days',
      actualPayment: 'Actual Payment',
      actualPaymentFormula: 'Actual Payment = Original Price - Remaining Value Discount',
      upgradeReward: 'Upgrade Reward',
      congratulations: 'Congratulations on upgrading to {tier}!',
      cancel: 'Cancel',
      confirmPayment: 'Confirm Payment ¥{amount}',
      // Plus Monthly to Pro Monthly Special Notice
      plusMonthlyToProMonthly: {
        noExtraXCoin: 'No additional X-Coin grant for this upgrade',
        suggestion: 'Suggestion: For full Pro benefits, consider Pro Yearly'
      }
    },
    upgradeLimitDialog: {
      title: 'Upgrade Not Available',
      currentPrefix: 'Your current plan is ',
      currentSuffix: '.',
      rule: 'According to the membership rules, each subscription cycle supports only one upgrade. You have already upgraded in this cycle, so another membership upgrade is not available yet.',
      nextAvailableTime: 'Next available upgrade time:',
      xcoinPrefix: 'If your X-Coin balance is insufficient, you can ',
      xcoinRecharge: 'recharge X-Coin separately',
      xcoinMiddle: ' to continue using related features. Separately recharged X-Coin is ',
      xcoinPermanent: 'permanently valid and does not expire',
      xcoinSuffix: ', and can be used together with other account quota.',
      confirm: 'OK',
      unknownPlan: 'Current Membership',
      monthlyPlan: 'Monthly Membership',
      yearlyPlan: 'Yearly Membership'
    }
  },
  
  // Balance Warning Component
  balanceWarning: {
    insufficientTitle: 'Insufficient Balance',
    lowBalanceTitle: 'Low Balance Warning',
    balanceConfirmTitle: 'Balance Confirmation',
    currentBalanceLabel: 'Current Balance:',
    estimatedCostLabel: 'Estimated Cost:',
    afterBalanceLabel: 'Balance After Operation:',
    buttons: {
      rechargeNow: 'Recharge Now',
      recharge: 'Recharge',
      viewAccount: 'View Account',
      viewDetails: 'View Details',
      cancel: 'Cancel',
      confirmExecute: 'Confirm',
      insufficient: 'Insufficient'
    },
    messages: {
      rechargePending: 'Opening recharge center',
      lowBalanceWarning: 'Your balance usage has reached {percentage}%. We recommend recharging soon. Current balance: {balance} X-Coin'
    }
  },
  
  // PDF Preview Component
  pdfPreview: {
    loading: 'Loading PDF...',
    loadingWithProgress: 'Loading PDF... {progress}%',
    downloadSpeed: 'Download Speed: {speed}',
    loadFailed: 'PDF load failed: {error}',
    buttons: {
      retry: 'Retry',
      clearCache: 'Clear Cache',
      fullscreen: 'Fullscreen'
    },
    title: 'PDF Preview',
    messages: {
      cacheCleared: 'Cache cleared',
      loadTimeout: 'PDF download timeout, please check network connection',
      fileNotFound: 'PDF file not found',
      noPermission: 'No permission to access this PDF file',
      serverError: 'Server internal error, please try again later',
      networkError: 'Network connection error',
      maxRetryReached: 'Maximum retry count reached ({count})',
      invalidFormat: 'PDF file format is invalid or corrupted',
      viewerLoadFailed: 'PDF viewer failed to load',
      fetchFailed: 'Failed to fetch PDF preview',
      fetchingPdf: 'Fetching PDF file...',
      validatingPdf: 'Validating PDF file...',
      initializingViewer: 'Initializing PDF viewer...',
      emptyOrTooSmall: 'File content is empty or too small',
      invalidPdfFormat: 'File is not a valid PDF format'
    }
  },
  
  // Notification Center Component (Supplement)
  notificationCenter: {
    downloadReport: 'Download Report',
    markAsRead: 'Mark as Read',
    viewDetails: 'View Details',
    viewSubscriptionFeed: 'View subscription updates',
    subscriptionFeedMissingTopic: 'Related topic not found',
    subscriptionFeedMissingTarget: 'Related task not found',
    upgradeToDownload: 'Upgrade membership to download reports',
    noDownloadPermission: 'Current membership tier has no download permission',
    preparing: 'Preparing to download {type}...',
    downloadStarted: '{type} download started',
    pdfOpened: 'PDF opened in new window, please save the file in the new window',
    reportTypes: {
      pdf: 'PDF Report',
      markdown: 'Markdown File',
      metadata: 'Metadata File',
      details: 'Detailed Data'
    },
    messages: {
      markReadSuccess: 'Marked as read',
      markReadFailed: 'Failed to mark as read',
      markAllReadFailed: 'Failed to mark all as read',
      downloadFailed: 'Download failed, please try again later',
      serverError: 'Server error, please try again later',
      networkError: 'Network connection failed, please check your network',
      permissionError: 'No download permission, please log in again'
    }
  },
  
  // Permission
  permission: {
    noAccessManual: 'No access to user manual',
    noAccessKnowledgeBase: 'No access to knowledge base',
    knowledgeBaseComingSoon: 'This feature is for [Official Version] only, coming soon!'
  },
  
  aiDeliveryBlocked: {
    header: 'System safety review',
    title: 'Content did not pass the safety review',
    aiOutputBody: 'The model response contained expressions that violate the platform content-safety guidelines, so this reply has been blocked and will not be shown to you. You can click Regenerate to get a new reply, or adjust your question and try again;',
    userInputBody: 'Your input contained expressions that violate the platform content-safety guidelines, so the message was not sent to the model. Please revise and resubmit, avoiding illegal, abusive, or otherwise restricted content;',
    misjudgePrefix: 'If you believe this is a mistake, contact us via ',
    feedbackLink: 'Feedback',
    misjudgeMiddle: ' or by email ',
    misjudgeSuffix: ';',
    noImpact: 'The review only blocks this submission and does not affect your conversation history.',
    adminNote: 'Admins can review the original content and audit records in the admin console.',
    regenerate: 'Regenerate',
    reportAuditTitle: 'Report did not pass the safety review',
    reportAuditBody: 'The report generated for you contains expressions that violate the platform content-safety guidelines and has been escalated to manual review. Results are expected by {deadline};',
  },

  // Sensitive word detection
  sensitiveWord: {
      auditUnavailable: 'Content audit is busy. Please try again later.',
    blockTitle: 'Content review notice',
    blockMessage: 'Thank you for your submission. The content you entered cannot be used for report generation as it contains information that does not comply with our platform\'s guidelines. Please revise your input to avoid topics that are illegal, infringe upon others\' rights, or are considered highly sensitive. You can resubmit the task or contact our support ({email}).',
    detectedWordsLabel: 'Detected sensitive words',
    supportEmail: "epixora{'@'}xtalpi.com",
    intercepted: 'Intercepted',
    interceptedMessage: 'This message has been intercepted due to sensitive words, only admins can view original content'
  },
  // Quick command preset labels (used by utils/quickCommands.js)
  commands: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    add: 'Add',
    delete: 'Delete',
    modify: 'Modify',
    continue: 'Continue',
    useOutlineTemplate: 'Outline Template'
  },
  // Quick command preset send-text (used by utils/quickCommands.js)
  commandTexts: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    add: 'Add',
    delete: 'Delete',
    modify: 'Modify',
    continue: 'Continue'
  }
}
